(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode(".red-placeholder::placeholder{color:#c2c2c5!important}.project-line-item:hover .inverted{background-color:#fff!important}.project-line-item{border-radius:0!important;border-bottom:1px solid #f2f2f2!important}.project-line-item:first-of-type{border-top:1px solid #f2f2f2!important}")),document.head.appendChild(e)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
import { jsx as s, jsxs as w, Fragment as Gt } from "react/jsx-runtime";
import * as cr from "react";
import Or, { useState as te, useMemo as ie, createContext as De, useContext as Kt, Component as Ei, createElement as dr, useEffect as nt, forwardRef as Be, useCallback as Ri, StrictMode as ji } from "react";
import { ThemeProvider as Ti, Typography as F, Tooltip as Mi, useTheme as Oi, useMediaQuery as Pt, IconButton as be, Drawer as Nr, Snackbar as Ni, Alert as Di, TextField as Dr, InputAdornment as Br, FormLabel as Bi, Divider as Ar, Skeleton as Ee, Button as it, ListItem as Ur, ListItemButton as Lr, Chip as Ai, Menu as Fr, MenuItem as Ui, ListItemIcon as Li } from "@mui/material";
import { useTranslation as W, I18nextProvider as Fi } from "react-i18next";
import { gql as p, useQuery as wt, useApolloClient as Vi, InMemoryCache as Zi, ApolloLink as zi, split as Hi, from as qi, ApolloProvider as Wi } from "@apollo/client";
import Vr from "axios";
import Gi from "@mui/material/Avatar";
import { createInstance as Ki } from "i18next";
import Qi from "i18next-browser-languagedetector";
import Ji from "i18next-chained-backend";
import Yi from "i18next-resources-to-backend";
import { createTheme as Xi } from "@mui/material/styles";
import { GraphQLWsLink as ea } from "@apollo/client/link/subscriptions";
import { createClient as ta } from "graphql-ws";
import { setContext as lr } from "@apollo/client/link/context";
import { getMainDefinition as ra } from "@apollo/client/utilities";
import { ApolloLink as na } from "@apollo/client/link/core/ApolloLink.js";
import { createSignalIfSupported as ia } from "@apollo/client/link/http/createSignalIfSupported.js";
import { parseAndCheckHttpResponse as aa } from "@apollo/client/link/http/parseAndCheckHttpResponse.js";
import { rewriteURIForGET as oa } from "@apollo/client/link/http/rewriteURIForGET.js";
import { selectHttpOptionsAndBodyInternal as sa, defaultPrinter as ca, fallbackHttpConfig as da } from "@apollo/client/link/http/selectHttpOptionsAndBody.js";
import { selectURI as la } from "@apollo/client/link/http/selectURI.js";
import { serializeFetchParameter as ur } from "@apollo/client/link/http/serializeFetchParameter.js";
import { Observable as mr } from "@apollo/client/utilities/observables/Observable.js";
import { ApolloClient as ua } from "@apollo/client/core/ApolloClient";
const E = {
  common: {
    black: "#27272C",
    white: "#ffffff"
  },
  primary: {
    main: "#4D4E58",
    dark: "#1A1A1A"
  },
  secondary: {
    main: "#f5f5f7",
    contrastText: "#4D4E58"
  },
  text: {
    primary: "#4D4E58",
    secondary: "#707075",
    disabled: "#86868b",
    error: "#C94090",
    sustainability: "#44D62C"
  },
  grey: {
    300: "#e4e4e4",
    500: "#333333"
  },
  success: {
    main: "#7dc64e"
  },
  error: {
    main: "#ED6DB8"
  },
  warning: {
    main: "#F8B263"
  },
  background: {
    default: "#ffffff",
    paper: "#ffffff",
    surfaceLightGray: "#F5F5F7"
  },
  action: {
    hover: "rgba(0, 0, 0, 0.04)",
    selected: "#C2C2C5",
    disabled: "rgba(0, 0, 0, 0.4)"
  },
  brands: {
    gensler: "#e82011"
  }
}, ma = {
  styleOverrides: {
    root: {
      marginRight: 0
    },
    label: {
      marginLeft: "12px"
    }
  }
}, pa = {
  defaultProps: {
    disableRipple: !0,
    disableTouchRipple: !0,
    disableFocusRipple: !0,
    disableElevation: !0
  },
  styleOverrides: {
    root: {
      textTransform: "none",
      fontWeight: 400,
      whiteSpace: "nowrap",
      minWidth: "2em",
      borderRadius: "24px",
      ":focus": {
        outline: "none"
      },
      "&.underlined": {
        textDecoration: "underline",
        fontWeight: "normal"
      },
      "&.dense": {
        padding: 0
      },
      "&:disabled": {
        backgroundColor: E.grey[300],
        color: E.secondary.contrastText
      }
    },
    containedPrimary: {
      color: E.common.white,
      backgroundColor: E.primary.main,
      "&:hover": {
        backgroundColor: E.common.black
      }
    },
    textSecondary: {
      backgroundColor: "none",
      color: E.primary.main
    },
    containedSecondary: {
      color: E.primary.main,
      "&:hover": {
        backgroundColor: E.grey[300]
      }
    },
    textSizeSmall: {
      fontSize: "12px",
      lineHeight: "20px"
    },
    sizeSmall: {
      padding: "4px 12px",
      fontSize: "16px",
      lineHeight: "20px",
      fontWeight: 400
    },
    sizeMedium: {
      padding: "6px 16px",
      fontSize: "16px",
      lineHeight: "22px"
    },
    sizeLarge: {
      padding: "12px 24px",
      fontSize: "16px",
      lineHeight: "24px"
    },
    startIcon: {
      fontSize: "75% !important",
      marginRight: "0"
    },
    endIcon: {
      fontSize: "75% !important"
    }
  }
}, fa = {
  defaultProps: {
    disableRipple: !0
  },
  styleOverrides: {
    root: {
      ":hover": {
        backgroundColor: E.secondary.main
      },
      "&.Mui-selected": {
        backgroundColor: E.secondary.main,
        "&:hover": {
          backgroundColor: E.secondary.main
        }
      },
      ".MuiListItemIcon-root ": {
        minWidth: "40px"
      }
    }
  }
}, ha = {
  defaultProps: {
    disableRipple: !0
  },
  styleOverrides: {
    root: {
      padding: "6px",
      "&.MuiIconButton-colorSuccess": {
        backgroundColor: E.success.main,
        color: E.common.white
      },
      "&.MuiIconButton-colorError": {
        backgroundColor: E.error.main,
        color: E.common.white
      },
      sizeSmall: {
        fontSize: "10px"
      },
      sizeMedium: {
        fontSize: "14px"
      },
      sizeLarge: {
        fontSize: "16px"
      }
    },
    colorSecondary: {
      color: E.text.primary,
      backgroundColor: E.secondary.main,
      "&:focus, &:active, &:hover": {
        backgroundColor: E.grey[300]
      }
    },
    colorPrimary: {
      backgroundColor: E.primary.main,
      color: E.common.white,
      "&:hover": {
        backgroundColor: E.common.black
      },
      "&:focus": {
        backgroundColor: E.primary.dark
      }
    }
  }
}, ga = {
  defaultProps: {
    InputProps: {
      disableUnderline: !0
    }
  },
  styleOverrides: {
    root: {
      "input, textarea": {
        "&:focus": {
          boxShadow: "initial"
          // This fixes tailwind ring coloring
        }
      },
      "& .MuiInputBase-root": {
        borderRadius: "24px",
        "& .MuiInputBase-input": {
          height: "3rem",
          paddingTop: 0,
          paddingBottom: 0
        },
        "&.MuiInputBase-sizeSmall": {
          height: "2.25rem"
        }
      },
      "& .MuiFilledInput-root": {
        backgroundColor: E.secondary.main,
        "&:before, &:after": {
          borderBottom: "none"
        },
        "&:hover:before": {
          borderBottom: "none"
        }
      }
    }
  }
}, ya = {
  defaultProps: {
    disableRipple: !0,
    disableTouchRipple: !0
  },
  styleOverrides: {
    root: {
      "&.MuiChip-colorDefault": {
        backgroundColor: E.secondary.main
      },
      ":active": {
        boxShadow: "none"
      },
      "&.MuiChip-colorDefault:hover": {
        backgroundColor: E.grey[300],
        cursor: "pointer"
      },
      "&.MuiChip-colorPrimary:hover": {
        backgroundColor: E.primary.main,
        cursor: "pointer"
      },
      "&.MuiChip-outlinedSecondary": {
        color: E.text.primary,
        border: "none"
      }
    }
  }
}, va = {
  styleOverrides: {
    paper: {
      borderRadius: "20px",
      boxShadow: "0px 10px 40px 0px rgba(0, 0, 0, 0.08)"
    }
  },
  defaultProps: {
    fullWidth: !0
  }
}, ba = {
  defaultProps: {
    disableUnderline: !1
  },
  styleOverrides: {
    select: {
      ".MuiSelect-select.MuiInput-input": {
        height: "auto",
        paddingTop: "0.5rem",
        paddingBottom: "0.5rem"
      }
    }
  }
}, _a = {
  defaultProps: {
    disableUnderline: !0
  }
}, Ca = {
  styleOverrides: {
    root: {
      borderRadius: "8px"
    }
  }
}, xa = {
  styleOverrides: {
    root: {
      "& .MuiBadge-badge": {
        color: E.common.white
      }
    }
  }
}, wa = {
  styleOverrides: {
    root: {}
  }
}, Ia = {
  styleOverrides: {
    root: {
      display: "flex",
      alignItems: "center"
    }
  }
}, ka = {
  defaultProps: {
    // @ts-ignore-next-line
    disableRipple: !0
  },
  styleOverrides: {
    root: {
      "&.Mui-selected": {
        color: E.primary.main
      },
      "&.Mui-selected:hover": {
        backgroundColor: E.grey[300]
      }
    },
    ellipsis: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    sizeLarge: {
      fontSize: "16px",
      width: "48px",
      height: "48px",
      margin: 0,
      borderRadius: "24px"
    }
  }
}, Sa = {
  styleOverrides: {
    ul: {
      gap: "4px"
    }
  }
}, $a = {
  styleOverrides: {
    root: {
      all: "unset",
      padding: 0,
      position: "relative",
      cursor: "pointer",
      backgroundColor: E.grey[300],
      transition: "all 0.2s ease-in-out",
      width: "40px",
      height: "20px",
      borderRadius: "12px",
      "&:hover": {
        opacity: 0.8
      },
      "&:has(.MuiSwitch-switchBase.Mui-checked)": {
        backgroundColor: E.primary.main
      }
    },
    thumb: {
      backgroundColor: E.common.white,
      borderRadius: "50%",
      transform: "translateX(3px)",
      width: "14px",
      height: "14px",
      willChange: "transform",
      "&.Mui-disabled": {
        backgroundColor: E.background.surfaceLightGray
      }
    },
    switchBase: {
      padding: "0",
      top: "50%",
      transform: "translateY(-50%)",
      "&.Mui-checked": {
        transform: "translateX(20px) translateY(-50%)"
      }
    }
  }
}, Pa = Xi({
  breakpoints: {
    values: {
      xs: 480,
      sm: 640,
      md: 768,
      lg: 1024,
      xl: 1280
    }
  },
  typography: {
    fontFamily: "var(--font-main)",
    title1: { fontSize: "60px", lineHeight: "60px", fontWeight: 600 },
    title2: { fontSize: "36px", lineHeight: "48px", fontWeight: 600 },
    title3: { fontSize: "28px", lineHeight: "36px", fontWeight: 600 },
    title5: { fontSize: "13px", lineHeight: "20px", fontWeight: 600 },
    h1: { fontSize: "24px", lineHeight: "32px", fontWeight: 600 },
    h2: { fontSize: "20px", lineHeight: "32px", fontWeight: 600 },
    h3: { fontSize: "16px", lineHeight: "24px", fontWeight: 600 },
    body1: { fontSize: "16px", lineHeight: "24px", fontWeight: 400 },
    caption: { fontSize: "13px", lineHeight: "20px", fontWeight: 400 },
    caption2: { fontSize: "12px", lineHeight: "16px", fontWeight: 400 },
    caption2Caps: {
      fontSize: "12px",
      lineHeight: "18px",
      fontWeight: 600,
      textTransform: "uppercase"
    },
    caption3: { fontSize: "10px", lineHeight: "12px" }
  },
  palette: E,
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        * {
            font-family: 'Graphik';
        }
      `
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          border: "none"
        }
      }
    },
    MuiSwitch: $a,
    MuiButton: pa,
    MuiListItemButton: fa,
    MuiIconButton: ha,
    MuiTextField: ga,
    MuiSelect: ba,
    MuiChip: ya,
    MuiDialog: va,
    MuiInputBase: _a,
    MuiListItem: Ca,
    MuiBadge: xa,
    MuiMenuItem: wa,
    MuiTypography: Ia,
    MuiFormControlLabel: ma,
    MuiPaginationItem: ka,
    MuiPagination: Sa
  }
});
function Ea({
  children: t,
  theme: e = Pa
}) {
  return /* @__PURE__ */ s(Ti, { theme: e, children: t });
}
function Ra({ children: t, ...e }) {
  return /* @__PURE__ */ s(Gi, { ...e, children: /* @__PURE__ */ s(F, { variant: "caption", color: "primary", fontWeight: "bold", children: t }) });
}
function ja({
  children: t,
  ...e
}) {
  return /* @__PURE__ */ s(
    Mi,
    {
      componentsProps: {
        tooltip: {
          sx: {
            backgroundColor: "primary.main",
            borderRadius: "50px"
          }
        }
      },
      ...e,
      children: t
    }
  );
}
function Ta({
  fill: t = "currentColor",
  size: e = 32
}) {
  return /* @__PURE__ */ s(
    "svg",
    {
      width: e,
      height: e,
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ s("g", { id: "32/Arrow Circle", children: /* @__PURE__ */ s(
        "path",
        {
          id: "Vector",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.3784 7.91813C17.6811 7.58051 15.9218 7.75379 14.3229 8.41606C12.7241 9.07832 11.3575 10.1998 10.3961 11.6388C9.5019 12.977 8.99546 14.5338 8.92894 16.1373L10.6956 14.6167C11.0095 14.3465 11.4831 14.382 11.7533 14.6959C12.0235 15.0099 11.988 15.4834 11.6741 15.7536L8.61888 18.3832C8.30494 18.6534 7.8314 18.618 7.56119 18.304L4.93157 15.2488C4.66136 14.9349 4.69681 14.4613 5.01075 14.1911C5.32469 13.9209 5.79824 13.9564 6.06845 14.2703L7.4411 15.8651C7.55304 14.0611 8.14048 12.3146 9.14886 10.8054C10.2751 9.11981 11.876 7.80604 13.7489 7.03024C15.6218 6.25444 17.6828 6.05146 19.6711 6.44696C21.6594 6.84245 23.4858 7.81867 24.9192 9.25216C26.3527 10.6856 27.329 12.512 27.7245 14.5003C28.12 16.4886 27.917 18.5496 27.1412 20.4225C26.3654 22.2954 25.0516 23.8963 23.366 25.0226C21.6804 26.1488 19.6987 26.75 17.6714 26.75C17.2572 26.75 16.9214 26.4142 16.9214 26C16.9214 25.5858 17.2572 25.25 17.6714 25.25C19.402 25.25 21.0937 24.7368 22.5327 23.7754C23.9716 22.8139 25.0931 21.4473 25.7553 19.8485C26.4176 18.2496 26.5909 16.4903 26.2533 14.793C25.9157 13.0956 25.0823 11.5365 23.8586 10.3128C22.6349 9.08911 21.0758 8.25575 19.3784 7.91813Z",
          fill: t
        }
      ) })
    }
  );
}
function Ma() {
  return /* @__PURE__ */ s(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ s("g", { id: "24/Arrow Left", children: /* @__PURE__ */ s(
        "path",
        {
          id: "Vector",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.19194 7.05806C9.43602 7.30214 9.43602 7.69786 9.19194 7.94194L5.50888 11.625H19.8333C20.1785 11.625 20.4583 11.9048 20.4583 12.25C20.4583 12.5952 20.1785 12.875 19.8333 12.875H5.50888L9.19194 16.5581C9.43602 16.8021 9.43602 17.1979 9.19194 17.4419C8.94786 17.686 8.55214 17.686 8.30806 17.4419L3.55806 12.6919C3.31398 12.4479 3.31398 12.0521 3.55806 11.8081L8.30806 7.05806C8.55214 6.81398 8.94786 6.81398 9.19194 7.05806Z",
          fill: "currentColor"
        }
      ) })
    }
  );
}
function Oa() {
  return /* @__PURE__ */ s(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ w("g", { id: "24/Check", children: [
        /* @__PURE__ */ s("rect", { width: "32", height: "32", rx: "16", fill: "#4D4E58" }),
        /* @__PURE__ */ s(
          "path",
          {
            id: "Vector",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M22.4419 11.5581C22.686 11.8021 22.686 12.1979 22.4419 12.4419L14.4419 20.4419C14.1979 20.686 13.8021 20.686 13.5581 20.4419L9.55806 16.4419C9.31398 16.1979 9.31398 15.8021 9.55806 15.5581C9.80214 15.314 10.1979 15.314 10.4419 15.5581L14 19.1161L21.5581 11.5581C21.8021 11.314 22.1979 11.314 22.4419 11.5581Z",
            fill: "white"
          }
        )
      ] })
    }
  );
}
function Zr() {
  return /* @__PURE__ */ s(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ s("g", { id: "Icon", children: /* @__PURE__ */ s(
        "path",
        {
          id: "Vector",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.55806 9.55806C6.80214 9.31398 7.19786 9.31398 7.44194 9.55806L12 14.1161L16.5581 9.55806C16.8021 9.31398 17.1979 9.31398 17.4419 9.55806C17.686 9.80214 17.686 10.1979 17.4419 10.4419L12.4419 15.4419C12.1979 15.686 11.8021 15.686 11.5581 15.4419L6.55806 10.4419C6.31398 10.1979 6.31398 9.80214 6.55806 9.55806Z",
          fill: "currentcolor"
        }
      ) })
    }
  );
}
function Na() {
  return /* @__PURE__ */ s(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ s(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.53267 7.63325C7.77675 7.38918 8.17247 7.38918 8.41655 7.63325L11.9746 11.1913L15.5327 7.63325C15.7767 7.38918 16.1725 7.38918 16.4166 7.63325C16.6606 7.87733 16.6606 8.27306 16.4166 8.51714L12.8585 12.0752L16.4166 15.6333C16.6606 15.8773 16.6606 16.2731 16.4166 16.5171C16.1725 16.7612 15.7767 16.7612 15.5327 16.5171L11.9746 12.9591L8.41655 16.5171C8.17247 16.7612 7.77675 16.7612 7.53267 16.5171C7.28859 16.2731 7.28859 15.8773 7.53267 15.6333L11.0907 12.0752L7.53267 8.51714C7.28859 8.27306 7.28859 7.87733 7.53267 7.63325Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function Da() {
  return /* @__PURE__ */ s(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ s("g", { id: "24/Cross", children: /* @__PURE__ */ s(
        "path",
        {
          id: "Vector",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.53267 7.63325C7.77675 7.38918 8.17247 7.38918 8.41655 7.63325L11.9746 11.1913L15.5327 7.63325C15.7767 7.38918 16.1725 7.38918 16.4166 7.63325C16.6606 7.87733 16.6606 8.27306 16.4166 8.51714L12.8585 12.0752L16.4166 15.6333C16.6606 15.8773 16.6606 16.2731 16.4166 16.5171C16.1725 16.7612 15.7767 16.7612 15.5327 16.5171L11.9746 12.9591L8.41655 16.5171C8.17247 16.7612 7.77675 16.7612 7.53267 16.5171C7.28859 16.2731 7.28859 15.8773 7.53267 15.6333L11.0907 12.0752L7.53267 8.51714C7.28859 8.27306 7.28859 7.87733 7.53267 7.63325Z",
          fill: "currentColor"
        }
      ) })
    }
  );
}
function Ba({ size: t = 24 }) {
  return /* @__PURE__ */ s(
    "svg",
    {
      width: t,
      height: t,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ s("g", { children: /* @__PURE__ */ w("g", { id: "Group 34", children: [
        /* @__PURE__ */ s(
          "path",
          {
            id: "Rectangle 15",
            d: "M16.44 3.52002H18.6C19.9255 3.52002 21 4.59454 21 5.92002V19.12C21 20.4455 19.9255 21.52 18.6 21.52H5.4C4.07452 21.52 3 20.4455 3 19.12V5.92002C3 4.59454 4.07452 3.52002 5.4 3.52002H7.8",
            stroke: "currentColor",
            strokeWidth: "0.96",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ w("g", { id: "Group 38", children: [
          /* @__PURE__ */ s(
            "rect",
            {
              id: "Rectangle 36",
              x: "7.31995",
              y: "8.56",
              width: "3.84",
              height: "3.84",
              rx: "0.96",
              stroke: "currentColor",
              strokeWidth: "0.96",
              strokeLinejoin: "round"
            }
          ),
          /* @__PURE__ */ s(
            "rect",
            {
              id: "Rectangle 39",
              x: "13.08",
              y: "8.56003",
              width: "3.84",
              height: "3.84",
              rx: "0.96",
              stroke: "currentColor",
              strokeWidth: "0.96",
              strokeLinejoin: "round"
            }
          ),
          /* @__PURE__ */ s(
            "rect",
            {
              id: "Rectangle 38",
              x: "7.31995",
              y: "14.32",
              width: "3.84",
              height: "3.84",
              rx: "0.96",
              stroke: "currentColor",
              strokeWidth: "0.96",
              strokeLinejoin: "round"
            }
          ),
          /* @__PURE__ */ s(
            "rect",
            {
              id: "Rectangle 40",
              x: "13.08",
              y: "14.32",
              width: "3.84",
              height: "3.84",
              rx: "0.96",
              stroke: "currentColor",
              strokeWidth: "0.96",
              strokeLinejoin: "round"
            }
          )
        ] }),
        /* @__PURE__ */ s(
          "rect",
          {
            id: "Rectangle 37",
            x: "7.79995",
            y: "2.08001",
            width: "8.64",
            height: "3.84",
            rx: "1.44",
            stroke: "currentColor",
            strokeWidth: "0.96",
            strokeLinejoin: "round"
          }
        )
      ] }) })
    }
  );
}
function Aa() {
  return /* @__PURE__ */ s(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ s(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.375 6.16667C3.375 5.17716 4.17716 4.375 5.16667 4.375H9.83333C9.99909 4.375 10.1581 4.44085 10.2753 4.55806L12.4254 6.70823L17.9664 6.70601L17.9715 6.70575C17.981 6.7053 17.9888 6.70516 17.9935 6.7051L17.999 6.70506L18.0004 6.70506L18.0008 6.70506H18.0009H18.0009C19.6347 6.70506 20.9595 8.02956 20.9583 9.66385L20.3333 9.66339H20.9583V9.66385V16.6667C20.9583 18.3005 19.6338 19.625 18 19.625H6.33333C4.69949 19.625 3.375 18.3005 3.375 16.6667V6.16667ZM5.16667 5.625C4.86751 5.625 4.625 5.86751 4.625 6.16667V16.6667C4.625 17.6102 5.38985 18.375 6.33333 18.375H18C18.9435 18.375 19.7083 17.6102 19.7083 16.6667V9.66339V9.66294C19.709 8.72948 18.96 7.97063 18.0297 7.95529C18.0199 7.95576 18.0101 7.95599 18.0003 7.95599L12.1669 7.95833C12.0011 7.9584 11.842 7.89255 11.7247 7.77527L9.57445 5.625H5.16667ZM18.593 7.52839C18.5886 7.54153 18.5789 7.57036 18.5606 7.60738C18.5731 7.58207 18.5839 7.5557 18.593 7.52839ZM18.0233 7.9552C18.0073 7.9557 17.999 7.95506 18.0009 7.95506L18.0233 7.9552ZM9.20831 13.1667C9.20831 12.8215 9.48813 12.5417 9.83331 12.5417H11.5417V10.8333C11.5417 10.4881 11.8215 10.2083 12.1667 10.2083C12.5119 10.2083 12.7917 10.4881 12.7917 10.8333V12.5417H14.5C14.8452 12.5417 15.125 12.8215 15.125 13.1667C15.125 13.5119 14.8452 13.7917 14.5 13.7917H12.7917V15.5653C12.7917 15.9105 12.5119 16.1903 12.1667 16.1903C11.8215 16.1903 11.5417 15.9105 11.5417 15.5653V13.7917H9.83331C9.48813 13.7917 9.20831 13.5119 9.20831 13.1667Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function Ua() {
  return /* @__PURE__ */ w(
    "svg",
    {
      width: "85",
      height: "72",
      viewBox: "0 0 85 72",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ s("g", { clipPath: "url(#clip0_5043_60232)", children: /* @__PURE__ */ s(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1 8.2314C1 3.68533 4.7249 0 9.31981 0H31.7733C32.4911 0 33.1795 0.282113 33.687 0.784276L44.1206 11.107L70.9137 11.0964L70.9437 11.0948C70.9852 11.0929 71.0187 11.0923 71.0391 11.092L71.0632 11.0919L71.0692 11.0918L71.0708 11.0918C78.7655 11.0918 85.0056 17.2637 85 24.8789L82.2935 24.877H85V24.8789V58.2149C85 65.8282 78.7619 72 71.0668 72H14.9332C7.23809 72 1 65.8282 1 58.2149V8.2314ZM9.31981 5.35537C7.71436 5.35537 6.41289 6.64302 6.41289 8.2314V58.2149C6.41289 62.8705 10.2275 66.6446 14.9332 66.6446H71.0668C75.7724 66.6446 79.5871 62.8705 79.5871 58.2149V24.877V24.875C79.5905 20.2653 75.8491 16.5186 71.2045 16.4482C71.1592 16.4505 71.1136 16.4517 71.0679 16.4517L43.0011 16.4628C42.2829 16.4631 41.5941 16.181 41.0863 15.6785L30.6522 5.35537H9.31981ZM73.6347 14.6197C73.616 14.6753 73.5749 14.7965 73.4973 14.9523C73.55 14.8456 73.5961 14.7346 73.6347 14.6197ZM71.1698 16.4478C71.0993 16.45 71.0629 16.4472 71.0713 16.4472L71.1698 16.4478ZM29.0667 41.5538C29.0667 40.075 30.2784 38.8761 31.7732 38.8761H40.2937V30.4462C40.2937 28.9673 41.5054 27.7685 43.0001 27.7685C44.4948 27.7685 45.7065 28.9673 45.7065 30.4462V38.8761H54.2266C55.7214 38.8761 56.9331 40.075 56.9331 41.5538C56.9331 43.0327 55.7214 44.2315 54.2266 44.2315H45.7065V52.9721C45.7065 54.4509 44.4948 55.6497 43.0001 55.6497C41.5054 55.6497 40.2937 54.4509 40.2937 52.9721V44.2315H31.7732C30.2784 44.2315 29.0667 43.0327 29.0667 41.5538Z",
            fill: "currentColor"
          }
        ) }),
        /* @__PURE__ */ s("defs", { children: /* @__PURE__ */ s("clipPath", { id: "clip0_5043_60232", children: /* @__PURE__ */ s(
          "rect",
          {
            width: "84",
            height: "72",
            fill: "white",
            transform: "translate(0.5)"
          }
        ) }) })
      ]
    }
  );
}
function La() {
  return /* @__PURE__ */ w(
    "svg",
    {
      width: "85",
      height: "84",
      viewBox: "0 0 85 84",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ w("g", { clipPath: "url(#clip0_5233_163984)", children: [
          /* @__PURE__ */ s(
            "path",
            {
              d: "M38.5625 63H16.0733C10.3707 63 5.75 58.3734 5.75 52.6636V9.13424C5.75 6.98928 7.48707 5.25 9.62931 5.25H28.7715C29.7974 5.25 30.7845 5.66 31.5129 6.38938L39.875 14.7621H62.8749C68.5775 14.7621 73.1982 19.3886 73.1982 25.0985V39.375",
              stroke: "#4D4E58",
              strokeWidth: "5",
              strokeMiterlimit: "10",
              strokeLinecap: "square"
            }
          ),
          /* @__PURE__ */ s(
            "path",
            {
              d: "M58.25 76.125C69.848 76.125 79.25 66.723 79.25 55.125C79.25 43.527 69.848 34.125 58.25 34.125C46.652 34.125 37.25 43.527 37.25 55.125C37.25 66.723 46.652 76.125 58.25 76.125Z",
              stroke: "#4D4E58",
              strokeWidth: "5",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          ),
          /* @__PURE__ */ s(
            "path",
            {
              d: "M81.875 78.75L74 70.875",
              stroke: "#4D4E58",
              strokeWidth: "5",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          ),
          /* @__PURE__ */ s(
            "path",
            {
              d: "M53 60.375L63.5 49.875",
              stroke: "#4D4E58",
              strokeWidth: "5",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          ),
          /* @__PURE__ */ s(
            "path",
            {
              d: "M63.5 60.375L53 49.875",
              stroke: "#4D4E58",
              strokeWidth: "5",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          )
        ] }),
        /* @__PURE__ */ s("defs", { children: /* @__PURE__ */ s("clipPath", { id: "clip0_5233_163984", children: /* @__PURE__ */ s(
          "rect",
          {
            width: "84",
            height: "84",
            fill: "white",
            transform: "translate(0.5)"
          }
        ) }) })
      ]
    }
  );
}
function Fa() {
  return /* @__PURE__ */ s(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ s(
        "path",
        {
          d: "M16.0001 14.8223V21.8922M16.0001 10.1072V11.2856M26 16C26 21.5228 21.5228 26 16 26C10.4772 26 6 21.5228 6 16C6 10.4772 10.4772 6 16 6C21.5228 6 26 10.4772 26 16Z",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
}
function Va() {
  return /* @__PURE__ */ s(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ s(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 4.625C7.9269 4.625 4.625 7.9269 4.625 12C4.625 16.0731 7.9269 19.375 12 19.375C16.0731 19.375 19.375 16.0731 19.375 12C19.375 7.9269 16.0731 4.625 12 4.625ZM3.375 12C3.375 7.23654 7.23654 3.375 12 3.375C16.7635 3.375 20.625 7.23654 20.625 12C20.625 16.7635 16.7635 20.625 12 20.625C7.23654 20.625 3.375 16.7635 3.375 12ZM12.0001 6.6608C12.3453 6.6608 12.6251 6.94062 12.6251 7.2858V8.22845C12.6251 8.57363 12.3453 8.85345 12.0001 8.85345C11.6549 8.85345 11.3751 8.57363 11.3751 8.22845V7.2858C11.3751 6.94062 11.6549 6.6608 12.0001 6.6608ZM12.0001 10.4328C12.3453 10.4328 12.6251 10.7126 12.6251 11.0578V16.7138C12.6251 17.0589 12.3453 17.3388 12.0001 17.3388C11.6549 17.3388 11.3751 17.0589 11.3751 16.7138V11.0578C11.3751 10.7126 11.6549 10.4328 12.0001 10.4328Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function Za() {
  return /* @__PURE__ */ s(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ s(
        "path",
        {
          d: "M12.8193 1.06163C14.2349 -0.353782 16.5297 -0.353738 17.9453 1.06163C19.2249 2.34124 19.3481 4.33929 18.3145 5.75695H20.625C22.0747 5.75695 23.2498 6.93233 23.25 8.38195V10.1319C23.25 10.6152 22.8582 11.0069 22.375 11.0069H22.25V20.3819C22.25 21.8317 21.0747 23.0069 19.625 23.0069H3.625C2.17525 23.0069 1 21.8317 1 20.3819V11.0069H0.875C0.39175 11.0069 0 10.6152 0 10.1319V8.38195C0.000156155 6.93233 1.17535 5.75695 2.625 5.75695H4.93652C3.90264 4.33928 4.02511 2.34133 5.30469 1.06163C6.72032 -0.353858 9.01603 -0.353898 10.4316 1.06163C10.8349 1.46506 11.1062 2.08711 11.2998 2.69152C11.4305 3.09959 11.5365 3.54123 11.625 3.97863C11.7135 3.54127 11.8195 3.09956 11.9502 2.69152C12.1439 2.08701 12.416 1.46505 12.8193 1.06163ZM2.25 20.3819C2.25 21.1413 2.86561 21.7569 3.625 21.7569H9V11.0069H2.25V20.3819ZM10.25 21.7569H13V7.00695H10.25V21.7569ZM14.25 21.7569H19.625C20.3844 21.7569 21 21.1413 21 20.3819V11.0069H14.25V21.7569ZM2.625 7.00695C1.8657 7.00695 1.25016 7.62269 1.25 8.38195V9.75695H9V7.00695H2.625ZM14.25 9.75695H22V8.38195C21.9998 7.62269 21.3843 7.00695 20.625 7.00695H14.25V9.75695ZM9.54688 1.94542C8.6194 1.01826 7.11589 1.01816 6.18848 1.94542C5.2612 2.87283 5.26131 4.37634 6.18848 5.30382C6.33551 5.45084 6.61121 5.6063 7.00879 5.75695H10.6416C10.6083 5.48036 10.5689 5.18025 10.5186 4.87218C10.4175 4.25402 10.2836 3.61639 10.1094 3.07238C9.92811 2.50663 9.72918 2.12775 9.54688 1.94542ZM17.0615 1.94542C16.1341 1.01821 14.6306 1.01816 13.7031 1.94542C13.5208 2.12776 13.3219 2.5067 13.1406 3.07238C12.9664 3.61637 12.8324 4.25406 12.7314 4.87218C12.6811 5.18025 12.6417 5.48036 12.6084 5.75695H16.2422C16.6393 5.60641 16.9146 5.45072 17.0615 5.30382C17.9888 4.37632 17.9889 2.87287 17.0615 1.94542Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function za() {
  return /* @__PURE__ */ s(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ s("g", { id: "32/Box Arrow", children: /* @__PURE__ */ w("g", { id: "Vector", children: [
        /* @__PURE__ */ s(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.78186 4.9607C6.888 4.66138 7.17115 4.46136 7.48873 4.46136H24.7489C25.0665 4.46136 25.3496 4.66138 25.4558 4.9607L27.7067 11.3083C27.7881 11.5379 27.7529 11.7928 27.6124 11.9917C27.4718 12.1907 27.2434 12.309 26.9998 12.309H5.2378C4.9942 12.309 4.76577 12.1907 4.62522 11.9917C4.48467 11.7928 4.44951 11.5379 4.53093 11.3083L6.78186 4.9607ZM8.01853 5.96136L6.29951 10.809H25.9381L24.2191 5.96136H8.01853Z",
            fill: "#4D4E58"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.1189 4.46136C16.5331 4.46136 16.8689 4.79715 16.8689 5.21136V11.559C16.8689 11.9732 16.5331 12.309 16.1189 12.309C15.7047 12.309 15.3689 11.9732 15.3689 11.559V5.21136C15.3689 4.79715 15.7047 4.46136 16.1189 4.46136Z",
            fill: "#4D4E58"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.2378 10.8091C4.82358 10.8091 4.4878 11.1449 4.4878 11.5591V15.3485C4.4878 15.7628 4.82358 16.0985 5.2378 16.0985C5.65201 16.0985 5.9878 15.7628 5.9878 15.3485V12.3091H26.2498V25.9646H5.9878V19.8857H14.7018L13.3091 21.2796C13.0164 21.5726 13.0166 22.0474 13.3096 22.3402C13.6026 22.633 14.0775 22.6328 14.3702 22.3398L17.0421 19.6657C17.3347 19.3728 17.3347 18.8983 17.0421 18.6054L14.3702 15.9313C14.0775 15.6383 13.6026 15.6381 13.3096 15.9309C13.0166 16.2237 13.0164 16.6985 13.3091 16.9916L14.7021 18.3857H5.2378C4.82358 18.3857 4.4878 18.7215 4.4878 19.1357V26.7146C4.4878 27.1288 4.82358 27.4646 5.2378 27.4646H26.9998C27.414 27.4646 27.7498 27.1288 27.7498 26.7146V11.5591C27.7498 11.1449 27.414 10.8091 26.9998 10.8091H5.2378Z",
            fill: "#4D4E58"
          }
        )
      ] }) })
    }
  );
}
function Ha() {
  return /* @__PURE__ */ s(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ s("g", { id: "32/Pin", children: /* @__PURE__ */ s(
        "path",
        {
          id: "Vector",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16.3333 5.75C14.5873 5.75 12.9128 6.4436 11.6782 7.67821C10.4436 8.91283 9.75 10.5873 9.75 12.3333C9.75 15.7746 11.4823 19.288 13.2907 22.0006C14.1868 23.3448 15.084 24.4664 15.7569 25.2515C15.9758 25.5068 16.1705 25.7261 16.3333 25.9054C16.4962 25.7261 16.6909 25.5068 16.9097 25.2515C17.5827 24.4664 18.4799 23.3448 19.376 22.0006C21.1844 19.288 22.9167 15.7746 22.9167 12.3333C22.9167 10.5873 22.2231 8.91283 20.9885 7.67821C19.7538 6.4436 18.0793 5.75 16.3333 5.75ZM16.3333 27L16.8637 27.5303C16.5708 27.8232 16.0959 27.8232 15.803 27.5303L16.3333 27ZM10.6175 6.61755C12.1335 5.10163 14.1895 4.25 16.3333 4.25C18.4772 4.25 20.5332 5.10163 22.0491 6.61755C23.565 8.13347 24.4167 10.1895 24.4167 12.3333C24.4167 16.2254 22.4823 20.0453 20.624 22.8327C19.6868 24.2386 18.7506 25.4086 18.0486 26.2277C17.6973 26.6376 17.4037 26.9606 17.1967 27.1823C17.0932 27.2932 17.0113 27.3788 16.9546 27.4374C16.9263 27.4667 16.9042 27.4893 16.8889 27.5048L16.8711 27.5229L16.866 27.5279L16.8645 27.5295L16.864 27.53C16.8638 27.5302 16.8637 27.5303 16.3333 27C15.803 27.5303 15.8028 27.5302 15.8027 27.53L15.8022 27.5295L15.8006 27.5279L15.7956 27.5229L15.7777 27.5048C15.7624 27.4893 15.7404 27.4667 15.712 27.4374C15.6553 27.3788 15.5734 27.2932 15.4699 27.1823C15.263 26.9606 14.9694 26.6376 14.6181 26.2277C13.916 25.4086 12.9799 24.2386 12.0426 22.8327C10.1844 20.0453 8.25 16.2254 8.25 12.3333C8.25 10.1895 9.10163 8.13347 10.6175 6.61755ZM16.3333 9.41667C14.7225 9.41667 13.4167 10.7225 13.4167 12.3333C13.4167 13.9442 14.7225 15.25 16.3333 15.25C17.9442 15.25 19.25 13.9442 19.25 12.3333C19.25 10.7225 17.9442 9.41667 16.3333 9.41667ZM11.9167 12.3333C11.9167 9.89408 13.8941 7.91667 16.3333 7.91667C18.7726 7.91667 20.75 9.89408 20.75 12.3333C20.75 14.7726 18.7726 16.75 16.3333 16.75C13.8941 16.75 11.9167 14.7726 11.9167 12.3333Z",
          fill: "currentColor"
        }
      ) })
    }
  );
}
function qa() {
  return /* @__PURE__ */ s(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ s("g", { id: "32/User", children: /* @__PURE__ */ s(
        "path",
        {
          id: "Vector",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16.002 5.75C13.3786 5.75 11.252 7.87665 11.252 10.5C11.252 13.1233 13.3786 15.25 16.002 15.25C18.6253 15.25 20.752 13.1234 20.752 10.5C20.752 7.87665 18.6253 5.75 16.002 5.75ZM19.3082 15.8049C21.0759 14.7008 22.252 12.7377 22.252 10.5C22.252 7.04822 19.4537 4.25 16.002 4.25C12.5502 4.25 9.75195 7.04822 9.75195 10.5C9.75195 12.7377 10.9279 14.7008 12.6956 15.8048C9.06901 17.0662 6.45117 20.3445 6.45117 24.25V27C6.45117 27.4142 6.78696 27.75 7.20117 27.75C7.61539 27.75 7.95117 27.4142 7.95117 27V24.25C7.95117 20.1508 11.5077 16.75 16.002 16.75C20.496 16.75 24.0512 20.1506 24.0512 24.25V27C24.0512 27.4142 24.387 27.75 24.8012 27.75C25.2154 27.75 25.5512 27.4142 25.5512 27V24.25C25.5512 20.3447 22.9344 17.0663 19.3082 15.8049Z",
          fill: "currentColor"
        }
      ) })
    }
  );
}
function Wa() {
  return /* @__PURE__ */ s(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ s("g", { id: "32/User Plus", children: /* @__PURE__ */ s(
        "path",
        {
          id: "Vector",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.252 10.5C11.252 7.87665 13.3786 5.75 16.002 5.75C18.6253 5.75 20.752 7.87665 20.752 10.5C20.752 13.1234 18.6253 15.25 16.002 15.25C13.3786 15.25 11.252 13.1233 11.252 10.5ZM22.252 10.5C22.252 12.7372 21.0765 14.6998 19.3096 15.804C21.0133 16.3963 22.4913 17.434 23.5815 18.7727C23.8431 19.0939 23.7948 19.5663 23.4736 19.8278C23.1524 20.0894 22.68 20.0411 22.4185 19.7199C20.9543 17.9221 18.6323 16.75 16.002 16.75C11.5077 16.75 7.95117 20.1508 7.95117 24.25V27C7.95117 27.4142 7.61539 27.75 7.20117 27.75C6.78696 27.75 6.45117 27.4142 6.45117 27V24.25C6.45117 20.3445 9.06901 17.0662 12.6956 15.8048C10.9279 14.7008 9.75195 12.7377 9.75195 10.5C9.75195 7.04822 12.5502 4.25 16.002 4.25C19.4537 4.25 22.252 7.04822 22.252 10.5ZM24.05 22C24.05 21.5858 24.3858 21.25 24.8 21.25C25.2143 21.25 25.55 21.5858 25.55 22V23.75H27.3C27.7143 23.75 28.05 24.0858 28.05 24.5C28.05 24.9142 27.7143 25.25 27.3 25.25H25.55V27C25.55 27.4142 25.2143 27.75 24.8 27.75C24.3858 27.75 24.05 27.4142 24.05 27V25.25H22.3C21.8858 25.25 21.55 24.9142 21.55 24.5C21.55 24.0858 21.8858 23.75 22.3 23.75H24.05V22Z",
          fill: "currentColor"
        }
      ) })
    }
  );
}
function Ga() {
  return /* @__PURE__ */ w(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 64 64",
      fill: "none",
      stroke: "currentColor",
      children: [
        /* @__PURE__ */ s("circle", { cx: "32", cy: "32", r: "24" }),
        /* @__PURE__ */ s("line", { x1: "32", y1: "16", x2: "32", y2: "36" }),
        /* @__PURE__ */ s("line", { x1: "32", y1: "44", x2: "32", y2: "48" })
      ]
    }
  );
}
const Ka = ["en", "it", "de", "es", "fr"], Qa = "en", Ja = {
  order: ["path"],
  lookupFromPathIndex: 0
}, Ya = {
  fallbackLng: Qa,
  detection: Ja,
  debug: !1,
  interpolation: {
    escapeValue: !1
  },
  supportedLngs: Ka,
  keySeparator: "::",
  nsSeparator: ":::",
  returnEmptyString: !1
};
function Xa({
  resourcesToBackendCallback: t,
  ...e
}) {
  const r = {
    backend: {
      backends: [Yi(t)]
    }
  }, n = Ki({
    ...Ya,
    ...e,
    ...r
  });
  return n.use(Qi).use(Ji), n;
}
const Qt = () => {
  const t = Oi();
  return {
    isMobile: Pt(t.breakpoints.down("md")),
    isTablet: Pt(t.breakpoints.between("md", "lg")),
    isSmallDesktop: Pt(t.breakpoints.between("lg", "xl"))
  };
};
function zr() {
  const [t, e] = te(null), r = !!t;
  function n(a) {
    e(a.currentTarget);
  }
  function i() {
    e(null);
  }
  return {
    open: r,
    anchorEl: t,
    onOpen: n,
    onClose: i
  };
}
const Hr = De(
  {}
);
function eo({ children: t }) {
  const [e, r] = te(!1), [n, i] = te(), [a, o] = te(null), c = ie(() => {
    function l(u, f = null) {
      i(u), r(!0), f && o(() => f);
    }
    function d() {
      r(!1), i(void 0), o(null);
    }
    return {
      isOpen: e,
      handleBack: a,
      handleClose: d,
      handleOpen: l,
      options: n
    };
  }, [e, a, n]);
  return /* @__PURE__ */ s(Hr.Provider, { value: c, children: t });
}
function qr() {
  const t = Kt(Hr);
  if (!t)
    throw new Error(
      "useMobileDrawer must be used within a MobileDrawerProvider"
    );
  return t;
}
const qe = ({
  element: t,
  identifier: e,
  prefix: r
}) => ({
  "data-selector": `${r ? `${r}-` : ""}${t}`,
  ...e && { id: `${t}-${e}` }
});
function to(t) {
  const e = De(t), r = () => {
    const n = Kt(e);
    if (n === void 0)
      throw new Error(
        "Context is attempting to be consumed outside of its provider."
      );
    return n;
  };
  return {
    Provider: e.Provider,
    useContext: r
  };
}
var ve = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Jt(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Et, pr;
function ro() {
  if (pr) return Et;
  pr = 1;
  var t = "Expected a function", e = NaN, r = "[object Symbol]", n = /^\s+|\s+$/g, i = /^[-+]0x[0-9a-f]+$/i, a = /^0b[01]+$/i, o = /^0o[0-7]+$/i, c = parseInt, l = typeof ve == "object" && ve && ve.Object === Object && ve, d = typeof self == "object" && self && self.Object === Object && self, u = l || d || Function("return this")(), f = Object.prototype, b = f.toString, C = Math.max, j = Math.min, M = function() {
    return u.Date.now();
  };
  function A(S, U, h) {
    var P, R, L, N, z, K, le = 0, Ue = !1, he = !1, Le = !0;
    if (typeof S != "function")
      throw new TypeError(t);
    U = ee(U) || 0, B(h) && (Ue = !!h.leading, he = "maxWait" in h, L = he ? C(ee(h.maxWait) || 0, U) : L, Le = "trailing" in h ? !!h.trailing : Le);
    function Fe(Z) {
      var ae = P, xe = R;
      return P = R = void 0, le = Z, N = S.apply(xe, ae), N;
    }
    function Ve(Z) {
      return le = Z, z = setTimeout(ge, U), Ue ? Fe(Z) : N;
    }
    function Ze(Z) {
      var ae = Z - K, xe = Z - le, at = U - ae;
      return he ? j(at, L - xe) : at;
    }
    function $e(Z) {
      var ae = Z - K, xe = Z - le;
      return K === void 0 || ae >= U || ae < 0 || he && xe >= L;
    }
    function ge() {
      var Z = M();
      if ($e(Z))
        return Pe(Z);
      z = setTimeout(ge, Ze(Z));
    }
    function Pe(Z) {
      return z = void 0, Le && P ? Fe(Z) : (P = R = void 0, N);
    }
    function St() {
      z !== void 0 && clearTimeout(z), le = 0, P = K = R = z = void 0;
    }
    function $t() {
      return z === void 0 ? N : Pe(M());
    }
    function ze() {
      var Z = M(), ae = $e(Z);
      if (P = arguments, R = this, K = Z, ae) {
        if (z === void 0)
          return Ve(K);
        if (he)
          return z = setTimeout(ge, U), Fe(K);
      }
      return z === void 0 && (z = setTimeout(ge, U)), N;
    }
    return ze.cancel = St, ze.flush = $t, ze;
  }
  function B(S) {
    var U = typeof S;
    return !!S && (U == "object" || U == "function");
  }
  function O(S) {
    return !!S && typeof S == "object";
  }
  function q(S) {
    return typeof S == "symbol" || O(S) && b.call(S) == r;
  }
  function ee(S) {
    if (typeof S == "number")
      return S;
    if (q(S))
      return e;
    if (B(S)) {
      var U = typeof S.valueOf == "function" ? S.valueOf() : S;
      S = B(U) ? U + "" : U;
    }
    if (typeof S != "string")
      return S === 0 ? S : +S;
    S = S.replace(n, "");
    var h = a.test(S);
    return h || o.test(S) ? c(S.slice(2), h ? 2 : 8) : i.test(S) ? e : +S;
  }
  return Et = A, Et;
}
var no = ro();
const io = /* @__PURE__ */ Jt(no);
function ao(t, e) {
  return io(t, e);
}
function oo(t) {
  const e = Object.fromEntries(
    document.cookie.split("; ").map((r) => r.split("="))
  );
  return e[t] ? decodeURIComponent(e[t]) : null;
}
const so = {
  en: "en",
  fr: "fr",
  de: "de",
  it: "it",
  es: "es"
}, Wr = () => {
  const t = location.pathname.replace(/^\/+/g, "").split("/")[0];
  return so[t];
}, ct = () => {
  const t = Wr();
  return t ? `${window.location.origin}/${t}` : window.location.origin;
};
function Yt(t, e) {
  return `${t.charAt(0)}${e.charAt(0)}`.toUpperCase();
}
var We = { exports: {} };
We.exports;
var fr;
function co() {
  return fr || (fr = 1, (function(t, e) {
    var r = 9007199254740991, n = "[object Arguments]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Map]", c = "[object Object]", l = "[object Promise]", d = "[object Set]", u = "[object WeakMap]", f = "[object DataView]", b = /[\\^$.*+?()[\]{}|]/g, C = /^\[object .+?Constructor\]$/, j = typeof ve == "object" && ve && ve.Object === Object && ve, M = typeof self == "object" && self && self.Object === Object && self, A = j || M || Function("return this")(), B = e && !e.nodeType && e, O = B && !0 && t && !t.nodeType && t, q = O && O.exports === B;
    function ee(g, D) {
      return g?.[D];
    }
    function S(g) {
      var D = !1;
      if (g != null && typeof g.toString != "function")
        try {
          D = !!(g + "");
        } catch {
        }
      return D;
    }
    function U(g, D) {
      return function(re) {
        return g(D(re));
      };
    }
    var h = Function.prototype, P = Object.prototype, R = A["__core-js_shared__"], L = (function() {
      var g = /[^.]+$/.exec(R && R.keys && R.keys.IE_PROTO || "");
      return g ? "Symbol(src)_1." + g : "";
    })(), N = h.toString, z = P.hasOwnProperty, K = P.toString, le = RegExp(
      "^" + N.call(z).replace(b, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), Ue = q ? A.Buffer : void 0, he = P.propertyIsEnumerable, Le = Ue ? Ue.isBuffer : void 0, Fe = U(Object.keys, Object), Ve = He(A, "DataView"), Ze = He(A, "Map"), $e = He(A, "Promise"), ge = He(A, "Set"), Pe = He(A, "WeakMap"), St = !he.call({ valueOf: 1 }, "valueOf"), $t = Ie(Ve), ze = Ie(Ze), Z = Ie($e), ae = Ie(ge), xe = Ie(Pe);
    function at(g) {
      return K.call(g);
    }
    function vi(g) {
      if (!or(g) || bi(g))
        return !1;
      var D = ar(g) || S(g) ? le : C;
      return D.test(Ie(g));
    }
    function He(g, D) {
      var re = ee(g, D);
      return vi(re) ? re : void 0;
    }
    var we = at;
    (Ve && we(new Ve(new ArrayBuffer(1))) != f || Ze && we(new Ze()) != o || $e && we($e.resolve()) != l || ge && we(new ge()) != d || Pe && we(new Pe()) != u) && (we = function(g) {
      var D = K.call(g), re = D == c ? g.constructor : void 0, sr = re ? Ie(re) : void 0;
      if (sr)
        switch (sr) {
          case $t:
            return f;
          case ze:
            return o;
          case Z:
            return l;
          case ae:
            return d;
          case xe:
            return u;
        }
      return D;
    });
    function bi(g) {
      return !!L && L in g;
    }
    function _i(g) {
      var D = g && g.constructor, re = typeof D == "function" && D.prototype || P;
      return g === re;
    }
    function Ie(g) {
      if (g != null) {
        try {
          return N.call(g);
        } catch {
        }
        try {
          return g + "";
        } catch {
        }
      }
      return "";
    }
    function Ci(g) {
      return wi(g) && z.call(g, "callee") && (!he.call(g, "callee") || K.call(g) == n);
    }
    var xi = Array.isArray;
    function ir(g) {
      return g != null && Si(g.length) && !ar(g);
    }
    function wi(g) {
      return $i(g) && ir(g);
    }
    var Ii = Le || Pi;
    function ki(g) {
      if (ir(g) && (xi(g) || typeof g == "string" || typeof g.splice == "function" || Ii(g) || Ci(g)))
        return !g.length;
      var D = we(g);
      if (D == o || D == d)
        return !g.size;
      if (St || _i(g))
        return !Fe(g).length;
      for (var re in g)
        if (z.call(g, re))
          return !1;
      return !0;
    }
    function ar(g) {
      var D = or(g) ? K.call(g) : "";
      return D == i || D == a;
    }
    function Si(g) {
      return typeof g == "number" && g > -1 && g % 1 == 0 && g <= r;
    }
    function or(g) {
      var D = typeof g;
      return !!g && (D == "object" || D == "function");
    }
    function $i(g) {
      return !!g && typeof g == "object";
    }
    function Pi() {
      return !1;
    }
    t.exports = ki;
  })(We, We.exports)), We.exports;
}
var lo = co();
const uo = /* @__PURE__ */ Jt(lo);
function mo(t) {
  return uo(t);
}
var Rt, hr;
function po() {
  if (hr) return Rt;
  hr = 1;
  var t = 1 / 0, e = 9007199254740991, r = 17976931348623157e292, n = NaN, i = 4294967295, a = "[object Symbol]", o = /^\s+|\s+$/g, c = /^[-+]0x[0-9a-f]+$/i, l = /^0b[01]+$/i, d = /^0o[0-7]+$/i, u = parseInt;
  function f(h, P) {
    for (var R = -1, L = Array(h); ++R < h; )
      L[R] = P(R);
    return L;
  }
  var b = Object.prototype, C = b.toString, j = Math.min;
  function M(h) {
    var P = typeof h;
    return !!h && (P == "object" || P == "function");
  }
  function A(h) {
    return !!h && typeof h == "object";
  }
  function B(h) {
    return typeof h == "symbol" || A(h) && C.call(h) == a;
  }
  function O(h) {
    if (!h)
      return h === 0 ? h : 0;
    if (h = ee(h), h === t || h === -t) {
      var P = h < 0 ? -1 : 1;
      return P * r;
    }
    return h === h ? h : 0;
  }
  function q(h) {
    var P = O(h), R = P % 1;
    return P === P ? R ? P - R : P : 0;
  }
  function ee(h) {
    if (typeof h == "number")
      return h;
    if (B(h))
      return n;
    if (M(h)) {
      var P = typeof h.valueOf == "function" ? h.valueOf() : h;
      h = M(P) ? P + "" : P;
    }
    if (typeof h != "string")
      return h === 0 ? h : +h;
    h = h.replace(o, "");
    var R = l.test(h);
    return R || d.test(h) ? u(h.slice(2), R ? 2 : 8) : c.test(h) ? n : +h;
  }
  function S(h) {
    return h;
  }
  function U(h, P) {
    if (h = q(h), h < 1 || h > e)
      return [];
    var R = i, L = j(h, i);
    P = typeof P == "function" ? P : S, h -= i;
    for (var N = f(L, P); ++R < h; )
      P(R);
    return N;
  }
  return Rt = U, Rt;
}
var fo = po();
const ho = /* @__PURE__ */ Jt(fo);
function go(t, e) {
  return ho(t, e);
}
const yo = 50;
function vo() {
  const [t, e] = te(""), r = ao((n) => {
    e(n);
  }, yo);
  return { searchValue: t, searchChangeHandler: r };
}
const bo = (t, e) => window.localStorage.setItem(t, e), _o = (t) => window.localStorage.getItem(t), Co = (t) => window.localStorage.removeItem(t), ce = {
  setItem: bo,
  getItem: _o,
  removeItem: Co
};
function gr(t) {
  const e = Object.prototype.toString.call(t);
  return t instanceof Date || typeof t == "object" && e === "[object Date]" ? new t.constructor(+t) : typeof t == "number" || e === "[object Number]" || typeof t == "string" || e === "[object String]" ? new Date(t) : /* @__PURE__ */ new Date(NaN);
}
const xo = 6e4;
function wo(t) {
  return (e) => {
    const n = (t ? Math[t] : Math.trunc)(e);
    return n === 0 ? 0 : n;
  };
}
function Io(t, e) {
  return +gr(t) - +gr(e);
}
function Gr(t, e, r) {
  const n = Io(t, e) / xo;
  return wo(r?.roundingMethod)(n);
}
const Kr = ({
  title: t,
  onClose: e,
  handleBack: r
}) => /* @__PURE__ */ w("div", { className: "flex flex-row justify-between p-4 border-b border-gray-300", children: [
  /* @__PURE__ */ w("div", { className: "flex flex-row gap-2 items-center", children: [
    r && /* @__PURE__ */ s(be, { onClick: r, color: "secondary", children: /* @__PURE__ */ s(Ma, {}) }),
    /* @__PURE__ */ s(F, { variant: "h2", className: "inline", children: t })
  ] }),
  /* @__PURE__ */ s(be, { onClick: e, color: "secondary", className: "h-[fit-content]", children: /* @__PURE__ */ s(Da, {}) })
] });
function ko({ children: t, ...e }) {
  return /* @__PURE__ */ s(
    "div",
    {
      className: "flex flex-row gap-2 justify-end p-4 pt-3 border-t",
      ...e,
      children: t
    }
  );
}
function So({
  isOpen: t,
  content: e,
  actions: r,
  title: n,
  renderTitleMethod: i = "top-bar",
  drawerSx: a,
  handleClose: o,
  handleBack: c
}) {
  return /* @__PURE__ */ w(
    Nr,
    {
      open: t,
      onClose: o,
      anchor: "bottom",
      sx: a,
      PaperProps: {
        className: "rounded-t-[20px] flex flex-col gap-2"
      },
      children: [
        i === "top-bar" ? /* @__PURE__ */ s(
          Kr,
          {
            title: n,
            onClose: o,
            handleBack: c
          }
        ) : n,
        /* @__PURE__ */ s("div", { className: "px-4 pb-4 overflow-y-auto", children: e }),
        r && /* @__PURE__ */ s(ko, { children: r })
      ]
    }
  );
}
const $o = De(null), jt = {
  didCatch: !1,
  error: null
};
let Po = class extends Ei {
  constructor(e) {
    super(e), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = jt;
  }
  static getDerivedStateFromError(e) {
    return {
      didCatch: !0,
      error: e
    };
  }
  resetErrorBoundary() {
    const {
      error: e
    } = this.state;
    if (e !== null) {
      for (var r, n, i = arguments.length, a = new Array(i), o = 0; o < i; o++)
        a[o] = arguments[o];
      (r = (n = this.props).onReset) === null || r === void 0 || r.call(n, {
        args: a,
        reason: "imperative-api"
      }), this.setState(jt);
    }
  }
  componentDidCatch(e, r) {
    var n, i;
    (n = (i = this.props).onError) === null || n === void 0 || n.call(i, e, r);
  }
  componentDidUpdate(e, r) {
    const {
      didCatch: n
    } = this.state, {
      resetKeys: i
    } = this.props;
    if (n && r.error !== null && Eo(e.resetKeys, i)) {
      var a, o;
      (a = (o = this.props).onReset) === null || a === void 0 || a.call(o, {
        next: i,
        prev: e.resetKeys,
        reason: "keys"
      }), this.setState(jt);
    }
  }
  render() {
    const {
      children: e,
      fallbackRender: r,
      FallbackComponent: n,
      fallback: i
    } = this.props, {
      didCatch: a,
      error: o
    } = this.state;
    let c = e;
    if (a) {
      const l = {
        error: o,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof r == "function")
        c = r(l);
      else if (n)
        c = dr(n, l);
      else if (i !== void 0)
        c = i;
      else
        throw o;
    }
    return dr($o.Provider, {
      value: {
        didCatch: a,
        error: o,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, c);
  }
};
function Eo() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return t.length !== e.length || t.some((r, n) => !Object.is(r, e[n]));
}
function Ro({ fallbackMessage: t }) {
  return /* @__PURE__ */ s("div", { className: "flex flex-col gap-4 justify-center items-center p-4", children: t });
}
function jo({
  children: t,
  fallbackMessage: e
}) {
  return /* @__PURE__ */ s(
    Po,
    {
      FallbackComponent: (r) => /* @__PURE__ */ s(Ro, { ...r, fallbackMessage: e }),
      children: t
    }
  );
}
function To() {
  const { isOpen: t, options: e, handleBack: r, handleClose: n } = qr(), {
    title: i,
    content: a,
    actions: o,
    cancelLabel: c,
    confirmLabel: l,
    onCancel: d,
    onConfirm: u
  } = e || {};
  return /* @__PURE__ */ s(
    So,
    {
      actions: o,
      cancelLabel: c,
      confirmLabel: l,
      content: a,
      handleBack: r,
      isOpen: t,
      onCancel: d,
      onConfirm: u,
      title: i,
      handleClose: n
    }
  );
}
const Mo = 5e3, Oo = {
  isOpen: !1,
  content: "",
  severity: "success"
}, No = De({});
function Do({ children: t }) {
  const [e, r] = te(Oo), { isOpen: n, content: i, severity: a } = e;
  function o(d) {
    r({
      isOpen: !0,
      ...d
    });
  }
  function c() {
    r((d) => ({
      ...d,
      content: "",
      isOpen: !1
    }));
  }
  const l = ie(() => ({
    open: o,
    close: c
  }), []);
  return /* @__PURE__ */ w(No.Provider, { value: l, children: [
    t,
    /* @__PURE__ */ s(
      Ni,
      {
        open: n,
        anchorOrigin: Bo,
        autoHideDuration: Mo,
        sx: Uo,
        onClose: c,
        children: /* @__PURE__ */ s(
          Di,
          {
            severity: a,
            variant: "filled",
            sx: Ao,
            icon: !1,
            onClose: c,
            children: i
          }
        )
      }
    )
  ] });
}
const Bo = {
  vertical: "bottom",
  horizontal: "center"
}, Ao = {
  width: "100%",
  borderRadius: "24px",
  color: "white",
  ".MuiAlert-action": {
    paddingTop: 0,
    display: "flex",
    alignItems: "center"
  }
}, Uo = {
  zIndex: 999999942
};
function Xt({
  displayName: t,
  avatar: e,
  size: r = "small"
}) {
  const n = r === "small" ? "w-8 h-8" : "w-16 h-16", i = r === "small" ? "12px" : "24px", a = r === "small" ? "18px" : "32px";
  return /* @__PURE__ */ s(
    Ra,
    {
      src: e,
      alt: t,
      className: `${n} bg-blue-100`,
      children: /* @__PURE__ */ s(
        F,
        {
          variant: "title1",
          fontSize: i,
          lineHeight: a,
          title: t,
          noWrap: !0,
          children: t
        }
      )
    }
  );
}
const Lo = `https://materialbank.referralrock.com/v2/${ENVIRONMENT_REGION === "US" ? 1 : 17}/access`, Fo = "/orders", Vo = "/boards/data-export", Zo = "/returns", zo = "/customer/account/logout", Ho = "address-modal", ot = 13, Ge = {
  searchInput: "navigation-project-search-input",
  projectListItem: "navigation-project-list-item",
  projectListItemDetails: "navigation-project-list-item-details",
  projectListSpecButton: "navigation-project-list-spec-button",
  topBarProjectButton: "navigation-top-bar-project-button"
};
function qo({
  isOpen: t,
  isLoading: e = !1,
  onOpen: r,
  currentProject: n
}) {
  const { t: i } = W(), { isTablet: a, isMobile: o, isSmallDesktop: c } = Qt(), l = qe({
    element: Ge.topBarProjectButton
  });
  return a || o || c ? /* @__PURE__ */ s(
    be,
    {
      size: "small",
      "aria-haspopup": "true",
      disabled: e,
      onClick: r,
      ...l,
      children: /* @__PURE__ */ s(F, { variant: "h2", color: "textPrimary", children: n ? n.title[0] : i("P") })
    }
  ) : /* @__PURE__ */ s(
    be,
    {
      size: "small",
      "aria-haspopup": "true",
      "aria-controls": t ? "project-section-menu" : void 0,
      "aria-expanded": t ? "true" : void 0,
      disabled: e,
      onClick: r,
      className: "px-0",
      ...l,
      children: /* @__PURE__ */ w("div", { className: "flex flex-row gap-3 items-center h-12 px-3 border border-[#F2F2F2] rounded-full hover:bg-[#F5F5F7] hover:border-[#F5F5F7] max-w-[220px]", children: [
        /* @__PURE__ */ w("div", { className: "flex flex-col text-left truncate", children: [
          /* @__PURE__ */ s(F, { variant: "caption2", className: "inline-block truncate", children: i("Active Project") }),
          /* @__PURE__ */ s(
            F,
            {
              variant: "body1",
              className: "inline-block truncate",
              fontWeight: "600",
              children: n ? n.title : i("Choose project")
            }
          )
        ] }),
        /* @__PURE__ */ s("div", { className: t ? "rotate-180" : "", children: /* @__PURE__ */ s(Zr, {}) })
      ] })
    }
  );
}
const Wo = {
  openProjectCreateDialogEventApiV2: "project-create-dialog-open-event-api-v2"
};
function Go(t) {
  window.dispatchEvent(
    new CustomEvent(
      Wo.openProjectCreateDialogEventApiV2,
      {
        detail: t
      }
    )
  );
}
const Ko = "set-current-project-id";
function Qo() {
  function t(e) {
    Go(e);
  }
  return { onCreate: t };
}
const Jo = [
  "countries",
  "projectUsers",
  "projectUserSuggestions",
  "notes",
  "types",
  "phases",
  "project",
  "projectByExternalID",
  "projects"
], Yo = [
  "createProjectUser",
  "updateProjectUser",
  "deleteProjectUser",
  "Auth",
  "createNote",
  "updateNote",
  "deleteNote",
  "readNotes",
  "evaluateTypes",
  "createProject",
  "patchProject",
  "deleteProject",
  "transferProject"
], Xo = [
  "healthcheck",
  "watchNotes",
  "watchNotesSummary"
], es = [
  ...Xo,
  ...Yo,
  ...Jo
];
var Qr = /* @__PURE__ */ ((t) => (t.Asc = "ASC", t.Desc = "DESC", t))(Qr || {}), Y = /* @__PURE__ */ ((t) => (t.Active = "ACTIVE", t.OnHold = "ON_HOLD", t.Completed = "COMPLETED", t.Canceled = "CANCELED", t.Archived = "ARCHIVED", t))(Y || {}), G = /* @__PURE__ */ ((t) => (t.January = "JANUARY", t.February = "FEBRUARY", t.March = "MARCH", t.April = "APRIL", t.May = "MAY", t.June = "JUNE", t.July = "JULY", t.August = "AUGUST", t.September = "SEPTEMBER", t.October = "OCTOBER", t.November = "NOVEMBER", t.December = "DECEMBER", t.NotSure = "NOT_SURE", t))(G || {});
const ts = {
  setUserCurrentProject: "sdg_project/project/projectssetlist"
}, yr = {
  "materialbank.test": "http://localhost:8081",
  "dev.materialbank.com": "https://mb-projects-dev.usw2.materialbank.com",
  "stage2.materialbank.com": "https://mb-projects-uat.usw2.materialbank.com",
  "uat2.materialbank.com": "https://mb-projects-uat.usw2.materialbank.com",
  "uat.materialbank.eu": "https://mb-projects-uat.dev.materialbank.eu",
  "www.materialbank.eu": "https://projects.p.materialbank.eu",
  "www.materialbank.com": "https://projects.p.materialbank.com",
  default: "https://mb-projects-uat.usw2.materialbank.com"
}, rs = p`
  fragment ProjectFragment on Project {
    id
    title
    country {
      code
      name
    }
    state {
      code
      name
    }
    city
    createdAt
    updatedAt
    externalId
    status
    userRef
    phase {
      code
      label
    }
    details
    type {
      code
      label
      externalId
    }
    budget {
      from
      to
      unit
    }
    size {
      from
      to
      unit
    }
    dueMonth
    dueYear
  }
`, Jr = Vr.create(), ns = {
  appDataStorageKey: "mage-cache-storage"
}, is = "en", er = ENVIRONMENT_REGION ?? "US", vr = "private-content-loaded", as = "customer-menu";
function os(t, e) {
  return Jr(`/${t}`, {
    ...e,
    baseURL: "",
    withCredentials: !0,
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      "Accept-Language": Wr() || is,
      ...e?.headers
    }
  });
}
const { appDataStorageKey: ss } = ns;
function cs() {
  return JSON.parse(ce.getItem(ss) || "{}")?.customer || {};
}
function ds() {
  window.dispatchEvent(new CustomEvent(as));
}
const ls = "reload-customer-section-data";
function us() {
  window.dispatchEvent(new CustomEvent(ls));
}
var Q = /* @__PURE__ */ ((t) => (t[t.TIER_1_GROUP_ID = 1] = "TIER_1_GROUP_ID", t[t.TIER_2_GROUP_ID = 2] = "TIER_2_GROUP_ID", t[t.TIER_3_GROUP_ID = 3] = "TIER_3_GROUP_ID", t[t.TIER_5_GROUP_ID = 5] = "TIER_5_GROUP_ID", t[t.TIER_8_GROUP_ID = 8] = "TIER_8_GROUP_ID", t[t.TIER_10_GROUP_ID = 10] = "TIER_10_GROUP_ID", t[t.TIER_0_GROUP_ID = 11] = "TIER_0_GROUP_ID", t[t.TIER_7_GROUP_ID = 12] = "TIER_7_GROUP_ID", t[t.TIER_13_GROUP_ID = 13] = "TIER_13_GROUP_ID", t[t.TIER_99_GROUP_ID = 14] = "TIER_99_GROUP_ID", t[t.TIER_9_GROUP_ID = 15] = "TIER_9_GROUP_ID", t[t.TIER_15_GROUP_ID = 16] = "TIER_15_GROUP_ID", t[t.TIER_16_GROUP_ID = 17] = "TIER_16_GROUP_ID", t[t.TIER_MCX_GROUP_ID = 21] = "TIER_MCX_GROUP_ID", t[t.TIER_400_GROUP_ID = 22] = "TIER_400_GROUP_ID", t))(Q || {}), T;
(function(t) {
  t.assertEqual = (i) => i;
  function e(i) {
  }
  t.assertIs = e;
  function r(i) {
    throw new Error();
  }
  t.assertNever = r, t.arrayToEnum = (i) => {
    const a = {};
    for (const o of i)
      a[o] = o;
    return a;
  }, t.getValidEnumValues = (i) => {
    const a = t.objectKeys(i).filter((c) => typeof i[i[c]] != "number"), o = {};
    for (const c of a)
      o[c] = i[c];
    return t.objectValues(o);
  }, t.objectValues = (i) => t.objectKeys(i).map(function(a) {
    return i[a];
  }), t.objectKeys = typeof Object.keys == "function" ? (i) => Object.keys(i) : (i) => {
    const a = [];
    for (const o in i)
      Object.prototype.hasOwnProperty.call(i, o) && a.push(o);
    return a;
  }, t.find = (i, a) => {
    for (const o of i)
      if (a(o))
        return o;
  }, t.isInteger = typeof Number.isInteger == "function" ? (i) => Number.isInteger(i) : (i) => typeof i == "number" && isFinite(i) && Math.floor(i) === i;
  function n(i, a = " | ") {
    return i.map((o) => typeof o == "string" ? `'${o}'` : o).join(a);
  }
  t.joinValues = n, t.jsonStringifyReplacer = (i, a) => typeof a == "bigint" ? a.toString() : a;
})(T || (T = {}));
var br;
(function(t) {
  t.mergeShapes = (e, r) => ({
    ...e,
    ...r
    // second overwrites first
  });
})(br || (br = {}));
const v = T.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), ke = (t) => {
  switch (typeof t) {
    case "undefined":
      return v.undefined;
    case "string":
      return v.string;
    case "number":
      return isNaN(t) ? v.nan : v.number;
    case "boolean":
      return v.boolean;
    case "function":
      return v.function;
    case "bigint":
      return v.bigint;
    case "symbol":
      return v.symbol;
    case "object":
      return Array.isArray(t) ? v.array : t === null ? v.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? v.promise : typeof Map < "u" && t instanceof Map ? v.map : typeof Set < "u" && t instanceof Set ? v.set : typeof Date < "u" && t instanceof Date ? v.date : v.object;
    default:
      return v.unknown;
  }
}, m = T.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class ne extends Error {
  constructor(e) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = e;
  }
  get errors() {
    return this.issues;
  }
  format(e) {
    const r = e || function(a) {
      return a.message;
    }, n = { _errors: [] }, i = (a) => {
      for (const o of a.issues)
        if (o.code === "invalid_union")
          o.unionErrors.map(i);
        else if (o.code === "invalid_return_type")
          i(o.returnTypeError);
        else if (o.code === "invalid_arguments")
          i(o.argumentsError);
        else if (o.path.length === 0)
          n._errors.push(r(o));
        else {
          let c = n, l = 0;
          for (; l < o.path.length; ) {
            const d = o.path[l];
            l === o.path.length - 1 ? (c[d] = c[d] || { _errors: [] }, c[d]._errors.push(r(o))) : c[d] = c[d] || { _errors: [] }, c = c[d], l++;
          }
        }
    };
    return i(this), n;
  }
  static assert(e) {
    if (!(e instanceof ne))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, T.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (r) => r.message) {
    const r = {}, n = [];
    for (const i of this.issues)
      i.path.length > 0 ? (r[i.path[0]] = r[i.path[0]] || [], r[i.path[0]].push(e(i))) : n.push(e(i));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
ne.create = (t) => new ne(t);
const et = (t, e) => {
  let r;
  switch (t.code) {
    case m.invalid_type:
      t.received === v.undefined ? r = "Required" : r = `Expected ${t.expected}, received ${t.received}`;
      break;
    case m.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(t.expected, T.jsonStringifyReplacer)}`;
      break;
    case m.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${T.joinValues(t.keys, ", ")}`;
      break;
    case m.invalid_union:
      r = "Invalid input";
      break;
    case m.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${T.joinValues(t.options)}`;
      break;
    case m.invalid_enum_value:
      r = `Invalid enum value. Expected ${T.joinValues(t.options)}, received '${t.received}'`;
      break;
    case m.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case m.invalid_return_type:
      r = "Invalid function return type";
      break;
    case m.invalid_date:
      r = "Invalid date";
      break;
    case m.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (r = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? r = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? r = `Invalid input: must end with "${t.validation.endsWith}"` : T.assertNever(t.validation) : t.validation !== "regex" ? r = `Invalid ${t.validation}` : r = "Invalid";
      break;
    case m.too_small:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : r = "Invalid input";
      break;
    case m.too_big:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? r = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : r = "Invalid input";
      break;
    case m.custom:
      r = "Invalid input";
      break;
    case m.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case m.not_multiple_of:
      r = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case m.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = e.defaultError, T.assertNever(t);
  }
  return { message: r };
};
let ms = et;
function Mt() {
  return ms;
}
const Ot = (t) => {
  const { data: e, path: r, errorMaps: n, issueData: i } = t, a = [...r, ...i.path || []], o = {
    ...i,
    path: a
  };
  if (i.message !== void 0)
    return {
      ...i,
      path: a,
      message: i.message
    };
  let c = "";
  const l = n.filter((d) => !!d).slice().reverse();
  for (const d of l)
    c = d(o, { data: e, defaultError: c }).message;
  return {
    ...i,
    path: a,
    message: c
  };
};
function y(t, e) {
  const r = Mt(), n = Ot({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      t.schemaErrorMap,
      r,
      r === et ? void 0 : et
      // then global default map
    ].filter((i) => !!i)
  });
  t.common.issues.push(n);
}
class J {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, r) {
    const n = [];
    for (const i of r) {
      if (i.status === "aborted")
        return I;
      i.status === "dirty" && e.dirty(), n.push(i.value);
    }
    return { status: e.value, value: n };
  }
  static async mergeObjectAsync(e, r) {
    const n = [];
    for (const i of r) {
      const a = await i.key, o = await i.value;
      n.push({
        key: a,
        value: o
      });
    }
    return J.mergeObjectSync(e, n);
  }
  static mergeObjectSync(e, r) {
    const n = {};
    for (const i of r) {
      const { key: a, value: o } = i;
      if (a.status === "aborted" || o.status === "aborted")
        return I;
      a.status === "dirty" && e.dirty(), o.status === "dirty" && e.dirty(), a.value !== "__proto__" && (typeof o.value < "u" || i.alwaysSet) && (n[a.value] = o.value);
    }
    return { status: e.value, value: n };
  }
}
const I = Object.freeze({
  status: "aborted"
}), Ke = (t) => ({ status: "dirty", value: t }), X = (t) => ({ status: "valid", value: t }), _r = (t) => t.status === "aborted", Cr = (t) => t.status === "dirty", dt = (t) => t.status === "valid", lt = (t) => typeof Promise < "u" && t instanceof Promise;
function ut(t, e, r, n) {
  if (typeof e == "function" ? t !== e || !0 : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return e.get(t);
}
function Yr(t, e, r, n, i) {
  if (typeof e == "function" ? t !== e || !0 : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return e.set(t, r), r;
}
var _;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e?.message;
})(_ || (_ = {}));
var Qe, Je;
class de {
  constructor(e, r, n, i) {
    this._cachedPath = [], this.parent = e, this.data = r, this._path = n, this._key = i;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const xr = (t, e) => {
  if (dt(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new ne(t.common.issues);
      return this._error = r, this._error;
    }
  };
};
function k(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: r, required_error: n, description: i } = t;
  if (e && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: i } : { errorMap: (o, c) => {
    var l, d;
    const { message: u } = t;
    return o.code === "invalid_enum_value" ? { message: u ?? c.defaultError } : typeof c.data > "u" ? { message: (l = u ?? n) !== null && l !== void 0 ? l : c.defaultError } : o.code !== "invalid_type" ? { message: c.defaultError } : { message: (d = u ?? r) !== null && d !== void 0 ? d : c.defaultError };
  }, description: i };
}
class $ {
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return ke(e.data);
  }
  _getOrReturnCtx(e, r) {
    return r || {
      common: e.parent.common,
      data: e.data,
      parsedType: ke(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new J(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: ke(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const r = this._parse(e);
    if (lt(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(e) {
    const r = this._parse(e);
    return Promise.resolve(r);
  }
  parse(e, r) {
    const n = this.safeParse(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(e, r) {
    var n;
    const i = {
      common: {
        issues: [],
        async: (n = r?.async) !== null && n !== void 0 ? n : !1,
        contextualErrorMap: r?.errorMap
      },
      path: r?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: ke(e)
    }, a = this._parseSync({ data: e, path: i.path, parent: i });
    return xr(i, a);
  }
  async parseAsync(e, r) {
    const n = await this.safeParseAsync(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(e, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r?.errorMap,
        async: !0
      },
      path: r?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: ke(e)
    }, i = this._parse({ data: e, path: n.path, parent: n }), a = await (lt(i) ? i : Promise.resolve(i));
    return xr(n, a);
  }
  refine(e, r) {
    const n = (i) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(i) : r;
    return this._refinement((i, a) => {
      const o = e(i), c = () => a.addIssue({
        code: m.custom,
        ...n(i)
      });
      return typeof Promise < "u" && o instanceof Promise ? o.then((l) => l ? !0 : (c(), !1)) : o ? !0 : (c(), !1);
    });
  }
  refinement(e, r) {
    return this._refinement((n, i) => e(n) ? !0 : (i.addIssue(typeof r == "function" ? r(n, i) : r), !1));
  }
  _refinement(e) {
    return new fe({
      schema: this,
      typeName: x.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  optional() {
    return se.create(this, this._def);
  }
  nullable() {
    return Ce.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return oe.create(this, this._def);
  }
  promise() {
    return rt.create(this, this._def);
  }
  or(e) {
    return ft.create([this, e], this._def);
  }
  and(e) {
    return ht.create(this, e, this._def);
  }
  transform(e) {
    return new fe({
      ...k(this._def),
      schema: this,
      typeName: x.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const r = typeof e == "function" ? e : () => e;
    return new _t({
      ...k(this._def),
      innerType: this,
      defaultValue: r,
      typeName: x.ZodDefault
    });
  }
  brand() {
    return new rn({
      typeName: x.ZodBranded,
      type: this,
      ...k(this._def)
    });
  }
  catch(e) {
    const r = typeof e == "function" ? e : () => e;
    return new Ct({
      ...k(this._def),
      innerType: this,
      catchValue: r,
      typeName: x.ZodCatch
    });
  }
  describe(e) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return It.create(this, e);
  }
  readonly() {
    return xt.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const ps = /^c[^\s-]{8,}$/i, fs = /^[0-9a-z]+$/, hs = /^[0-9A-HJKMNP-TV-Z]{26}$/, gs = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, ys = /^[a-z0-9_-]{21}$/i, vs = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, bs = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, _s = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Tt;
const Cs = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, xs = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, ws = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Xr = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Is = new RegExp(`^${Xr}$`);
function en(t) {
  let e = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return t.precision ? e = `${e}\\.\\d{${t.precision}}` : t.precision == null && (e = `${e}(\\.\\d+)?`), e;
}
function ks(t) {
  return new RegExp(`^${en(t)}$`);
}
function Ss(t) {
  let e = `${Xr}T${en(t)}`;
  const r = [];
  return r.push(t.local ? "Z?" : "Z"), t.offset && r.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${r.join("|")})`, new RegExp(`^${e}$`);
}
function $s(t, e) {
  return !!((e === "v4" || !e) && Cs.test(t) || (e === "v6" || !e) && xs.test(t));
}
class me extends $ {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== v.string) {
      const a = this._getOrReturnCtx(e);
      return y(a, {
        code: m.invalid_type,
        expected: v.string,
        received: a.parsedType
      }), I;
    }
    const n = new J();
    let i;
    for (const a of this._def.checks)
      if (a.kind === "min")
        e.data.length < a.value && (i = this._getOrReturnCtx(e, i), y(i, {
          code: m.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), n.dirty());
      else if (a.kind === "max")
        e.data.length > a.value && (i = this._getOrReturnCtx(e, i), y(i, {
          code: m.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), n.dirty());
      else if (a.kind === "length") {
        const o = e.data.length > a.value, c = e.data.length < a.value;
        (o || c) && (i = this._getOrReturnCtx(e, i), o ? y(i, {
          code: m.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }) : c && y(i, {
          code: m.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }), n.dirty());
      } else if (a.kind === "email")
        bs.test(e.data) || (i = this._getOrReturnCtx(e, i), y(i, {
          validation: "email",
          code: m.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "emoji")
        Tt || (Tt = new RegExp(_s, "u")), Tt.test(e.data) || (i = this._getOrReturnCtx(e, i), y(i, {
          validation: "emoji",
          code: m.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "uuid")
        gs.test(e.data) || (i = this._getOrReturnCtx(e, i), y(i, {
          validation: "uuid",
          code: m.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "nanoid")
        ys.test(e.data) || (i = this._getOrReturnCtx(e, i), y(i, {
          validation: "nanoid",
          code: m.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "cuid")
        ps.test(e.data) || (i = this._getOrReturnCtx(e, i), y(i, {
          validation: "cuid",
          code: m.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "cuid2")
        fs.test(e.data) || (i = this._getOrReturnCtx(e, i), y(i, {
          validation: "cuid2",
          code: m.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "ulid")
        hs.test(e.data) || (i = this._getOrReturnCtx(e, i), y(i, {
          validation: "ulid",
          code: m.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "url")
        try {
          new URL(e.data);
        } catch {
          i = this._getOrReturnCtx(e, i), y(i, {
            validation: "url",
            code: m.invalid_string,
            message: a.message
          }), n.dirty();
        }
      else a.kind === "regex" ? (a.regex.lastIndex = 0, a.regex.test(e.data) || (i = this._getOrReturnCtx(e, i), y(i, {
        validation: "regex",
        code: m.invalid_string,
        message: a.message
      }), n.dirty())) : a.kind === "trim" ? e.data = e.data.trim() : a.kind === "includes" ? e.data.includes(a.value, a.position) || (i = this._getOrReturnCtx(e, i), y(i, {
        code: m.invalid_string,
        validation: { includes: a.value, position: a.position },
        message: a.message
      }), n.dirty()) : a.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : a.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : a.kind === "startsWith" ? e.data.startsWith(a.value) || (i = this._getOrReturnCtx(e, i), y(i, {
        code: m.invalid_string,
        validation: { startsWith: a.value },
        message: a.message
      }), n.dirty()) : a.kind === "endsWith" ? e.data.endsWith(a.value) || (i = this._getOrReturnCtx(e, i), y(i, {
        code: m.invalid_string,
        validation: { endsWith: a.value },
        message: a.message
      }), n.dirty()) : a.kind === "datetime" ? Ss(a).test(e.data) || (i = this._getOrReturnCtx(e, i), y(i, {
        code: m.invalid_string,
        validation: "datetime",
        message: a.message
      }), n.dirty()) : a.kind === "date" ? Is.test(e.data) || (i = this._getOrReturnCtx(e, i), y(i, {
        code: m.invalid_string,
        validation: "date",
        message: a.message
      }), n.dirty()) : a.kind === "time" ? ks(a).test(e.data) || (i = this._getOrReturnCtx(e, i), y(i, {
        code: m.invalid_string,
        validation: "time",
        message: a.message
      }), n.dirty()) : a.kind === "duration" ? vs.test(e.data) || (i = this._getOrReturnCtx(e, i), y(i, {
        validation: "duration",
        code: m.invalid_string,
        message: a.message
      }), n.dirty()) : a.kind === "ip" ? $s(e.data, a.version) || (i = this._getOrReturnCtx(e, i), y(i, {
        validation: "ip",
        code: m.invalid_string,
        message: a.message
      }), n.dirty()) : a.kind === "base64" ? ws.test(e.data) || (i = this._getOrReturnCtx(e, i), y(i, {
        validation: "base64",
        code: m.invalid_string,
        message: a.message
      }), n.dirty()) : T.assertNever(a);
    return { status: n.value, value: e.data };
  }
  _regex(e, r, n) {
    return this.refinement((i) => e.test(i), {
      validation: r,
      code: m.invalid_string,
      ..._.errToObj(n)
    });
  }
  _addCheck(e) {
    return new me({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ..._.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ..._.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ..._.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ..._.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ..._.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ..._.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ..._.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ..._.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ..._.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ..._.errToObj(e) });
  }
  datetime(e) {
    var r, n;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      offset: (r = e?.offset) !== null && r !== void 0 ? r : !1,
      local: (n = e?.local) !== null && n !== void 0 ? n : !1,
      ..._.errToObj(e?.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof e?.precision > "u" ? null : e?.precision,
      ..._.errToObj(e?.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ..._.errToObj(e) });
  }
  regex(e, r) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ..._.errToObj(r)
    });
  }
  includes(e, r) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: r?.position,
      ..._.errToObj(r?.message)
    });
  }
  startsWith(e, r) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ..._.errToObj(r)
    });
  }
  endsWith(e, r) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ..._.errToObj(r)
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e,
      ..._.errToObj(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e,
      ..._.errToObj(r)
    });
  }
  length(e, r) {
    return this._addCheck({
      kind: "length",
      value: e,
      ..._.errToObj(r)
    });
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(e) {
    return this.min(1, _.errToObj(e));
  }
  trim() {
    return new me({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new me({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new me({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get minLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
}
me.create = (t) => {
  var e;
  return new me({
    checks: [],
    typeName: x.ZodString,
    coerce: (e = t?.coerce) !== null && e !== void 0 ? e : !1,
    ...k(t)
  });
};
function Ps(t, e) {
  const r = (t.toString().split(".")[1] || "").length, n = (e.toString().split(".")[1] || "").length, i = r > n ? r : n, a = parseInt(t.toFixed(i).replace(".", "")), o = parseInt(e.toFixed(i).replace(".", ""));
  return a % o / Math.pow(10, i);
}
class Me extends $ {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== v.number) {
      const a = this._getOrReturnCtx(e);
      return y(a, {
        code: m.invalid_type,
        expected: v.number,
        received: a.parsedType
      }), I;
    }
    let n;
    const i = new J();
    for (const a of this._def.checks)
      a.kind === "int" ? T.isInteger(e.data) || (n = this._getOrReturnCtx(e, n), y(n, {
        code: m.invalid_type,
        expected: "integer",
        received: "float",
        message: a.message
      }), i.dirty()) : a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (n = this._getOrReturnCtx(e, n), y(n, {
        code: m.too_small,
        minimum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), i.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (n = this._getOrReturnCtx(e, n), y(n, {
        code: m.too_big,
        maximum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), i.dirty()) : a.kind === "multipleOf" ? Ps(e.data, a.value) !== 0 && (n = this._getOrReturnCtx(e, n), y(n, {
        code: m.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), i.dirty()) : a.kind === "finite" ? Number.isFinite(e.data) || (n = this._getOrReturnCtx(e, n), y(n, {
        code: m.not_finite,
        message: a.message
      }), i.dirty()) : T.assertNever(a);
    return { status: i.value, value: e.data };
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, _.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, _.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, _.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, _.toString(r));
  }
  setLimit(e, r, n, i) {
    return new Me({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: _.toString(i)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Me({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: _.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: _.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: _.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: _.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: _.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: _.toString(r)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: _.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: _.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: _.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && T.isInteger(e.value));
  }
  get isFinite() {
    let e = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(e);
  }
}
Me.create = (t) => new Me({
  checks: [],
  typeName: x.ZodNumber,
  coerce: t?.coerce || !1,
  ...k(t)
});
class Oe extends $ {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = BigInt(e.data)), this._getType(e) !== v.bigint) {
      const a = this._getOrReturnCtx(e);
      return y(a, {
        code: m.invalid_type,
        expected: v.bigint,
        received: a.parsedType
      }), I;
    }
    let n;
    const i = new J();
    for (const a of this._def.checks)
      a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (n = this._getOrReturnCtx(e, n), y(n, {
        code: m.too_small,
        type: "bigint",
        minimum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), i.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (n = this._getOrReturnCtx(e, n), y(n, {
        code: m.too_big,
        type: "bigint",
        maximum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), i.dirty()) : a.kind === "multipleOf" ? e.data % a.value !== BigInt(0) && (n = this._getOrReturnCtx(e, n), y(n, {
        code: m.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), i.dirty()) : T.assertNever(a);
    return { status: i.value, value: e.data };
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, _.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, _.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, _.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, _.toString(r));
  }
  setLimit(e, r, n, i) {
    return new Oe({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: _.toString(i)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Oe({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: _.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: _.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: _.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: _.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: _.toString(r)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
}
Oe.create = (t) => {
  var e;
  return new Oe({
    checks: [],
    typeName: x.ZodBigInt,
    coerce: (e = t?.coerce) !== null && e !== void 0 ? e : !1,
    ...k(t)
  });
};
class Nt extends $ {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== v.boolean) {
      const n = this._getOrReturnCtx(e);
      return y(n, {
        code: m.invalid_type,
        expected: v.boolean,
        received: n.parsedType
      }), I;
    }
    return X(e.data);
  }
}
Nt.create = (t) => new Nt({
  typeName: x.ZodBoolean,
  coerce: t?.coerce || !1,
  ...k(t)
});
class tt extends $ {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== v.date) {
      const a = this._getOrReturnCtx(e);
      return y(a, {
        code: m.invalid_type,
        expected: v.date,
        received: a.parsedType
      }), I;
    }
    if (isNaN(e.data.getTime())) {
      const a = this._getOrReturnCtx(e);
      return y(a, {
        code: m.invalid_date
      }), I;
    }
    const n = new J();
    let i;
    for (const a of this._def.checks)
      a.kind === "min" ? e.data.getTime() < a.value && (i = this._getOrReturnCtx(e, i), y(i, {
        code: m.too_small,
        message: a.message,
        inclusive: !0,
        exact: !1,
        minimum: a.value,
        type: "date"
      }), n.dirty()) : a.kind === "max" ? e.data.getTime() > a.value && (i = this._getOrReturnCtx(e, i), y(i, {
        code: m.too_big,
        message: a.message,
        inclusive: !0,
        exact: !1,
        maximum: a.value,
        type: "date"
      }), n.dirty()) : T.assertNever(a);
    return {
      status: n.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new tt({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: _.toString(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: _.toString(r)
    });
  }
  get minDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
}
tt.create = (t) => new tt({
  checks: [],
  coerce: t?.coerce || !1,
  typeName: x.ZodDate,
  ...k(t)
});
class Dt extends $ {
  _parse(e) {
    if (this._getType(e) !== v.symbol) {
      const n = this._getOrReturnCtx(e);
      return y(n, {
        code: m.invalid_type,
        expected: v.symbol,
        received: n.parsedType
      }), I;
    }
    return X(e.data);
  }
}
Dt.create = (t) => new Dt({
  typeName: x.ZodSymbol,
  ...k(t)
});
class mt extends $ {
  _parse(e) {
    if (this._getType(e) !== v.undefined) {
      const n = this._getOrReturnCtx(e);
      return y(n, {
        code: m.invalid_type,
        expected: v.undefined,
        received: n.parsedType
      }), I;
    }
    return X(e.data);
  }
}
mt.create = (t) => new mt({
  typeName: x.ZodUndefined,
  ...k(t)
});
class pt extends $ {
  _parse(e) {
    if (this._getType(e) !== v.null) {
      const n = this._getOrReturnCtx(e);
      return y(n, {
        code: m.invalid_type,
        expected: v.null,
        received: n.parsedType
      }), I;
    }
    return X(e.data);
  }
}
pt.create = (t) => new pt({
  typeName: x.ZodNull,
  ...k(t)
});
class Bt extends $ {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return X(e.data);
  }
}
Bt.create = (t) => new Bt({
  typeName: x.ZodAny,
  ...k(t)
});
class je extends $ {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return X(e.data);
  }
}
je.create = (t) => new je({
  typeName: x.ZodUnknown,
  ...k(t)
});
class _e extends $ {
  _parse(e) {
    const r = this._getOrReturnCtx(e);
    return y(r, {
      code: m.invalid_type,
      expected: v.never,
      received: r.parsedType
    }), I;
  }
}
_e.create = (t) => new _e({
  typeName: x.ZodNever,
  ...k(t)
});
class At extends $ {
  _parse(e) {
    if (this._getType(e) !== v.undefined) {
      const n = this._getOrReturnCtx(e);
      return y(n, {
        code: m.invalid_type,
        expected: v.void,
        received: n.parsedType
      }), I;
    }
    return X(e.data);
  }
}
At.create = (t) => new At({
  typeName: x.ZodVoid,
  ...k(t)
});
class oe extends $ {
  _parse(e) {
    const { ctx: r, status: n } = this._processInputParams(e), i = this._def;
    if (r.parsedType !== v.array)
      return y(r, {
        code: m.invalid_type,
        expected: v.array,
        received: r.parsedType
      }), I;
    if (i.exactLength !== null) {
      const o = r.data.length > i.exactLength.value, c = r.data.length < i.exactLength.value;
      (o || c) && (y(r, {
        code: o ? m.too_big : m.too_small,
        minimum: c ? i.exactLength.value : void 0,
        maximum: o ? i.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: i.exactLength.message
      }), n.dirty());
    }
    if (i.minLength !== null && r.data.length < i.minLength.value && (y(r, {
      code: m.too_small,
      minimum: i.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.minLength.message
    }), n.dirty()), i.maxLength !== null && r.data.length > i.maxLength.value && (y(r, {
      code: m.too_big,
      maximum: i.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((o, c) => i.type._parseAsync(new de(r, o, r.path, c)))).then((o) => J.mergeArray(n, o));
    const a = [...r.data].map((o, c) => i.type._parseSync(new de(r, o, r.path, c)));
    return J.mergeArray(n, a);
  }
  get element() {
    return this._def.type;
  }
  min(e, r) {
    return new oe({
      ...this._def,
      minLength: { value: e, message: _.toString(r) }
    });
  }
  max(e, r) {
    return new oe({
      ...this._def,
      maxLength: { value: e, message: _.toString(r) }
    });
  }
  length(e, r) {
    return new oe({
      ...this._def,
      exactLength: { value: e, message: _.toString(r) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
oe.create = (t, e) => new oe({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: x.ZodArray,
  ...k(e)
});
function Re(t) {
  if (t instanceof V) {
    const e = {};
    for (const r in t.shape) {
      const n = t.shape[r];
      e[r] = se.create(Re(n));
    }
    return new V({
      ...t._def,
      shape: () => e
    });
  } else return t instanceof oe ? new oe({
    ...t._def,
    type: Re(t.element)
  }) : t instanceof se ? se.create(Re(t.unwrap())) : t instanceof Ce ? Ce.create(Re(t.unwrap())) : t instanceof pe ? pe.create(t.items.map((e) => Re(e))) : t;
}
class V extends $ {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), r = T.objectKeys(e);
    return this._cached = { shape: e, keys: r };
  }
  _parse(e) {
    if (this._getType(e) !== v.object) {
      const d = this._getOrReturnCtx(e);
      return y(d, {
        code: m.invalid_type,
        expected: v.object,
        received: d.parsedType
      }), I;
    }
    const { status: n, ctx: i } = this._processInputParams(e), { shape: a, keys: o } = this._getCached(), c = [];
    if (!(this._def.catchall instanceof _e && this._def.unknownKeys === "strip"))
      for (const d in i.data)
        o.includes(d) || c.push(d);
    const l = [];
    for (const d of o) {
      const u = a[d], f = i.data[d];
      l.push({
        key: { status: "valid", value: d },
        value: u._parse(new de(i, f, i.path, d)),
        alwaysSet: d in i.data
      });
    }
    if (this._def.catchall instanceof _e) {
      const d = this._def.unknownKeys;
      if (d === "passthrough")
        for (const u of c)
          l.push({
            key: { status: "valid", value: u },
            value: { status: "valid", value: i.data[u] }
          });
      else if (d === "strict")
        c.length > 0 && (y(i, {
          code: m.unrecognized_keys,
          keys: c
        }), n.dirty());
      else if (d !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const d = this._def.catchall;
      for (const u of c) {
        const f = i.data[u];
        l.push({
          key: { status: "valid", value: u },
          value: d._parse(
            new de(i, f, i.path, u)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: u in i.data
        });
      }
    }
    return i.common.async ? Promise.resolve().then(async () => {
      const d = [];
      for (const u of l) {
        const f = await u.key, b = await u.value;
        d.push({
          key: f,
          value: b,
          alwaysSet: u.alwaysSet
        });
      }
      return d;
    }).then((d) => J.mergeObjectSync(n, d)) : J.mergeObjectSync(n, l);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return _.errToObj, new V({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (r, n) => {
          var i, a, o, c;
          const l = (o = (a = (i = this._def).errorMap) === null || a === void 0 ? void 0 : a.call(i, r, n).message) !== null && o !== void 0 ? o : n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: (c = _.errToObj(e).message) !== null && c !== void 0 ? c : l
          } : {
            message: l
          };
        }
      } : {}
    });
  }
  strip() {
    return new V({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new V({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new V({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new V({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: x.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, r) {
    return this.augment({ [e]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new V({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const r = {};
    return T.objectKeys(e).forEach((n) => {
      e[n] && this.shape[n] && (r[n] = this.shape[n]);
    }), new V({
      ...this._def,
      shape: () => r
    });
  }
  omit(e) {
    const r = {};
    return T.objectKeys(this.shape).forEach((n) => {
      e[n] || (r[n] = this.shape[n]);
    }), new V({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return Re(this);
  }
  partial(e) {
    const r = {};
    return T.objectKeys(this.shape).forEach((n) => {
      const i = this.shape[n];
      e && !e[n] ? r[n] = i : r[n] = i.optional();
    }), new V({
      ...this._def,
      shape: () => r
    });
  }
  required(e) {
    const r = {};
    return T.objectKeys(this.shape).forEach((n) => {
      if (e && !e[n])
        r[n] = this.shape[n];
      else {
        let a = this.shape[n];
        for (; a instanceof se; )
          a = a._def.innerType;
        r[n] = a;
      }
    }), new V({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return tn(T.objectKeys(this.shape));
  }
}
V.create = (t, e) => new V({
  shape: () => t,
  unknownKeys: "strip",
  catchall: _e.create(),
  typeName: x.ZodObject,
  ...k(e)
});
V.strictCreate = (t, e) => new V({
  shape: () => t,
  unknownKeys: "strict",
  catchall: _e.create(),
  typeName: x.ZodObject,
  ...k(e)
});
V.lazycreate = (t, e) => new V({
  shape: t,
  unknownKeys: "strip",
  catchall: _e.create(),
  typeName: x.ZodObject,
  ...k(e)
});
class ft extends $ {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = this._def.options;
    function i(a) {
      for (const c of a)
        if (c.result.status === "valid")
          return c.result;
      for (const c of a)
        if (c.result.status === "dirty")
          return r.common.issues.push(...c.ctx.common.issues), c.result;
      const o = a.map((c) => new ne(c.ctx.common.issues));
      return y(r, {
        code: m.invalid_union,
        unionErrors: o
      }), I;
    }
    if (r.common.async)
      return Promise.all(n.map(async (a) => {
        const o = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await a._parseAsync({
            data: r.data,
            path: r.path,
            parent: o
          }),
          ctx: o
        };
      })).then(i);
    {
      let a;
      const o = [];
      for (const l of n) {
        const d = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, u = l._parseSync({
          data: r.data,
          path: r.path,
          parent: d
        });
        if (u.status === "valid")
          return u;
        u.status === "dirty" && !a && (a = { result: u, ctx: d }), d.common.issues.length && o.push(d.common.issues);
      }
      if (a)
        return r.common.issues.push(...a.ctx.common.issues), a.result;
      const c = o.map((l) => new ne(l));
      return y(r, {
        code: m.invalid_union,
        unionErrors: c
      }), I;
    }
  }
  get options() {
    return this._def.options;
  }
}
ft.create = (t, e) => new ft({
  options: t,
  typeName: x.ZodUnion,
  ...k(e)
});
const ue = (t) => t instanceof yt ? ue(t.schema) : t instanceof fe ? ue(t.innerType()) : t instanceof vt ? [t.value] : t instanceof Se ? t.options : t instanceof bt ? T.objectValues(t.enum) : t instanceof _t ? ue(t._def.innerType) : t instanceof mt ? [void 0] : t instanceof pt ? [null] : t instanceof se ? [void 0, ...ue(t.unwrap())] : t instanceof Ce ? [null, ...ue(t.unwrap())] : t instanceof rn || t instanceof xt ? ue(t.unwrap()) : t instanceof Ct ? ue(t._def.innerType) : [];
class tr extends $ {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== v.object)
      return y(r, {
        code: m.invalid_type,
        expected: v.object,
        received: r.parsedType
      }), I;
    const n = this.discriminator, i = r.data[n], a = this.optionsMap.get(i);
    return a ? r.common.async ? a._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : a._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (y(r, {
      code: m.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), I);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, r, n) {
    const i = /* @__PURE__ */ new Map();
    for (const a of r) {
      const o = ue(a.shape[e]);
      if (!o.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const c of o) {
        if (i.has(c))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(c)}`);
        i.set(c, a);
      }
    }
    return new tr({
      typeName: x.ZodDiscriminatedUnion,
      discriminator: e,
      options: r,
      optionsMap: i,
      ...k(n)
    });
  }
}
function Ut(t, e) {
  const r = ke(t), n = ke(e);
  if (t === e)
    return { valid: !0, data: t };
  if (r === v.object && n === v.object) {
    const i = T.objectKeys(e), a = T.objectKeys(t).filter((c) => i.indexOf(c) !== -1), o = { ...t, ...e };
    for (const c of a) {
      const l = Ut(t[c], e[c]);
      if (!l.valid)
        return { valid: !1 };
      o[c] = l.data;
    }
    return { valid: !0, data: o };
  } else if (r === v.array && n === v.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const i = [];
    for (let a = 0; a < t.length; a++) {
      const o = t[a], c = e[a], l = Ut(o, c);
      if (!l.valid)
        return { valid: !1 };
      i.push(l.data);
    }
    return { valid: !0, data: i };
  } else return r === v.date && n === v.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
class ht extends $ {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), i = (a, o) => {
      if (_r(a) || _r(o))
        return I;
      const c = Ut(a.value, o.value);
      return c.valid ? ((Cr(a) || Cr(o)) && r.dirty(), { status: r.value, value: c.data }) : (y(n, {
        code: m.invalid_intersection_types
      }), I);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([a, o]) => i(a, o)) : i(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
ht.create = (t, e, r) => new ht({
  left: t,
  right: e,
  typeName: x.ZodIntersection,
  ...k(r)
});
class pe extends $ {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== v.array)
      return y(n, {
        code: m.invalid_type,
        expected: v.array,
        received: n.parsedType
      }), I;
    if (n.data.length < this._def.items.length)
      return y(n, {
        code: m.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), I;
    !this._def.rest && n.data.length > this._def.items.length && (y(n, {
      code: m.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const a = [...n.data].map((o, c) => {
      const l = this._def.items[c] || this._def.rest;
      return l ? l._parse(new de(n, o, n.path, c)) : null;
    }).filter((o) => !!o);
    return n.common.async ? Promise.all(a).then((o) => J.mergeArray(r, o)) : J.mergeArray(r, a);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new pe({
      ...this._def,
      rest: e
    });
  }
}
pe.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new pe({
    items: t,
    typeName: x.ZodTuple,
    rest: null,
    ...k(e)
  });
};
class gt extends $ {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== v.object)
      return y(n, {
        code: m.invalid_type,
        expected: v.object,
        received: n.parsedType
      }), I;
    const i = [], a = this._def.keyType, o = this._def.valueType;
    for (const c in n.data)
      i.push({
        key: a._parse(new de(n, c, n.path, c)),
        value: o._parse(new de(n, n.data[c], n.path, c)),
        alwaysSet: c in n.data
      });
    return n.common.async ? J.mergeObjectAsync(r, i) : J.mergeObjectSync(r, i);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, r, n) {
    return r instanceof $ ? new gt({
      keyType: e,
      valueType: r,
      typeName: x.ZodRecord,
      ...k(n)
    }) : new gt({
      keyType: me.create(),
      valueType: e,
      typeName: x.ZodRecord,
      ...k(r)
    });
  }
}
class Lt extends $ {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== v.map)
      return y(n, {
        code: m.invalid_type,
        expected: v.map,
        received: n.parsedType
      }), I;
    const i = this._def.keyType, a = this._def.valueType, o = [...n.data.entries()].map(([c, l], d) => ({
      key: i._parse(new de(n, c, n.path, [d, "key"])),
      value: a._parse(new de(n, l, n.path, [d, "value"]))
    }));
    if (n.common.async) {
      const c = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const l of o) {
          const d = await l.key, u = await l.value;
          if (d.status === "aborted" || u.status === "aborted")
            return I;
          (d.status === "dirty" || u.status === "dirty") && r.dirty(), c.set(d.value, u.value);
        }
        return { status: r.value, value: c };
      });
    } else {
      const c = /* @__PURE__ */ new Map();
      for (const l of o) {
        const d = l.key, u = l.value;
        if (d.status === "aborted" || u.status === "aborted")
          return I;
        (d.status === "dirty" || u.status === "dirty") && r.dirty(), c.set(d.value, u.value);
      }
      return { status: r.value, value: c };
    }
  }
}
Lt.create = (t, e, r) => new Lt({
  valueType: e,
  keyType: t,
  typeName: x.ZodMap,
  ...k(r)
});
class Ne extends $ {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== v.set)
      return y(n, {
        code: m.invalid_type,
        expected: v.set,
        received: n.parsedType
      }), I;
    const i = this._def;
    i.minSize !== null && n.data.size < i.minSize.value && (y(n, {
      code: m.too_small,
      minimum: i.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.minSize.message
    }), r.dirty()), i.maxSize !== null && n.data.size > i.maxSize.value && (y(n, {
      code: m.too_big,
      maximum: i.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.maxSize.message
    }), r.dirty());
    const a = this._def.valueType;
    function o(l) {
      const d = /* @__PURE__ */ new Set();
      for (const u of l) {
        if (u.status === "aborted")
          return I;
        u.status === "dirty" && r.dirty(), d.add(u.value);
      }
      return { status: r.value, value: d };
    }
    const c = [...n.data.values()].map((l, d) => a._parse(new de(n, l, n.path, d)));
    return n.common.async ? Promise.all(c).then((l) => o(l)) : o(c);
  }
  min(e, r) {
    return new Ne({
      ...this._def,
      minSize: { value: e, message: _.toString(r) }
    });
  }
  max(e, r) {
    return new Ne({
      ...this._def,
      maxSize: { value: e, message: _.toString(r) }
    });
  }
  size(e, r) {
    return this.min(e, r).max(e, r);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
Ne.create = (t, e) => new Ne({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: x.ZodSet,
  ...k(e)
});
class Xe extends $ {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== v.function)
      return y(r, {
        code: m.invalid_type,
        expected: v.function,
        received: r.parsedType
      }), I;
    function n(c, l) {
      return Ot({
        data: c,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          Mt(),
          et
        ].filter((d) => !!d),
        issueData: {
          code: m.invalid_arguments,
          argumentsError: l
        }
      });
    }
    function i(c, l) {
      return Ot({
        data: c,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          Mt(),
          et
        ].filter((d) => !!d),
        issueData: {
          code: m.invalid_return_type,
          returnTypeError: l
        }
      });
    }
    const a = { errorMap: r.common.contextualErrorMap }, o = r.data;
    if (this._def.returns instanceof rt) {
      const c = this;
      return X(async function(...l) {
        const d = new ne([]), u = await c._def.args.parseAsync(l, a).catch((C) => {
          throw d.addIssue(n(l, C)), d;
        }), f = await Reflect.apply(o, this, u);
        return await c._def.returns._def.type.parseAsync(f, a).catch((C) => {
          throw d.addIssue(i(f, C)), d;
        });
      });
    } else {
      const c = this;
      return X(function(...l) {
        const d = c._def.args.safeParse(l, a);
        if (!d.success)
          throw new ne([n(l, d.error)]);
        const u = Reflect.apply(o, this, d.data), f = c._def.returns.safeParse(u, a);
        if (!f.success)
          throw new ne([i(u, f.error)]);
        return f.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new Xe({
      ...this._def,
      args: pe.create(e).rest(je.create())
    });
  }
  returns(e) {
    return new Xe({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, r, n) {
    return new Xe({
      args: e || pe.create([]).rest(je.create()),
      returns: r || je.create(),
      typeName: x.ZodFunction,
      ...k(n)
    });
  }
}
class yt extends $ {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
yt.create = (t, e) => new yt({
  getter: t,
  typeName: x.ZodLazy,
  ...k(e)
});
class vt extends $ {
  _parse(e) {
    if (e.data !== this._def.value) {
      const r = this._getOrReturnCtx(e);
      return y(r, {
        received: r.data,
        code: m.invalid_literal,
        expected: this._def.value
      }), I;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
vt.create = (t, e) => new vt({
  value: t,
  typeName: x.ZodLiteral,
  ...k(e)
});
function tn(t, e) {
  return new Se({
    values: t,
    typeName: x.ZodEnum,
    ...k(e)
  });
}
class Se extends $ {
  constructor() {
    super(...arguments), Qe.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return y(r, {
        expected: T.joinValues(n),
        received: r.parsedType,
        code: m.invalid_type
      }), I;
    }
    if (ut(this, Qe) || Yr(this, Qe, new Set(this._def.values)), !ut(this, Qe).has(e.data)) {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return y(r, {
        received: r.data,
        code: m.invalid_enum_value,
        options: n
      }), I;
    }
    return X(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Values() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  extract(e, r = this._def) {
    return Se.create(e, {
      ...this._def,
      ...r
    });
  }
  exclude(e, r = this._def) {
    return Se.create(this.options.filter((n) => !e.includes(n)), {
      ...this._def,
      ...r
    });
  }
}
Qe = /* @__PURE__ */ new WeakMap();
Se.create = tn;
class bt extends $ {
  constructor() {
    super(...arguments), Je.set(this, void 0);
  }
  _parse(e) {
    const r = T.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(e);
    if (n.parsedType !== v.string && n.parsedType !== v.number) {
      const i = T.objectValues(r);
      return y(n, {
        expected: T.joinValues(i),
        received: n.parsedType,
        code: m.invalid_type
      }), I;
    }
    if (ut(this, Je) || Yr(this, Je, new Set(T.getValidEnumValues(this._def.values))), !ut(this, Je).has(e.data)) {
      const i = T.objectValues(r);
      return y(n, {
        received: n.data,
        code: m.invalid_enum_value,
        options: i
      }), I;
    }
    return X(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
Je = /* @__PURE__ */ new WeakMap();
bt.create = (t, e) => new bt({
  values: t,
  typeName: x.ZodNativeEnum,
  ...k(e)
});
class rt extends $ {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== v.promise && r.common.async === !1)
      return y(r, {
        code: m.invalid_type,
        expected: v.promise,
        received: r.parsedType
      }), I;
    const n = r.parsedType === v.promise ? r.data : Promise.resolve(r.data);
    return X(n.then((i) => this._def.type.parseAsync(i, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
rt.create = (t, e) => new rt({
  type: t,
  typeName: x.ZodPromise,
  ...k(e)
});
class fe extends $ {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === x.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), i = this._def.effect || null, a = {
      addIssue: (o) => {
        y(n, o), o.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (a.addIssue = a.addIssue.bind(a), i.type === "preprocess") {
      const o = i.transform(n.data, a);
      if (n.common.async)
        return Promise.resolve(o).then(async (c) => {
          if (r.value === "aborted")
            return I;
          const l = await this._def.schema._parseAsync({
            data: c,
            path: n.path,
            parent: n
          });
          return l.status === "aborted" ? I : l.status === "dirty" || r.value === "dirty" ? Ke(l.value) : l;
        });
      {
        if (r.value === "aborted")
          return I;
        const c = this._def.schema._parseSync({
          data: o,
          path: n.path,
          parent: n
        });
        return c.status === "aborted" ? I : c.status === "dirty" || r.value === "dirty" ? Ke(c.value) : c;
      }
    }
    if (i.type === "refinement") {
      const o = (c) => {
        const l = i.refinement(c, a);
        if (n.common.async)
          return Promise.resolve(l);
        if (l instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return c;
      };
      if (n.common.async === !1) {
        const c = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return c.status === "aborted" ? I : (c.status === "dirty" && r.dirty(), o(c.value), { status: r.value, value: c.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((c) => c.status === "aborted" ? I : (c.status === "dirty" && r.dirty(), o(c.value).then(() => ({ status: r.value, value: c.value }))));
    }
    if (i.type === "transform")
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!dt(o))
          return o;
        const c = i.transform(o.value, a);
        if (c instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: c };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => dt(o) ? Promise.resolve(i.transform(o.value, a)).then((c) => ({ status: r.value, value: c })) : o);
    T.assertNever(i);
  }
}
fe.create = (t, e, r) => new fe({
  schema: t,
  typeName: x.ZodEffects,
  effect: e,
  ...k(r)
});
fe.createWithPreprocess = (t, e, r) => new fe({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: x.ZodEffects,
  ...k(r)
});
class se extends $ {
  _parse(e) {
    return this._getType(e) === v.undefined ? X(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
se.create = (t, e) => new se({
  innerType: t,
  typeName: x.ZodOptional,
  ...k(e)
});
class Ce extends $ {
  _parse(e) {
    return this._getType(e) === v.null ? X(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Ce.create = (t, e) => new Ce({
  innerType: t,
  typeName: x.ZodNullable,
  ...k(e)
});
class _t extends $ {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    let n = r.data;
    return r.parsedType === v.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
_t.create = (t, e) => new _t({
  innerType: t,
  typeName: x.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...k(e)
});
class Ct extends $ {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, i = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return lt(i) ? i.then((a) => ({
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new ne(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new ne(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Ct.create = (t, e) => new Ct({
  innerType: t,
  typeName: x.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...k(e)
});
class Ft extends $ {
  _parse(e) {
    if (this._getType(e) !== v.nan) {
      const n = this._getOrReturnCtx(e);
      return y(n, {
        code: m.invalid_type,
        expected: v.nan,
        received: n.parsedType
      }), I;
    }
    return { status: "valid", value: e.data };
  }
}
Ft.create = (t) => new Ft({
  typeName: x.ZodNaN,
  ...k(t)
});
class rn extends $ {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class It extends $ {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.common.async)
      return (async () => {
        const a = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return a.status === "aborted" ? I : a.status === "dirty" ? (r.dirty(), Ke(a.value)) : this._def.out._parseAsync({
          data: a.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const i = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return i.status === "aborted" ? I : i.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: i.value
      }) : this._def.out._parseSync({
        data: i.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(e, r) {
    return new It({
      in: e,
      out: r,
      typeName: x.ZodPipeline
    });
  }
}
class xt extends $ {
  _parse(e) {
    const r = this._def.innerType._parse(e), n = (i) => (dt(i) && (i.value = Object.freeze(i.value)), i);
    return lt(r) ? r.then((i) => n(i)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
}
xt.create = (t, e) => new xt({
  innerType: t,
  typeName: x.ZodReadonly,
  ...k(e)
});
V.lazycreate;
var x;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(x || (x = {}));
const H = me.create;
Me.create;
Ft.create;
Oe.create;
Nt.create;
tt.create;
Dt.create;
mt.create;
pt.create;
Bt.create;
je.create;
_e.create;
At.create;
oe.create;
const Es = V.create;
V.strictCreate;
const Rs = ft.create;
tr.create;
ht.create;
pe.create;
gt.create;
Lt.create;
Ne.create;
Xe.create;
yt.create;
vt.create;
const wr = Se.create;
bt.create;
rt.create;
fe.create;
se.create;
Ce.create;
fe.createWithPreprocess;
It.create;
function js() {
  function t(e) {
    return os(ts.setUserCurrentProject, {
      method: "POST",
      data: {
        project_id: Number(e)
      }
    });
  }
  return { setUserCurrentProject: t };
}
const Ts = p`
  query PhasesQuery {
    phases {
      code
      label
      order
    }
  }
`;
function Ms(t) {
  return { ...wt(Ts, t) };
}
const Os = p`
  query ProjectsQuery(
    $statuses: [ProjectStatus!]
    $excludedStatuses: [ProjectStatus!]
    $page: Int
    $pageSize: Int
    $sortBy: ProjectSortableField
    $sortDirection: SortDirection
  ) {
    projects(
      statuses: $statuses
      excludedStatuses: $excludedStatuses
      page: $page
      pageSize: $pageSize
      sortBy: $sortBy
      sortDirection: $sortDirection
    ) {
      items {
        ...ProjectFragment
      }
      currentPage
    }
  }
  ${rs}
`;
function Ns(t) {
  return { ...wt(Os, t) };
}
const Vt = "mage-cache-storage";
class Ye extends Error {
}
Ye.prototype.name = "InvalidTokenError";
function Ds(t) {
  return decodeURIComponent(atob(t).replace(/(.)/g, (e, r) => {
    let n = r.charCodeAt(0).toString(16).toUpperCase();
    return n.length < 2 && (n = "0" + n), "%" + n;
  }));
}
function Bs(t) {
  let e = t.replace(/-/g, "+").replace(/_/g, "/");
  switch (e.length % 4) {
    case 0:
      break;
    case 2:
      e += "==";
      break;
    case 3:
      e += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return Ds(e);
  } catch {
    return atob(e);
  }
}
function As(t, e) {
  if (typeof t != "string")
    throw new Ye("Invalid token specified: must be a string");
  e || (e = {});
  const r = e.header === !0 ? 0 : 1, n = t.split(".")[r];
  if (typeof n != "string")
    throw new Ye(`Invalid token specified: missing part #${r + 1}`);
  let i;
  try {
    i = Bs(n);
  } catch (a) {
    throw new Ye(`Invalid token specified: invalid base64 for part #${r + 1} (${a.message})`);
  }
  try {
    return JSON.parse(i);
  } catch (a) {
    throw new Ye(`Invalid token specified: invalid json for part #${r + 1} (${a.message})`);
  }
}
const nn = (t) => As(t)?.expired_at, Us = (t) => {
  try {
    const e = nn(t), r = (/* @__PURE__ */ new Date()).toISOString();
    return new Date(e) < new Date(r);
  } catch {
    return !0;
  }
}, Ls = (t) => {
  try {
    const e = nn(t);
    let r = 0;
    if (e) {
      const n = (/* @__PURE__ */ new Date()).toISOString();
      r = Gr(e, new Date(n));
    }
    return r < 5;
  } catch {
    return !0;
  }
}, Fs = () => ce.getItem(Vt) ? JSON.parse(ce.getItem(Vt))?.customer?.signin_token : "";
function Vs() {
  return JSON.parse(ce.getItem(Vt) || "{}")?.customer || {};
}
async function Zs() {
  const t = Vs();
  if (t?.customer_id)
    return Promise.resolve(t.customer_id);
  try {
    return (await zs())?.data?.id ?? "";
  } catch (e) {
    return console.error("Error while fetching customer", e), "";
  }
}
function zs() {
  return Jr("rest/default/V1/customers/me", {
    baseURL: "/",
    method: "GET",
    withCredentials: !0,
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  });
}
const Hs = {
  en: "en",
  fr: "fr",
  de: "de",
  it: "it",
  es: "es"
}, qs = () => {
  const t = location.pathname.replace(/^\/+/g, "").split("/")[0];
  return Hs[t];
};
function an() {
  return oo("loggedIn");
}
const on = "projects.accessToken";
function Zt(t, e) {
  ce.setItem(
    on,
    JSON.stringify({
      [e]: t
    })
  );
}
function Ws() {
  try {
    return JSON.parse(ce.getItem(on) ?? "{}");
  } catch {
    return {};
  }
}
const Ir = "private-content-loaded", sn = async (t) => {
  let e = Fs();
  return e || (e = await new Promise((r) => {
    const n = (i) => {
      const a = i;
      window.removeEventListener(Ir, n);
      const o = a.detail.data;
      r(o.customer.signin_token);
    };
    window.addEventListener(Ir, n);
  })), fetch(t, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      query: `
        mutation Auth($exToken: String!) {
          Auth(exToken: $exToken) {
            token
          }
        }
      `,
      variables: {
        exToken: e
      }
    })
  });
}, Gs = async (t, e) => {
  try {
    const i = (await (await sn(t)).json()).data.Auth?.token || "";
    return Zt(i, e), i;
  } catch (r) {
    return console.error(r), "";
  }
}, Ks = (t, e) => {
  sn(t).then(
    (r) => {
      r.json().then((n) => {
        const i = n.data.Auth?.token || "";
        Zt(i, e);
      });
    },
    (r) => {
      console.error(r), Zt("", e);
    }
  );
}, Qs = () => {
  const t = window.location.hostname;
  return yr[t] ?? yr.default;
}, Js = "@gensler.com";
function Ys(t) {
  return t?.email ? (t?.email?.toLowerCase()?.trim()).endsWith(Js) : !1;
}
function Xs() {
  const [t, e] = te(() => {
    const i = cs();
    return mo(i) ? null : kr(i);
  }), [r, n] = te(() => t === null);
  return nt(() => {
    function i(a) {
      const o = a.detail.data.customer;
      e(kr(o)), n(!1);
    }
    return window.addEventListener(vr, i), () => {
      window.removeEventListener(
        vr,
        i
      );
    };
  }, []), {
    isLoading: r,
    customer: t
  };
}
function kr(t) {
  return {
    ...t,
    isGenslerCustomer: Ys(t)
  };
}
const { Provider: ec, useContext: Ae } = to();
function cn({ children: t }) {
  const { isLoading: e, customer: r } = Xs(), n = ie(() => ({
    isLoading: e,
    customer: r
  }), [e, r]);
  return /* @__PURE__ */ s(ec, { value: n, children: t });
}
const tc = "select-project-timestamp";
function rc() {
  localStorage.setItem(tc, String(Date.now()));
}
function nc(t) {
  window.dispatchEvent(
    new CustomEvent(Ko, {
      detail: { projectId: t }
    })
  );
}
function dn() {
  const { customer: t } = Ae(), { setUserCurrentProject: e } = js(), { currentProjectId: r, setCurrentProject: n } = ic();
  nt(() => {
    r || n(t?.current_project ?? null);
  }, [r, t?.current_project, n]);
  async function i(a, o) {
    if (!a)
      return;
    const c = r;
    n(a);
    try {
      if ((await e(a))?.data?.status !== "success") {
        n(c);
        return;
      }
      rc(), nc(a), us();
    } catch (l) {
      n(c), o?.(l);
    }
  }
  return {
    currentExternalProjectId: r,
    setCurrentProjectId: i
  };
}
const Sr = p`
  query GetCurrentProject {
    currentProjectId @client
  }
`;
function ic() {
  const t = Vi(), { data: e, refetch: r } = wt(Sr);
  function n(i) {
    t.writeQuery({
      query: Sr,
      data: {
        currentProjectId: i
      },
      overwrite: !0
    }), r();
  }
  return {
    currentProjectId: e?.currentProjectId,
    setCurrentProject: n
  };
}
const ac = {
  openProjectEditDialogEvent: "project-edit-dialog-open-event"
};
function rr(t) {
  window.dispatchEvent(
    new CustomEvent(
      ac.openProjectEditDialogEvent,
      {
        detail: t
      }
    )
  );
}
const oc = Or.createContext(null), sc = () => Or.useContext(oc);
function cc(t) {
  return /^[-\s]/.test(t);
}
function dc(t) {
  return /[\[\](){}]/.test(t);
}
function lc(t) {
  return /[@#$%^&*]/.test(t);
}
function uc(t) {
  return /[+=|\\]/.test(t);
}
function mc(t) {
  return /[:;"<>,?]/.test(t);
}
function pc(t) {
  return /[!~`]/.test(t);
}
const $r = 500, fc = 20, zt = er === "US";
function hc(t, e) {
  if (!t)
    return !1;
  const r = t.toLowerCase();
  return e.map(
    (i) => new RegExp(`\\b${i.toLowerCase()}\\b`, "gi")
  ).some((i) => i.test(r));
}
const ln = (t, e) => {
  const r = e === Q.TIER_13_GROUP_ID;
  return Es({
    name: H().min(1, "Project name is required").refine((n) => !cc(n), "Project names cannot start with a hyphen or space.").refine((n) => !dc(n), "Project names cannot include brackets: [ ] ( ) { }").refine((n) => !lc(n), "Project names cannot include special characters: @ # $ % ^ & *").refine((n) => !uc(n), "Project names cannot include special characters: + = | \\").refine((n) => !mc(n), "Project names cannot include special characters: ? : ; ” < > ,").refine((n) => !pc(n), "Project names cannot include special characters: ! ~ `").refine((n) => !hc(n, t), "Please enter a valid Project name."),
    country: H().min(1, "Country is required"),
    city: r ? H().nullable().optional() : H().min(1, "Please add city to your project"),
    state: r ? H().nullable().optional() : H().min(1, "State is required"),
    type: H().min(1, "Type is required"),
    phase: r ? H().nullable().optional() : H().min(1, "Phase is required"),
    size: r ? H().nullable().optional() : H().min(1, "Size is required"),
    budget: r ? H().nullable().optional() : H().min(1, "Budget is required"),
    dueMonth: r ? Rs([
      wr(Object.values(G)),
      H()
    ]).nullable().optional() : wr(Object.values(G), {
      errorMap: () => ({ message: "Select correct month and year" })
    }),
    dueYear: r ? H().nullable().optional() : H().min(1, "Select correct month and year"),
    description: r ? H().nullable().optional() : H().min(
      fc,
      "Please provide more information about your project"
    ).max(
      $r,
      `Description must be at most ${$r} characters`
    ).refine(
      (n) => n.trim().length > 1,
      "Please provide more information about your project"
    )
  });
}, gc = (t, e) => ln(t, e).omit({
  state: !0
}), yc = (t, e) => {
  const r = zt ? ln(t, e) : gc(t, e);
  return Object.keys(r.shape).filter((n) => {
    const i = r.shape[n];
    return !(i instanceof se || i instanceof Ce);
  });
}, vc = {
  name: "title",
  country: "country",
  state: "state",
  city: "city",
  type: "type",
  phase: "phase",
  size: "size",
  budget: "budget",
  dueMonth: "dueMonth",
  dueYear: "dueYear",
  description: "details"
}, bc = ["size", "budget"];
G.January + "", G.February + "", G.March + "", G.April + "", G.May + "", G.June + "", G.July + "", G.August + "", G.September + "", G.October + "", G.November + "", G.December + "", G.NotSure + "";
const kt = sc;
De(
  {}
);
function _c() {
  return /* @__PURE__ */ s("div", { className: "text-red flex-shrink-0", children: /* @__PURE__ */ s(Ga, {}) });
}
const un = Be(
  (t, e) => {
    const r = `py-0 px-4 text-gray ${t.InputProps?.endAdornment ? "pr-10" : ""}`;
    return /* @__PURE__ */ s(
      Dr,
      {
        ...t,
        ref: e,
        className: "h-9 md:h-12 rounded-full py-0 bg-[#F5F5F7] focus:border-[#B9C8F4] focus:outline-none",
        variant: "outlined",
        InputProps: {
          ...t.InputProps,
          classes: {
            notchedOutline: t.error ? "" : "border-none",
            input: r
          },
          className: "h-9 md:h-12 rounded-full p-0"
        }
      }
    );
  }
);
un.displayName = "TextField";
const Cc = Be(
  ({ initialValue: t, onClear: e, ...r }, n) => {
    const { setValue: i } = kt(), [a, o] = te(t ?? "");
    nt(() => {
      t && o(t);
    }, [t]);
    function c(d) {
      o(d.target.value), r.onChange && r.onChange(d);
    }
    function l() {
      o(""), r.onChange && r.onChange({
        target: { value: "" }
      }), i(r.name, ""), e?.();
    }
    return /* @__PURE__ */ s(
      un,
      {
        ...r,
        ref: n,
        value: a,
        InputProps: {
          ...r.InputProps,
          endAdornment: a ? /* @__PURE__ */ s(Br, { position: "end", className: "absolute right-5", children: /* @__PURE__ */ s(be, { edge: "end", tabIndex: -1, onClick: l, children: /* @__PURE__ */ s(Na, {}) }) }) : null
        },
        onChange: c
      }
    );
  }
);
Cc.displayName = "Input";
const nr = "unknown", xc = [
  { label: "10M+", from: 1e7, to: null },
  { label: "1M - 10M", from: 1e6, to: 1e7 },
  { label: "500K - 1M", from: 5e5, to: 1e6 },
  { label: "250K - 500K", from: 25e4, to: 5e5 },
  { label: "100K - 250K", from: 1e5, to: 25e4 },
  { label: "0 - 100K", from: 0, to: 1e5 },
  { label: "Unsure", value: nr }
];
mn(
  xc
);
const wc = [
  { label: "500K+", from: 5e5 },
  { label: "100K - 500K", from: 1e5, to: 5e5 },
  { label: "50K - 100K", from: 5e4, to: 1e5 },
  { label: "20K - 50K", from: 2e4, to: 5e4 },
  { label: "5K - 20K", from: 5e3, to: 2e4 },
  { label: "0 - 5K", from: 0, to: 5e3 },
  { label: "Unsure", value: nr }
], Ic = [
  { label: "50,000+", from: 5e4 },
  { label: "10,000 - 50,000", from: 1e4, to: 5e4 },
  { label: "5,000 - 10,000", from: 5e3, to: 1e4 },
  { label: "2,000 - 5,000", from: 2e3, to: 5e3 },
  { label: "500 - 2,000", from: 500, to: 2e3 },
  { label: "0 - 500", from: 0, to: 500 },
  { label: "Unsure", value: nr }
], kc = er === "EU" ? Ic : wc;
mn(kc);
function mn(t) {
  return t.map((e) => {
    const { label: r, from: n, to: i, value: a, ...o } = e;
    return a ? { ...e, value: `${e.value}` } : {
      label: r,
      value: `${n}-${i}`,
      from: n,
      to: i,
      ...o
    };
  });
}
const Sc = Be(
  ({ field: t, type: e, label: r, value: n, isSelected: i, onChangeAnalyticsCallback: a }, o) => {
    const { t: c } = W(), { register: l } = kt(), d = l(t);
    return /* @__PURE__ */ w("label", { ref: o, className: "flex items-center mb-0", tabIndex: 0, children: [
      /* @__PURE__ */ s(
        "input",
        {
          type: e,
          id: `${t}-${n}`,
          value: n,
          ...d,
          onChange: (u) => {
            d.onChange(u), a?.(r, n);
          },
          className: "hidden"
        }
      ),
      /* @__PURE__ */ s(
        "span",
        {
          className: `px-3 py-1.5 md:px-4 md:py-3 border-none rounded-full cursor-pointer ${i ? "bg-[#4D4E58] text-white" : "hover:bg-gray-200 bg-[#F5F5F6]"}`,
          children: c(r)
        }
      )
    ] });
  }
);
Sc.displayName = "OptionInput";
const Te = Be(
  ({
    field: t,
    type: e,
    label: r = "",
    infoText: n,
    hasError: i,
    withLabel: a = !0,
    withDivider: o = !0,
    withPlaceholder: c = !1,
    children: l
  }, d) => /* @__PURE__ */ w(
    "div",
    {
      ref: d,
      className: "flex flex-col gap-3 transition-all duration-300 ease-in-out",
      children: [
        /* @__PURE__ */ s(
          pn,
          {
            field: t,
            fieldInfoType: "inline",
            type: e,
            hasError: i,
            withLabel: a,
            infoText: n,
            label: r,
            withDivider: o,
            withPlaceholder: c
          }
        ),
        l
      ]
    },
    t
  )
);
function pn({
  field: t,
  label: e,
  withLabel: r,
  hasError: n,
  withDivider: i,
  withPlaceholder: a,
  fieldInfoType: o,
  type: c,
  infoText: l
}) {
  const { t: d } = W();
  return r ? /* @__PURE__ */ w("div", { className: "flex items-center gap-2 min-w-0 overflow-hidden", children: [
    /* @__PURE__ */ s(
      Bi,
      {
        htmlFor: t,
        className: "text-base md:text-md font-semibold text-gray-700 mb-0 truncate min-w-0 flex-shrink-0",
        style: { maxWidth: "80%" },
        title: e ? d(e) : void 0,
        children: e ? d(e) : null
      }
    ),
    o === "inline" && l ? /* @__PURE__ */ s(
      F,
      {
        variant: "caption",
        className: "text-gray-500 truncate block min-w-0",
        title: d(l),
        children: `(${d(l)})`
      }
    ) : null,
    c === "multiValue" ? /* @__PURE__ */ s(
      F,
      {
        variant: "caption",
        className: "text-gray-500 truncate block min-w-0",
        title: d("Select all that apply"),
        children: `(${d("Select all that apply")})`
      }
    ) : null,
    o === "tooltip" && l ? /* @__PURE__ */ s(
      ja,
      {
        title: d(l),
        PopperProps: $c,
        placement: "right-end",
        className: "p-0 hidden md:block flex-shrink-0",
        children: /* @__PURE__ */ s(be, { children: /* @__PURE__ */ s(Va, {}) })
      }
    ) : null,
    n ? /* @__PURE__ */ s(_c, {}) : null
  ] }) : i ? /* @__PURE__ */ s(Ar, {}) : a ? /* @__PURE__ */ s("div", { style: { height: "32px" } }) : null;
}
const $c = {
  sx: {
    zIndex: 999999943
  }
};
Te.displayName = "FormField";
const Pc = "singleValue", Ec = "singleValue", Rc = "singleValue", jc = Be(
  ({ fieldRefs: t, index: e, cityComponent: r, stateComponent: n, countryComponent: i }, a) => {
    const { t: o } = W(), l = kt()?.formState?.errors ?? {};
    return /* @__PURE__ */ w(
      "div",
      {
        ref: (d) => {
          t.current[e] = d, typeof a == "function" ? a(d) : a && (a.current = d);
        },
        className: "flex flex-col w-full gap-4",
        children: [
          /* @__PURE__ */ w("div", { className: "flex flex-row w-full", children: [
            /* @__PURE__ */ s("div", { className: zt ? "w-1/2 pr-2" : "w-full", children: /* @__PURE__ */ s(
              Te,
              {
                field: "city",
                label: o("Location"),
                type: Pc,
                withLabel: !0,
                hasError: !!l?.city || !!l?.state || !!l?.country,
                children: r
              }
            ) }),
            zt ? /* @__PURE__ */ s("div", { className: "w-1/2 pl-2", children: /* @__PURE__ */ s(
              Te,
              {
                field: "state",
                withLabel: !1,
                withDivider: !1,
                withPlaceholder: !0,
                type: Ec,
                children: n
              }
            ) }) : null
          ] }),
          /* @__PURE__ */ s("div", { className: "w-full", children: /* @__PURE__ */ s(
            Te,
            {
              field: "country",
              withLabel: !1,
              withDivider: !1,
              withPlaceholder: !1,
              type: Rc,
              children: i
            }
          ) })
        ]
      }
    );
  }
);
jc.displayName = "Location";
const Tc = "singleValue", Mc = "singleValue", Oc = Be(
  ({ fieldRefs: t, index: e, monthComponent: r, yearComponent: n, readonly: i = !1 }, a) => {
    const { t: o } = W(), l = kt()?.formState?.errors ?? {};
    return /* @__PURE__ */ w(
      "div",
      {
        ref: (d) => {
          t.current[e] = d, typeof a == "function" ? a(d) : a && (a.current = d);
        },
        className: "flex flex-col w-full gap-3",
        children: [
          /* @__PURE__ */ s("div", { className: "flex flex-row w-full", children: /* @__PURE__ */ s(
            pn,
            {
              type: "singleValue",
              label: o("Estimated completion date"),
              infoText: o("Project end date"),
              fieldInfoType: "inline",
              withLabel: !0,
              hasError: !!l?.dueMonth || !!l?.dueYear
            }
          ) }),
          /* @__PURE__ */ s(
            "div",
            {
              className: `flex flex-col gap-1 md:gap-4 relative ${i ? "" : "min-h-[80px] md:min-h-[112px]"}`,
              children: /* @__PURE__ */ w("div", { className: "flex flex-row w-full", children: [
                /* @__PURE__ */ s("div", { className: "w-1/2 pr-2", children: /* @__PURE__ */ s(
                  Te,
                  {
                    field: "dueMonth",
                    type: Tc,
                    withLabel: !1,
                    withDivider: !1,
                    children: r
                  }
                ) }),
                /* @__PURE__ */ s("div", { className: "w-1/2 pl-2", children: /* @__PURE__ */ s(
                  Te,
                  {
                    field: "dueYear",
                    type: Mc,
                    withLabel: !1,
                    withDivider: !1,
                    children: n
                  }
                ) })
              ] })
            }
          )
        ]
      }
    );
  }
);
Oc.displayName = "Timeline";
const fn = (/* @__PURE__ */ new Date()).getFullYear();
fn.toString();
(/* @__PURE__ */ new Date()).getMonth();
Nc();
function Nc() {
  return Array.from({ length: 6 }, (t, e) => {
    const r = (fn + e).toString();
    return { label: r, value: r };
  });
}
const Dc = {
  AL: "Alabama",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  DC: "District of Columbia",
  FL: "Florida",
  GA: "Georgia",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming"
}, Bc = [
  { code: "AB", name: "Alberta", value: "66" },
  { code: "BC", name: "British Columbia", value: "67" },
  { code: "MB", name: "Manitoba", value: "68" },
  { code: "NL", name: "Newfoundland and Labrador", value: "69" },
  { code: "NB", name: "New Brunswick", value: "70" },
  { code: "NS", name: "Nova Scotia", value: "71" },
  { code: "NT", name: "Northwest Territories", value: "72" },
  { code: "NU", name: "Nunavut", value: "73" },
  { code: "ON", name: "Ontario", value: "74" },
  { code: "PE", name: "Prince Edward Island", value: "75" },
  { code: "QC", name: "Quebec", value: "76" },
  { code: "SK", name: "Saskatchewan", value: "77" },
  { code: "YT", name: "Yukon Territory", value: "78" }
], Ac = {
  AD: "Andorra",
  AT: "Austria",
  BE: "Belgium",
  BG: "Bulgaria",
  HR: "Croatia",
  CZ: "Czechia",
  DK: "Denmark",
  EE: "Estonia",
  FI: "Finland",
  FR: "France",
  DE: "Germany",
  GR: "Greece",
  HU: "Hungary",
  IE: "Ireland",
  IT: "Italy",
  LV: "Latvia",
  LT: "Lithuania",
  LU: "Luxembourg",
  MC: "Monaco",
  NL: "Netherlands",
  PL: "Poland",
  PT: "Portugal",
  RO: "Romania",
  SM: "San Marino",
  SK: "Slovakia",
  SI: "Slovenia",
  ES: "Spain",
  SE: "Sweden",
  CH: "Switzerland",
  GB: "United Kingdom",
  IL: "Israel",
  SA: "Saudi Arabia",
  AE: "United Arab Emirates",
  TR: "Turkey",
  KW: "Kuwait",
  QA: "Qatar",
  BH: "Bahrain",
  US: "United States",
  MT: "Malta",
  NO: "Norway"
}, Uc = {
  CA: "Canada",
  US: "United States"
};
Object.entries(Ac).map(
  ([t, e]) => ({
    label: e,
    value: t
  })
);
Object.entries(Uc).map(
  ([t, e]) => ({
    label: e,
    value: t
  })
);
Object.entries(Dc).map(([t, e]) => ({
  label: e,
  value: e
}));
Bc.map(({ name: t }) => ({
  label: t,
  value: t
}));
function Lc(t, e) {
  return !t || !e ? !1 : t.userRef === e?.customer_id;
}
function hn() {
  const { customer: t } = Ae();
  function e(n) {
    return n ? Fc(n, t?.groupId ?? null) : !1;
  }
  function r(n) {
    return Lc(n, t);
  }
  return { isProjectDataComplete: e, isProjectEditable: r };
}
function Fc(t, e) {
  return yc(
    [],
    e
  ).filter(
    (n) => !bc.includes(
      n
    )
  ).every((n) => {
    const i = vc[n];
    return !!t[i];
  });
}
const Vc = 1e9;
function gn({ variables: t, options: e } = {
  variables: {},
  options: {}
}) {
  return Ns({
    variables: {
      page: 1,
      pageSize: Vc,
      sortDirection: Qr.Asc,
      ...t
    },
    fetchPolicy: "cache-first",
    ...e
  });
}
function Zc(t) {
  const {
    data: e,
    loading: r,
    error: n,
    refetch: i
  } = gn({
    options: {
      skip: !t
    }
  }), { projects: a, activeProjects: o } = ie(() => {
    const c = {}, l = {};
    return e?.projects.items.forEach((d) => {
      c[d.externalId] = d, d.status === Y.Active && (l[d.externalId] = d);
    }), {
      projects: c,
      activeProjects: l
    };
  }, [e?.projects.items]);
  return { loading: r, projects: a, activeProjects: o, error: n, refetch: i };
}
const yn = De({});
function zc({
  shouldFetch: t = !0,
  children: e
}) {
  const { loading: r, projects: n, activeProjects: i, error: a, refetch: o } = Zc(t), { setCurrentProjectId: c } = dn(), { isProjectDataComplete: l } = hn(), d = ie(() => {
    function u(f) {
      const b = n[f];
      if (b) {
        if (!l(b)) {
          rr({
            projectId: Number(f),
            successCallback: () => {
              c(f);
            }
          });
          return;
        }
        c(f);
      }
    }
    return {
      projects: n,
      projectsLoading: r,
      projectsError: a,
      refetch: o,
      setCurrentProject: u,
      activeProjects: i
    };
  }, [
    n,
    i,
    r,
    a,
    o,
    l,
    c
  ]);
  return /* @__PURE__ */ s(yn.Provider, { value: d, children: e });
}
function Hc() {
  const t = Kt(yn);
  if (!t)
    throw new Error(
      "useProjectsProvider must be used within a ProjectsProvider"
    );
  return t;
}
function qc() {
  const { currentExternalProjectId: t, setCurrentProjectId: e } = dn(), { projects: r, projectsLoading: n } = Hc();
  return {
    currentProject: t ? r[t] : null,
    loading: n,
    setCurrentProjectId: e
  };
}
function Wc() {
  function t(e) {
    rr({
      projectId: e
    });
  }
  return { onEdit: t };
}
function Gc({ children: t }) {
  const e = !!an();
  return /* @__PURE__ */ s(cn, { children: /* @__PURE__ */ s(zc, { shouldFetch: e, children: t }) });
}
const Pr = {
  [Y.Active]: "#7DC64E",
  [Y.OnHold]: "#D18023",
  [Y.Completed]: "#425270",
  [Y.Canceled]: "#DE6CAF",
  [Y.Archived]: "#CECECE"
}, Kc = {
  [Y.Active]: "Active",
  [Y.Archived]: "Archived",
  [Y.Canceled]: "Canceled",
  [Y.Completed]: "Completed",
  [Y.OnHold]: "On Hold"
};
function Qc(t) {
  const { data: e } = Ms(), { customer: r, isLoading: n } = Ae(), {
    loading: i,
    error: a,
    data: o
  } = gn();
  return {
    projectsViewModel: ie(() => {
      if (!o || i || a || n)
        return {
          projectsLoading: i,
          projects: [],
          projectsMap: {},
          projectsMapPerExternalId: {},
          phases: {}
        };
      const l = o.projects.items.filter((f) => f.status !== Y.Archived).map((f) => ({
        id: f.id,
        title: f.title,
        isCurrent: f.externalId?.toString() === t,
        phase: f.phase,
        status: f.status,
        externalId: f.externalId,
        statusLabel: Kc[f.status],
        editable: f.userRef === r?.customer_id
      })), d = Y.Active;
      return l.sort((f, b) => f.isCurrent ? -1 : b.isCurrent ? 1 : f.status === d && b.status !== d ? -1 : f.status !== d && b.status === d ? 1 : 0), {
        projectsLoading: i,
        projects: l,
        projectsMap: o.projects.items.reduce(
          (f, b) => (f[b.id] = b, f),
          {}
        ),
        projectsMapPerExternalId: o.projects.items.reduce((f, b) => (f[b.externalId] = b, f), {}),
        phases: e?.phases?.reduce((f, b) => (f[b.code] = b, f), {}) ?? {}
      };
    }, [
      t,
      r?.customer_id,
      n,
      e?.phases,
      o,
      a,
      i
    ])
  };
}
const Jc = (t) => /* @__PURE__ */ cr.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", ...t }, /* @__PURE__ */ cr.createElement("path", { fill: "#4D4E58", fillRule: "evenodd", d: "M4.125 10.375a6.25 6.25 0 1 1 11.09 3.956l4.977 4.977a.625.625 0 1 1-.884.884l-4.977-4.978a6.25 6.25 0 0 1-10.206-4.84Zm6.25-5a5 5 0 1 0 0 10 5 5 0 0 0 0-10Z", clipRule: "evenodd" }));
function Yc({ search: t, onChange: e, analytics: r }) {
  function n(o) {
    e(o.target.value);
  }
  const { t: i } = W(), { projectsSearchListInput: a } = r;
  return /* @__PURE__ */ s(
    Dr,
    {
      variant: "filled",
      placeholder: i("Search"),
      hiddenLabel: !0,
      size: "small",
      fullWidth: !0,
      value: t,
      onChange: n,
      inputProps: { ...a },
      InputProps: {
        startAdornment: /* @__PURE__ */ s(Br, { position: "start", children: /* @__PURE__ */ s(Jc, {}) })
      }
    }
  );
}
const Xc = [
  "Auth",
  "Board",
  "BoardOwnerDetails",
  "BoardProjects",
  "BoardUsers",
  "Boards",
  "ConsideringSampledBoard",
  "ConsideringSampledBoardBrands",
  "ConsideringSampledBoardItems",
  "ConsideringSampledBoards",
  "ItemFilters",
  "ItemNotes",
  "Items",
  "ItemsCount",
  "MaterialExport",
  "MaterialExportTemplates",
  "Moodboard",
  "MoodboardComments",
  "PinterestBoards",
  "PinterestPinsOnBoard",
  "PublicBoard",
  "PublicMaterialExport",
  "RenewToken",
  "Tags"
], ed = [
  "archiveMoodboardThreads",
  "checkConsideringSampledBoard",
  "copyBoard",
  "copyItem",
  "copyMoodboard",
  "createBoard",
  "createBoardUser",
  "createItem",
  "createItemNote",
  "createItems",
  "createMaterialExportTemplate",
  "createMoodboard",
  "createMoodboardComment",
  "createRepOrder",
  "deleteBoard",
  "deleteBoardProduct",
  "deleteBoardUser",
  "deleteItem",
  "deleteItemNote",
  "deleteMaterialExportTemplate",
  "deleteMoodboard",
  "deleteMoodboardComment",
  "pinterestAuthExchangeCode",
  "pinterestAuthRefreshToken",
  "readItemNotes",
  "removeBackgroundForMoodBoard",
  "unarchiveMoodboardThreads",
  "updateBoard",
  "updateBoardUser",
  "updateConsideringSampledBoardBrand",
  "updateItem",
  "updateItemNote",
  "updateItems",
  "updateMaterialExportTemplate",
  "updateMoodboard",
  "updateMoodboardComment",
  "updateSampledBrands"
], td = [
  "healthcheck",
  "watchBoardSummary",
  "watchItemNotes",
  "watchMoodboardComments",
  "watchMoodboardSummary"
], rd = [
  ...td,
  ...ed,
  ...Xc
];
var vn = /* @__PURE__ */ ((t) => (t.Brand = "BRAND", t.RepSelections = "REP_SELECTIONS", t.Sampled = "SAMPLED", t.User = "USER", t))(vn || {});
const nd = {
  appDataStorageKey: "mage-cache-storage"
}, { appDataStorageKey: Er } = nd, Rr = {
  "materialbank.test": "http://localhost:8080",
  "dev.materialbank.com": "https://mb-boards-dev.usw2.materialbank.com",
  "uat2.materialbank.com": "https://mb-boards-uat.usw2.materialbank.com",
  "uat.materialbank.eu": "https://mb-boards-uat.dev.materialbank.eu",
  "www.materialbank.eu": "https://boards.p.materialbank.eu",
  "www.materialbank.com": "https://boards.p.materialbank.com",
  default: "https://mb-boards-uat.usw2.materialbank.com"
};
p`
  mutation ArchiveMoodboardThreadsMutation(
    $moodboardId: UUID!
    $threadIds: [UUID!]!
  ) {
    archiveMoodboardThreads(moodboardId: $moodboardId, threadIds: $threadIds)
  }
`;
p`
  mutation CheckConsideringBoard($id: UUID!) {
    checkConsideringSampledBoard(id: $id) {
      id
    }
  }
`;
p`
  mutation CopyBoard($id: UUID!) {
    copyBoard(id: $id) {
      name
    }
  }
`;
p`
  mutation CopyMoodboardMutation($id: UUID!) {
    copyMoodboard(id: $id) {
      id
      name
    }
  }
`;
p`
  mutation CopyToBoardMutation($id: UUID!, $boardId: UUID!) {
    copyItem(id: $id, boardId: $boardId) {
      id
    }
  }
`;
p`
  mutation CreateBoard($input: createBoard!) {
    createBoard(input: $input) {
      name
      slug
    }
  }
`;
p`
  mutation CreateBoardUser($boardId: UUID!, $input: createBoardUser!) {
    createBoardUser(boardId: $boardId, input: $input) {
      id
      firstName
      lastName
      email
      unregisteredEmail
      type
    }
  }
`;
p`
  mutation CreateItemMutation($boardId: UUID!, $input: ItemInput!) {
    createItem(boardId: $boardId, input: $input) {
      id
      name
      type
    }
  }
`;
p`
  mutation CreateItemNoteMutation($itemId: UUID!, $input: ItemNoteInput!) {
    createItemNote(itemId: $itemId, input: $input) {
      id
      isPublic
      note
      createdAt
      updatedAt
      user {
        userRef
        firstName
        lastName
        imageUrl
      }
    }
  }
`;
p`
  mutation CreateItemsMutation($boardId: UUID!, $input: [ItemInput!]!) {
    createItems(boardId: $boardId, input: $input) {
      id
      name
      type
    }
  }
`;
p`
  mutation CreateMaterialExportTemplate(
    $input: CreateMaterialExportTemplateInput!
  ) {
    createMaterialExportTemplate(input: $input) {
      id
      name
      items {
        key
        isActive
        position
      }
    }
  }
`;
p`
  mutation CreateMoodboardCommentMutation(
    $moodboardId: UUID!
    $input: createMoodboardComment!
  ) {
    createMoodboardComment(moodboardId: $moodboardId, input: $input) {
      id
      comment
      createdAt
      updatedAt
      user {
        userRef
        firstName
        lastName
        imageUrl
      }
    }
  }
`;
p`
  mutation CreateMoodboardMutation($boardID: UUID!, $input: MoodboardInput!) {
    createMoodboard(boardID: $boardID, input: $input) {
      id
      name
    }
  }
`;
p`
  mutation CreateRepOrderMutation(
    $token: String!
    $input: CreateRepOrderInput!
  ) {
    createRepOrder(token: $token, input: $input) {
      orderId
      orderNumber
      deliveryMessage
    }
  }
`;
p`
  mutation DeleteBoardProduct($boardId: UUID!, $productRef: Int!) {
    deleteBoardProduct(boardId: $boardId, productRef: $productRef) {
      id
    }
  }
`;
p`
  mutation DeleteBoardItemMutation($id: UUID!) {
    deleteItem(id: $id) {
      id
    }
  }
`;
p`
  mutation DeleteBoard($id: UUID!) {
    deleteBoard(id: $id)
  }
`;
p`
  mutation DeleteBoardUser($id: UUID!) {
    deleteBoardUser(id: $id)
  }
`;
p`
  mutation DeleteItemNoteMutation($noteId: UUID!) {
    deleteItemNote(noteId: $noteId) {
      id
      isPublic
    }
  }
`;
p`
  mutation DeleteMaterialExportTemplate($id: UUID!) {
    deleteMaterialExportTemplate(id: $id)
  }
`;
p`
  mutation DeleteMoodboardCommentMutation($commentId: UUID!) {
    deleteMoodboardComment(commentId: $commentId) {
      id
      comment
      createdAt
      updatedAt
      user {
        userRef
        firstName
        lastName
        imageUrl
      }
    }
  }
`;
p`
  mutation DeleteMoodboardMutation($id: UUID!) {
    deleteMoodboard(id: $id) {
      id
    }
  }
`;
p`
  mutation RemoveBackgroundForMoodBoardMutation(
    $moodboardId: UUID!
    $imageUrl: String!
  ) {
    removeBackgroundForMoodBoard(moodboardId: $moodboardId, imageUrl: $imageUrl)
  }
`;
p`
  mutation PinterestAuthExchangeCode($code: String!, $redirectUri: String!) {
    pinterestAuthExchangeCode(code: $code, redirectUri: $redirectUri) {
      accessToken
      refreshToken
      responseType
      tokenType
      expiresIn
      refreshTokenExpiresIn
      scope
    }
  }
`;
p`
  mutation PinterestAuthRefreshToken($refreshToken: String!) {
    pinterestAuthRefreshToken(refreshToken: $refreshToken) {
      accessToken
      refreshToken
      responseType
      tokenType
      expiresIn
      refreshTokenExpiresIn
      scope
    }
  }
`;
p`
  mutation ReadItemNotes($itemId: UUID!) {
    readItemNotes(itemId: $itemId)
  }
`;
p`
  mutation UnarchiveMoodboardThreadsMutation(
    $moodboardId: UUID!
    $threadIds: [UUID!]!
  ) {
    unarchiveMoodboardThreads(moodboardId: $moodboardId, threadIds: $threadIds)
  }
`;
p`
  mutation UpdateBoardMutation($id: UUID!, $input: updateBoard!) {
    updateBoard(id: $id, input: $input) {
      id
      name
      description
      projectRef
      publicRef
      showOwnerDetails
      distributeToReps
      type
      activeMoodboardId
    }
  }
`;
p`
  mutation UpdateBoardUser($id: UUID!, $input: updateBoardUser!) {
    updateBoardUser(id: $id, input: $input) {
      id
      firstName
      lastName
      email
      unregisteredEmail
      type
    }
  }
`;
p`
  mutation UpdateItemMutation($id: UUID!, $input: ItemInput!) {
    updateItem(id: $id, input: $input) {
      id
      position
      name
      status
      attributes {
        name
        value
      }
      tags {
        id
        name
      }
    }
  }
`;
p`
  mutation UpdateItemNoteMutation($noteId: UUID!, $input: ItemNoteInput!) {
    updateItemNote(noteId: $noteId, input: $input) {
      id
      isPublic
      note
      createdAt
      updatedAt
      user {
        firstName
        lastName
        imageUrl
        userRef
      }
    }
  }
`;
p`
  mutation UpdateItemsMutation($input: [ItemInput!]) {
    updateItems(input: $input) {
      id
      position
      name
      status
      attributes {
        name
        value
      }
      tags {
        id
        name
      }
    }
  }
`;
p`
  mutation UpdateMaterialExportTemplate(
    $id: UUID!
    $input: UpdateMaterialExportTemplateInput!
  ) {
    updateMaterialExportTemplate(id: $id, input: $input) {
      id
      name
      items {
        key
        isActive
        position
      }
    }
  }
`;
p`
  mutation UpdateMoodboardCommentMutation(
    $commentId: UUID!
    $comment: String!
  ) {
    updateMoodboardComment(commentId: $commentId, comment: $comment) {
      id
      comment
      createdAt
      updatedAt
      user {
        userRef
        firstName
        lastName
        imageUrl
      }
    }
  }
`;
p`
  mutation UpdateMoodboardMutation($id: UUID!, $input: MoodboardInput!) {
    updateMoodboard(id: $id, input: $input) {
      id
      name
      payload
    }
  }
`;
p`
  mutation UpdateSampledBrandsMutation(
    $boardId: UUID!
    $brands: [String!]!
    $status: BrandStatus!
  ) {
    updateSampledBrands(boardId: $boardId, brands: $brands, status: $status) {
      name
    }
  }
`;
p`
  mutation UpdateSampledBrandsMutation(
    $boardId: UUID!
    $brands: [String!]!
    $status: BrandStatus!
  ) {
    updateSampledBrands(boardId: $boardId, brands: $brands, status: $status) {
      name
      logo
      status
    }
  }
`;
const bn = p`
  fragment BoardDetails on Board {
    id
    itemsCount(filter: $filter)
  }
`;
p`
  ${bn}

  query BoardDetailsQuery($slug: String!, $filter: ItemFilterInput) {
    Board(slug: $slug) {
      ...BoardDetails
    }
  }
`;
p`
  ${bn}

  query PublicBoardDetailsQuery($token: String!, $filter: ItemFilterInput) {
    PublicBoard(token: $token) {
      ...BoardDetails
    }
  }
`;
const id = p`
  fragment ProductFields on Product {
    _id
    entity_id
    name
    url
    brand_product
    price_sign
    manufacturer
    residential_commercial
    associated_finish_products
    imageUrl
    thumbnailImageUrl
    ss_item_type
    family_id
    sku
    ss_facet_color_filter {
      entity_id
    }
    categories
    taxonomy_l2
    taxonomy_l3
    taxonomy_l4
    install_images
    qty
    components {
      items {
        name
      }
    }
    product_finish_type
    is_orderable
    is_digital
    status
    install_images
  }
`, _n = p`
  fragment BoardItemFields on Item {
    id
    type
    name
    imageUrl
    description
    position
    sampled
    source
    status
    associatedProduct {
      _id
      imageUrl
      name
      manufacturer
    }
    attributes {
      name
      value
    }
    tags {
      id
      name
    }
    product {
      ...ProductFields
    }
  }
  ${id}
`;
p`
  query BoardsQuery(
    $sort: BoardsSortableField
    $order: Order
    $projectRef: String
    $archived: Boolean
    $brandRef: String
    $limit: Int
    $filter: BoardFilterInput
    $itemSort: ItemSortableField
    $itemSortDirection: ItemSortDirection
    $itemFilter: ItemFilterInput
    $itemPage: Int
    $itemPageSize: Int
  ) {
    Boards(
      sort: $sort
      order: $order
      projectRef: $projectRef
      archived: $archived
      brandRef: $brandRef
      limit: $limit
      filter: $filter
    ) {
      id
      name
      slug
      projectRef
      publicRef
      showOwnerDetails
      permission
      itemFilters {
        statuses
        tags
        brands
      }
      itemsCount(filter: $itemFilter)
      itemsPaginated(
        sortBy: $itemSort
        sortDirection: $itemSortDirection
        page: $itemPage
        pageSize: $itemPageSize
        filter: $itemFilter
      ) {
        totalPages
        items {
          ...BoardItemFields
        }
      }
    }
  }
  ${_n}
`;
p`
  query PublicBoardItemsQuery(
    $slug: String!
    $itemSort: ItemSortableField
    $itemSortDirection: ItemSortDirection
    $itemPage: Int
    $itemPageSize: Int
    $itemFilter: ItemFilterInput
  ) {
    PublicBoard(token: $slug) {
      id
      name
      slug
      publicRef
      showOwnerDetails
      permission
      itemFilters {
        statuses
        tags
        brands
      }
      itemsPaginated(
        sortBy: $itemSort
        sortDirection: $itemSortDirection
        page: $itemPage
        pageSize: $itemPageSize
        filter: $itemFilter
      ) {
        totalPages
        items {
          ...BoardItemFields
        }
      }
    }
  }
  ${_n}
`;
const Cn = p`
  fragment BoardDetails on Board {
    id
    name
    type
    archived
    name
    projectRef
    description
    publicRef
    permission
    showOwnerDetails
    distributeToReps
    coverUrl
    hasCustomCover
    coverItemRef
    tags {
      id
      name
    }
    moodboards {
      id
      name
    }
    activeMoodboardId
    itemsPaginated(sortBy: $sort) {
      items {
        id
        type
        name
        imageUrl
        description
        position
        sampled
        source
        status
        associatedProduct {
          _id
          imageUrl
          name
          manufacturer
        }
        attributes {
          name
          value
        }
        tags {
          id
          name
        }
        product {
          _id
          entity_id
          name
          url
          brand_product
          price_sign
          manufacturer
          residential_commercial
          associated_finish_products
          imageUrl
          thumbnailImageUrl
          ss_item_type
          family_id
          sku
          ss_facet_color_filter {
            entity_id
          }
          categories
          taxonomy_l2
          taxonomy_l3
          taxonomy_l4
          install_images
          qty
          components {
            items {
              name
            }
          }
          product_finish_type
          is_orderable
          is_digital
          status
          install_images
          is_gps_compliant
          country_permission
          state_permission
          project_type_restrictions
          primary_child_id
          color_variants {
            items {
              entity_id
              is_unavailable
            }
          }
        }
      }
    }
  }
`;
p`
  ${Cn}

  query BoardDetailsQuery($slug: String!, $sort: ItemSortableField) {
    Board(slug: $slug) {
      ...BoardDetails
    }
  }
`;
p`
  ${Cn}

  query PublicBoardDetailsQuery($slug: String!, $sort: ItemSortableField) {
    PublicBoard(token: $slug) {
      ...BoardDetails
    }
  }
`;
const ad = p`
  fragment ProductFields on Product {
    _id
    entity_id
    name
    url
    brand_product
    price_sign
    manufacturer
    residential_commercial
    associated_finish_products
    imageUrl
    thumbnailImageUrl
    ss_item_type
    family_id
    sku
    ss_facet_color_filter {
      entity_id
    }
    categories
    taxonomy_l2
    taxonomy_l3
    taxonomy_l4
    install_images
    qty
    components {
      items {
        name
      }
    }
    product_finish_type
    is_orderable
    is_digital
    status
    install_images
  }
`, od = p`
  fragment BoardItemFields on Item {
    id
    type
    name
    imageUrl
    description
    position
    sampled
    source
    status
    associatedProduct {
      _id
      imageUrl
      name
      manufacturer
    }
    attributes {
      name
      value
    }
    tags {
      id
      name
    }
    product {
      ...ProductFields
    }
  }
  ${ad}
`;
p`
  query BoardDetails(
    $slug: String!
    $itemSort: ItemSortableField
    $itemSortDirection: ItemSortDirection
    $itemPage: Int
    $itemPageSize: Int
    $itemFilter: ItemFilterInput
  ) {
    Board(slug: $slug) {
      id
      name
      slug
      publicRef
      projectRef
      showOwnerDetails
      permission
      itemFilters {
        statuses
        tags
        brands
      }
      type
      itemsPaginated(
        sortBy: $itemSort
        sortDirection: $itemSortDirection
        page: $itemPage
        pageSize: $itemPageSize
        filter: $itemFilter
      ) {
        totalPages
        items {
          ...BoardItemFields
        }
      }
    }
  }
  ${od}
`;
p`
  query BoardDetailsTagsQuery($slug: String!) {
    Board(slug: $slug) {
      tags {
        id
        name
      }
    }
  }
`;
p`
  query PublicBoardDetailsTagsQuery($slug: String!) {
    PublicBoard(token: $slug) {
      tags {
        id
        name
      }
    }
  }
`;
const sd = p`
  fragment ProductFields on Product {
    _id
    entity_id
    name
    url
    brand_product
    price_sign
    manufacturer
    residential_commercial
    associated_finish_products
    imageUrl
    thumbnailImageUrl
    ss_item_type
    family_id
    sku
    ss_facet_color_filter {
      entity_id
    }
    categories
    taxonomy_l2
    taxonomy_l3
    taxonomy_l4
    install_images
    qty
    components {
      items {
        name
      }
    }
    product_finish_type
    is_orderable
    is_digital
    status
    install_images
  }
`, xn = p`
  fragment BoardItemFields on Item {
    id
    status
    associatedProduct {
      name
      manufacturer
    }
    associatedProductRef
    product {
      ...ProductFields
    }
  }
  ${sd}
`;
p`
  query BoardItemsQuery(
    $slug: String!
    $itemSort: ItemSortableField
    $itemSortDirection: ItemSortDirection
    $itemPage: Int
    $itemPageSize: Int
    $itemFilter: ItemFilterInput
  ) {
    Board(slug: $slug) {
      itemsPaginated(
        sortBy: $itemSort
        sortDirection: $itemSortDirection
        page: $itemPage
        pageSize: $itemPageSize
        filter: $itemFilter
      ) {
        totalPages
        items {
          ...BoardItemFields
        }
      }
    }
  }
  ${xn}
`;
p`
  query BoardItemsQueryPublic(
    $slug: String!
    $itemSort: ItemSortableField
    $itemSortDirection: ItemSortDirection
    $itemPage: Int
    $itemPageSize: Int
    $itemFilter: ItemFilterInput
  ) {
    PublicBoard(token: $slug) {
      itemsPaginated(
        sortBy: $itemSort
        sortDirection: $itemSortDirection
        page: $itemPage
        pageSize: $itemPageSize
        filter: $itemFilter
      ) {
        items {
          ...BoardItemFields
        }
      }
    }
  }
  ${xn}
`;
p`
  query BoardOwnerDetailsQuery($boardId: UUID!) {
    BoardOwnerDetails(boardId: $boardId) {
      firstName
      lastName
      companyName
      location
      imageUrl
      rep
      email
    }
  }
`;
p`
  query BoardProjects {
    BoardProjects
  }
`;
p`
  query BoardsQuery(
    $sort: BoardsSortableField
    $order: Order
    $projectRef: String
    $archived: Boolean
    $brandRef: String
    $limit: Int
  ) {
    Boards(
      sort: $sort
      order: $order
      projectRef: $projectRef
      archived: $archived
      brandRef: $brandRef
      limit: $limit
    ) {
      id
      name
      slug
    }
  }
`;
p`
  query BoardsQuery(
    $sort: BoardsSortableField
    $order: Order
    $projectRef: String
    $archived: Boolean
    $brandRef: String
    $limit: Int
    $filter: BoardFilterInput
  ) {
    Boards(
      sort: $sort
      order: $order
      projectRef: $projectRef
      archived: $archived
      brandRef: $brandRef
      limit: $limit
      filter: $filter
    ) {
      id
      name
      slug
      projectRef
      archived
      itemsCount
      covers
      coverUrl
      hasCustomCover
      publicRef
      permission
      type
      showOwnerDetails
      distributeToReps
      itemsPaginated {
        items {
          id
          name
          imageUrl
          product {
            categories
            url
            _id
            country_permission
            entity_id
            family_id
            image_scale_factor
            indoor_outdoor_use
            is_collection
            is_new
            is_orderable
            is_primary
            just_added
            is_digital
            light_reflectance_value
            manufacturer
            manufacturer_alias
            manufacturer_sku
            ss_item_type
            status
          }
        }
      }
    }
  }
`;
p`
  query BoardsQueryWithFilters(
    $sort: BoardsSortableField
    $order: Order
    $projectRef: String
    $archived: Boolean
    $filter: BoardFilterInput
  ) {
    Boards(
      sort: $sort
      order: $order
      projectRef: $projectRef
      archived: $archived
      filter: $filter
    ) {
      id
      name
      itemsPaginated {
        items {
          id
          product {
            entity_id
          }
        }
      }
    }
  }
`;
p`
  query BoardUsersQuery($boardId: UUID!) {
    BoardUsers(boardId: $boardId) {
      id
      userRef
      firstName
      lastName
      email
      type
      unregisteredEmail
      isEditable
      source
    }
  }
`;
p`
  query ConsideringSampledBoardItemsQuery(
    $boardId: UUID!
    $brands: [String!]!
  ) {
    ConsideringSampledBoardItems(boardId: $boardId, brands: $brands) {
      id
      name
      imageUrl
      status
      product {
        _id
        entity_id
        manufacturer
        categories
        taxonomy
        taxonomy_l2
        taxonomy_l3
        taxonomy_l4
        color
      }
    }
  }
`;
p`
  query ConsideringSampledBoardQuery(
    $from: Int!
    $to: Int!
    $projectCreatedBefore: Int!
    $lastCheckedBefore: Int!
    $sampledBrandsLimit: Int
    $sampledBrandsFilter: SampledBrandFilterInput
  ) {
    ConsideringSampledBoard(
      from: $from
      to: $to
      projectCreatedBefore: $projectCreatedBefore
      lastCheckedBefore: $lastCheckedBefore
    ) {
      id
      projectRef
      sampledBrands(limit: $sampledBrandsLimit, filter: $sampledBrandsFilter) {
        name
      }
    }
  }
`;
p`
  query ConsideringSampledBoardQuery($from: Int!, $to: Int!) {
    ConsideringSampledBoards(from: $from, to: $to) {
      checkedEligible {
        id
        projectRef
      }
      uncheckedEligible {
        id
        projectRef
      }
      nonEligible {
        id
        projectRef
      }
    }
  }
`;
p`
  query ItemFilters($boardId: UUID!) {
    ItemFilters(boardId: $boardId) {
      statuses
      tags
      brands
    }
  }
`;
p`
  query ItemNotesQuery($itemId: UUID!) {
    ItemNotes(itemId: $itemId) {
      id
      isPublic
      note
      user {
        firstName
        lastName
        imageUrl
        userRef
      }
      updatedAt
      createdAt
    }
  }
`;
p`
  query ItemsCount($boardId: UUID!, $filter: ItemFilterInput) {
    ItemsCount(boardId: $boardId, filter: $filter)
  }
`;
const wn = p`
  fragment ProjectInfoFields on MaterialExportProjectInfo {
    title
    description
    phaseLabel
  }
`, In = p`
  fragment RowFields on MaterialExportRow {
    id
    name
    manufactureSku
    brand
    indoorOutdoorUse
    urlKey
    residentialCommercial
    color
    primaryColor
    collectionName
    contentTextile
    priceSign
    patternScale
    finishTreatment
    stainResistance
    durability
    carpetDyeMethod
    flammabilityTest
    thicknessPileHeightCarpet
    tags
    abrasionWearResistance
    acoustics
    ada
    classification
    emissions
    flammability
    slipResistance
    globalWarmingPotential
    width
    tileType
    contentTestAttribute
    construction
    categories
    colorNumber
    products
    paintProductType
    backingInput
    carpetFiberSystem
    csiNumber
    leed
    sustainabilityActionPlan
    organizationalCommitments
    multiAttributeCertification
    multiAttributeCertExpiration
    epd
    epdExpirationDate
    gwpUom
    lcaPlan
    postIndustrialRecycledContent
    postConsumerRecycledContent
    biobasedContent
    biobasedCertification
    manufacturingLocation
    eolOptions
    fscCertifiedWood
    vocEmissionsCertificate
    vocEmissionsTest
    vocTestExpirationDate
    ingredientDisclosure
    disclosureCertExpirationDate
    disclosureLevel
    ingredientsDisclosed75
    materialHealthCertifications
    materialHealthExpirationDate
    chemicalsOfConcern
    rohs
    electronicComponents
    gpsEligible
    status
    image
    sku
    associatedProductBrand
    associatedProductName
    circularEconomy
    climateHealth
    ecosystemHealth
    humanHealth
    socialHealthEquity
  }
`;
p`
  query MaterialExportQuery($boardId: UUID!, $itemIds: [UUID!]) {
    MaterialExport(boardId: $boardId, itemIds: $itemIds) {
      projectInfo {
        ...ProjectInfoFields
      }
      rows {
        ...RowFields
      }
    }
  }
  ${wn}
  ${In}
`;
p`
  query PublicMaterialExportQuery($token: String!, $itemIds: [UUID!]) {
    PublicMaterialExport(token: $token, itemIds: $itemIds) {
      projectInfo {
        ...ProjectInfoFields
      }
      rows {
        ...RowFields
      }
    }
  }
  ${wn}
  ${In}
`;
p`
  query MaterialExportTemplatesQuery {
    MaterialExportTemplates {
      id
      name
      type
      items {
        key
        isActive
        position
      }
    }
  }
`;
p`
  query MoodboardComments($threadId: UUID!) {
    MoodboardComments(threadId: $threadId) {
      id
      comment
      createdAt
      updatedAt
      user {
        userRef
        firstName
        lastName
        imageUrl
      }
    }
  }
`;
p`
  query MoodboardDetailsQuery($id: UUID!) {
    Moodboard(id: $id) {
      id
      name
      payload
    }
  }
`;
p`
  query PinterestPinsOnBoard(
    $accessToken: String!
    $boardID: String!
    $params: PinterestListParams
  ) {
    PinterestPinsOnBoard(
      accessToken: $accessToken
      boardID: $boardID
      params: $params
    ) {
      bookmark
      items {
        id
        title
        media
      }
    }
  }
`;
p`
  query PinterestBoards($accessToken: String!, $params: PinterestListParams) {
    PinterestBoards(accessToken: $accessToken, params: $params) {
      bookmark
      items {
        id
        name
        pinCount
        media
        owner {
          username
        }
      }
    }
  }
`;
p`
  query ProjectBoardsItemsQuery($filter: BoardFilterInput, $limit: Int) {
    Boards(filter: $filter, limit: $limit) {
      id
      projectRef
      slug
      sampledBrandsSummary {
        total
        specified
        excluded
        considering
      }
    }
  }
`;
const cd = p`
  query ProjectBoardsQuery($filter: BoardFilterInput, $limit: Int) {
    Boards(filter: $filter, limit: $limit) {
      id
      projectRef
    }
  }
`;
function dd(t) {
  return { ...wt(
    cd,
    t
  ) };
}
p`
  query ProjectBoardsQuery(
    $filter: BoardFilterInput
    $limit: Int
    $sampledBrandsLimit: Int
    $sampledBrandsFilter: SampledBrandFilterInput
  ) {
    Boards(filter: $filter, limit: $limit) {
      id
      projectRef
      slug
      sampledBrands(limit: $sampledBrandsLimit, filter: $sampledBrandsFilter) {
        status
        name
        logo
      }
    }
  }
`;
p`
  query SampledBrandsBoardQuery($slug: String!) {
    Board(slug: $slug) {
      id
      sampledBrands {
        name
        logo
        status
      }
    }
  }
`;
p`
  query UserTagsQuery {
    Tags {
      id
      name
    }
  }
`;
p`
  subscription WatchBoardSummary($boardId: UUID!) {
    watchBoardSummary(boardId: $boardId) {
      boardId
      itemNotes {
        itemID
        hasNewNotes
        notesCount
      }
    }
  }
`;
p`
  subscription ItemNotesSubscribe($itemId: UUID!) {
    watchItemNotes(itemId: $itemId) {
      type
      note {
        id
        isPublic
        note
        user {
          firstName
          lastName
          imageUrl
          userRef
        }
        updatedAt
        createdAt
      }
    }
  }
`;
p`
  subscription MoodboardCommentsSubscription(
    $moodboardId: UUID!
    $threadId: UUID!
  ) {
    watchMoodboardComments(moodboardId: $moodboardId, threadId: $threadId) {
      type
      comment {
        id
        comment
        createdAt
        updatedAt
        user {
          userRef
          firstName
          lastName
          imageUrl
        }
      }
    }
  }
`;
p`
  subscription MoodboardSummarySubscription($moodboardId: UUID!) {
    watchMoodboardSummary(moodboardId: $moodboardId) {
      comments {
        commentsCount
        threadId
        lastComment {
          id
          comment
          createdAt
          updatedAt
          user {
            userRef
            firstName
            lastName
            imageUrl
          }
        }
      }
    }
  }
`;
const kn = "boards.accessToken", Sn = (t) => {
  const e = t.split(".").pop() || "";
  return JSON.parse(atob(e))?.expiresAt || "";
}, ld = (t) => {
  const e = Sn(t), r = (/* @__PURE__ */ new Date()).toISOString();
  return new Date(e) < new Date(r);
}, ud = (t) => {
  try {
    const e = Sn(t);
    let r = 0;
    if (e) {
      const n = (/* @__PURE__ */ new Date()).toISOString();
      r = Gr(e, new Date(n));
    }
    return r < 5;
  } catch {
    return !0;
  }
};
function Ht(t, e) {
  ce.setItem(
    kn,
    JSON.stringify({
      [e]: t
    })
  );
}
const md = () => ce.getItem(Er) ? JSON.parse(ce.getItem(Er))?.customer?.signin_token : "";
function pd() {
  try {
    return JSON.parse(ce.getItem(kn) ?? "{}");
  } catch {
    return {};
  }
}
const jr = "private-content-loaded", $n = async (t) => {
  let e = md();
  return e || (e = await new Promise((r) => {
    const n = (i) => {
      const a = i;
      window.removeEventListener(jr, n);
      const o = a.detail.data;
      r(o.customer.signin_token);
    };
    window.addEventListener(jr, n);
  })), fetch(t, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      query: `
        query Auth($exToken: String!) {
          Auth(exToken: $exToken) {
            token
          }
        }
      `,
      variables: {
        exToken: e
      }
    })
  });
}, fd = async (t, e) => {
  try {
    const i = (await (await $n(t)).json()).data.Auth?.token || "";
    return Ht(i, e), i;
  } catch (r) {
    return console.error(r), "";
  }
}, hd = (t, e) => {
  $n(t).then(
    (r) => {
      r.json().then((n) => {
        const i = n.data.Auth?.token || "";
        Ht(i, e);
      });
    },
    (r) => {
      console.error(r), Ht("", e);
    }
  );
}, gd = () => {
  const t = window.location.hostname;
  return Rr[t] ?? Rr.default;
}, yd = `${gd()}/api/v1/query`, vd = "initialize-conversion-modal", Pn = [
  Q.TIER_1_GROUP_ID,
  Q.TIER_2_GROUP_ID
];
function bd({
  projectId: t,
  skip: e = !1
}) {
  const { customer: r } = Ae(), n = ie(() => e || !PROJECT_CONFIG.conversionModal.enabled || !r || !Pn.includes(r.groupId), [e, r]), { data: i, loading: a } = dd({
    variables: {
      filter: {
        type: vn.Sampled
      },
      limit: 1e3
    },
    skip: n
  }), o = ie(() => n || a ? !1 : i?.Boards?.some((c) => c.projectRef === t) ?? !1, [n, a, i, t]);
  return {
    loading: a && !n,
    showProjectSpecButton: o
  };
}
function _d({
  customer: t,
  projectId: e
}) {
  if (!PROJECT_CONFIG.conversionModal.enabled)
    return;
  const r = t?.groupId;
  r && Pn.includes(r) && window.dispatchEvent(
    new CustomEvent(vd, {
      detail: { projectId: e }
    })
  );
}
function Cd({
  loading: t,
  title: e,
  onClick: r,
  ...n
}) {
  const { t: i } = W();
  if (t)
    return /* @__PURE__ */ s(
      Ee,
      {
        variant: "rounded",
        className: "rounded-full",
        width: 114,
        height: 34
      }
    );
  const a = i(e || "Spec’d Items");
  return /* @__PURE__ */ s(
    it,
    {
      color: "primary",
      size: "medium",
      variant: "contained",
      className: "w-fit truncate inline-block",
      title: a,
      onClick: r,
      ...n,
      children: a
    }
  );
}
function xd({
  isOpen: t,
  project: e,
  analyticsProps: r,
  onSelect: n,
  onEditProject: i,
  onClose: a
}) {
  const { t: o } = W(), { customer: c } = Ae(), { projectListItem: l, projectListItemDetails: d, projectListSpecButton: u } = r, { showProjectSpecButton: f, loading: b } = bd({
    projectId: e.externalId.toString(),
    skip: !t
  });
  function C() {
    n(e.externalId, e.id);
  }
  function j(ee) {
    ee.stopPropagation(), i(e.id);
  }
  function M(ee) {
    ee.stopPropagation(), _d({ projectId: e.externalId, customer: c }), a?.();
  }
  const A = /* @__PURE__ */ s("div", { className: "w-8 h-8 flex-shrink-0 flex items-center justify-center", children: e.isCurrent ? /* @__PURE__ */ s(Oa, {}) : /* @__PURE__ */ s("div", { className: "w-8 h-8 rounded-2xl bg-[#F5F5F7] inverted" }) }), B = Pr[e.status] ?? Pr.ARCHIVED, O = f ? /* @__PURE__ */ s(
    Cd,
    {
      loading: b,
      onClick: M,
      sx: Tr,
      ...u
    }
  ) : null, q = o("See details");
  return /* @__PURE__ */ s(Ur, { className: "p-0 project-line-item", ...l, children: /* @__PURE__ */ w(
    Lr,
    {
      className: "justify-between py-4 w-full max-w-full",
      onClick: C,
      children: [
        /* @__PURE__ */ w("div", { className: "flex flex-col gap-2", children: [
          /* @__PURE__ */ s(
            F,
            {
              className: "text-[13px] leading-[20px] font-semibold truncate overflow-hidden whitespace-nowrap max-w-[300px] inline-block",
              title: e.title,
              children: e.title
            }
          ),
          /* @__PURE__ */ w("div", { className: "flex flex-col gap-1", children: [
            /* @__PURE__ */ s(
              Ai,
              {
                label: /* @__PURE__ */ s(F, { variant: "caption3", fontWeight: 600, children: o(e.statusLabel) }),
                size: "small",
                sx: {
                  background: B ? `${B}!important` : "inherit",
                  color: "white",
                  width: "fit-content",
                  height: "16px",
                  textTransform: "uppercase"
                }
              }
            ),
            /* @__PURE__ */ s(F, { variant: "body2", color: "textSecondary", children: o(e.phase?.label ?? "") })
          ] }),
          /* @__PURE__ */ w("div", { className: "flex flex-row gap-1", children: [
            /* @__PURE__ */ s(
              it,
              {
                color: "secondary",
                size: "medium",
                variant: "contained",
                className: "inverted w-fit truncate inline-block",
                sx: Tr,
                title: q,
                onClick: j,
                ...d,
                children: q
              }
            ),
            O
          ] })
        ] }),
        A
      ]
    }
  ) });
}
const Tr = {
  maxWidth: "140px"
};
function En({
  isSidebarOpen: t = !1,
  withIcon: e = !0,
  size: r = "medium",
  onClick: n
}) {
  const { t: i } = W(), { onCreate: a } = Qo();
  function o() {
    n?.(), a();
  }
  return /* @__PURE__ */ w(
    it,
    {
      variant: "contained",
      color: "primary",
      className: `w-full my-2 gap-2  flex flex-row overflow-hidden whitespace-nowrap transition-all duration-300 ${t ? "justify-center px-4" : "justify-start px-2"}`,
      size: r,
      onClick: o,
      children: [
        e ? /* @__PURE__ */ s("div", { className: "flex-grow-1", children: /* @__PURE__ */ s(Aa, {}) }) : null,
        /* @__PURE__ */ s("span", { className: "overflow-hidden whitespace-nowrap", children: /* @__PURE__ */ s(F, { variant: "caption", children: i("New project") }) })
      ]
    }
  );
}
function Rn({ title: t, description: e, icon: r }) {
  return /* @__PURE__ */ s("div", { className: "mx-auto h-max", children: /* @__PURE__ */ w("div", { className: "flex flex-col items-center justify-center text-center p-4 gap-6", children: [
    r,
    /* @__PURE__ */ s(F, { variant: "title3", children: t }),
    /* @__PURE__ */ s(F, { variant: "body1", color: "text.secondary", children: e }),
    /* @__PURE__ */ s(En, { isSidebarOpen: !0 })
  ] }) });
}
function wd() {
  const { t } = W();
  return /* @__PURE__ */ s(
    Rn,
    {
      title: t("No projects yet? Let's create one!"),
      description: t(
        'Start organizing your design ideas, materials, and specs. Create your first project by clicking "New Project"'
      ),
      icon: /* @__PURE__ */ s(Ua, {})
    }
  );
}
function Id() {
  const { t } = W();
  return /* @__PURE__ */ s(
    Rn,
    {
      title: t("We didn't find any matching projects"),
      description: t(
        "Try adjusting your search / filter criteria or create a new project."
      ),
      icon: /* @__PURE__ */ s(La, {})
    }
  );
}
function kd({
  projectsLoading: t,
  searchValue: e,
  projects: r,
  projectsMap: n,
  onClose: i,
  onCurrentProjectChange: a,
  isOpen: o,
  projectLineItemAnalytics: c
}) {
  const { isProjectDataComplete: l } = hn();
  function d(C, j) {
    const M = n[j];
    if (!l(M)) {
      rr({
        projectId: Number(C),
        successCallback: () => {
          a(C);
        }
      });
      return;
    }
    a(C);
  }
  const { onEdit: u } = Wc();
  if (!t && r.length === 0 && !e)
    return /* @__PURE__ */ s(wd, {});
  if (r.length === 0)
    return /* @__PURE__ */ s(Id, {});
  function f(C, j) {
    d(C.toString(), j);
  }
  function b(C) {
    const j = n[C];
    !j || !j.externalId || (i?.(), u(j.externalId));
  }
  return /* @__PURE__ */ s(
    "div",
    {
      className: "overflow-y-auto max-h-[50vh] scrollbar-hide",
      style: { maxHeight: "50vh" },
      children: r.map((C) => /* @__PURE__ */ s(
        xd,
        {
          project: C,
          onEditProject: b,
          onSelect: f,
          onClose: i,
          isOpen: o,
          analyticsProps: c
        },
        C.id
      ))
    }
  );
}
const Sd = 3;
function $d() {
  return /* @__PURE__ */ s("div", { className: "flex flex-col", children: go(Sd, (t) => /* @__PURE__ */ s(Ur, { className: "p-0 project-line-item", children: /* @__PURE__ */ w(Lr, { className: "justify-between", children: [
    /* @__PURE__ */ w("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ s(Ee, { variant: "text", width: 280, height: 32 }),
      /* @__PURE__ */ w("div", { className: "flex flex-col gap-1", children: [
        /* @__PURE__ */ s(Ee, { variant: "rounded", width: 260, height: 32 }),
        /* @__PURE__ */ s(Ee, { variant: "text", width: 240, height: 32 })
      ] }),
      /* @__PURE__ */ s(Ee, { variant: "rounded", width: 140, height: 24 })
    ] }),
    /* @__PURE__ */ s(Ee, { variant: "circular", width: 32, height: 32 })
  ] }) }, t)) });
}
function Pd() {
  const t = ct();
  return { seeAllClickHandler: (r) => {
    if (window.location.pathname.split("/").pop() === "projects") {
      r?.();
      return;
    }
    window.location.href = `${t}/projects`;
  } };
}
function jn({
  currentProject: t,
  withActionButtons: e,
  isOpen: r,
  projectLineItemAnalytics: n,
  searchInputAnalytics: i,
  onClose: a,
  onCurrentProjectChange: o,
  containerClassName: c,
  buttonLocation: l = "below-search"
}) {
  const { t: d } = W(), {
    projectsViewModel: { projectsLoading: u, projects: f, projectsMap: b }
  } = Qc(t?.externalId?.toString() ?? null), { searchValue: C, searchChangeHandler: j } = vo(), { seeAllClickHandler: M } = Pd(), A = ie(() => f.filter(
    (q) => q.title.toLowerCase().includes(C.toLowerCase())
  ), [f, C]);
  if (u)
    return /* @__PURE__ */ s($d, {});
  function B() {
    M(a);
  }
  const O = e ? /* @__PURE__ */ w("div", { className: "flex flex-row gap-2 items-center", children: [
    /* @__PURE__ */ s("div", { className: "max-w-fit", children: /* @__PURE__ */ s(En, { size: "small", withIcon: !1 }) }),
    /* @__PURE__ */ s(
      it,
      {
        variant: "contained",
        color: "primary",
        size: "small",
        sx: { minWidth: "min-content" },
        className: "px-2",
        onClick: B,
        children: /* @__PURE__ */ s(F, { variant: "caption", children: d("All projects") })
      }
    )
  ] }) : null;
  return /* @__PURE__ */ w("div", { children: [
    /* @__PURE__ */ w(
      "div",
      {
        className: `${e ? "flex flex-col gap-2 py-4 pt-2" : "p-4 pt-2"} ${c}`,
        children: [
          l === "above-search" ? O : null,
          /* @__PURE__ */ s(
            Yc,
            {
              search: C,
              onChange: j,
              analytics: i
            }
          ),
          l === "below-search" ? O : null
        ]
      }
    ),
    /* @__PURE__ */ s(
      kd,
      {
        projects: A,
        projectsMap: b,
        projectsLoading: u,
        searchValue: C,
        onClose: a,
        onCurrentProjectChange: o,
        isOpen: r,
        projectLineItemAnalytics: n
      }
    )
  ] });
}
function Ed({
  isOpen: t,
  closeHandler: e,
  currentProject: r,
  setCurrentProjectId: n,
  projectLineItemAnalytics: i,
  searchInputAnalytics: a
}) {
  const { t: o } = W();
  return /* @__PURE__ */ w(
    Nr,
    {
      open: t,
      onClose: e,
      anchor: "bottom",
      PaperProps: {
        className: "rounded-t-[20px] flex flex-col gap-2"
      },
      children: [
        /* @__PURE__ */ s(Kr, { title: o("Choose project"), onClose: e }),
        /* @__PURE__ */ s("div", { className: "px-4 pb-4", children: /* @__PURE__ */ s(
          jn,
          {
            currentProject: r,
            withActionButtons: !0,
            onClose: e,
            onCurrentProjectChange: n,
            isOpen: t,
            projectLineItemAnalytics: i,
            searchInputAnalytics: a
          }
        ) })
      ]
    }
  );
}
function Rd({
  isOpen: t,
  anchorEl: e,
  onClose: r,
  currentProject: n,
  onCurrentProjectChange: i
}) {
  const { t: a } = W(), { isMobile: o } = Qt(), c = qe({
    element: Ge.searchInput
  }), l = qe({
    element: Ge.projectListItem
  }), d = qe({
    element: Ge.projectListItemDetails
  }), u = qe({
    element: Ge.projectListSpecButton
  }), f = {
    projectListItem: l,
    projectListItemDetails: d,
    projectListSpecButton: u
  };
  return o ? /* @__PURE__ */ s(
    Ed,
    {
      isOpen: t,
      closeHandler: r,
      currentProject: n,
      setCurrentProjectId: i,
      searchInputAnalytics: {
        projectsSearchListInput: c
      },
      projectLineItemAnalytics: f
    }
  ) : /* @__PURE__ */ w(
    Fr,
    {
      id: "project-section-menu",
      anchorEl: e,
      open: t,
      transformOrigin: Td,
      anchorOrigin: jd,
      PaperProps: Md,
      onClose: r,
      children: [
        /* @__PURE__ */ s("h2", { className: "text-[20px] font-semibold leading-[32px]", children: a("Choose project") }),
        /* @__PURE__ */ s(
          jn,
          {
            withActionButtons: !0,
            containerClassName: "px-0",
            currentProject: n,
            onCurrentProjectChange: i,
            isOpen: t,
            searchInputAnalytics: {
              projectsSearchListInput: c
            },
            projectLineItemAnalytics: f,
            buttonLocation: "above-search"
          }
        )
      ]
    }
  );
}
const jd = {
  horizontal: "right",
  vertical: "bottom"
}, Td = {
  horizontal: "right",
  vertical: "top"
}, Md = {
  sx: {
    width: "388px",
    borderRadius: "12px",
    padding: "12px"
  }
};
function Od() {
  const { anchorEl: t, open: e, onOpen: r, onClose: n } = zr(), { currentProject: i, setCurrentProjectId: a } = qc();
  function o(c) {
    a(c), n();
  }
  return /* @__PURE__ */ w(Gt, { children: [
    /* @__PURE__ */ s(
      qo,
      {
        isOpen: e,
        onOpen: r,
        currentProject: i
      }
    ),
    /* @__PURE__ */ s(
      Rd,
      {
        isOpen: e,
        anchorEl: t,
        onClose: n,
        currentProject: i,
        onCurrentProjectChange: o
      }
    )
  ] });
}
const Nd = Vr.create({
  withCredentials: !0,
  headers: {
    "X-Requested-With": "XMLHttpRequest"
  }
}), Dd = () => {
  const [t, e] = te(
    null
  ), [r, n] = te(!0), [i, a] = te(null);
  return nt(() => {
    (async () => {
      try {
        const c = await Nd.get(
          "/rest/V1/m-select/configuration"
        );
        e(c.data.data), n(!1);
      } catch (c) {
        a(c), n(!1);
      }
    })();
  }, []), { data: t, isLoading: r, error: i };
}, Bd = () => {
  const { data: t } = Dd();
  return {
    loyaltyProgramEnabled: ie(() => t?.is_loyalty_program_enabled && t?.is_customer_eligible, [t])
  };
};
function ye({
  title: t,
  label: e,
  icon: r,
  href: n,
  target: i,
  onClick: a
}) {
  return /* @__PURE__ */ w(
    Ui,
    {
      href: n,
      target: i,
      component: "a",
      className: "gap-3 p-2 px-4",
      onClick: a,
      children: [
        /* @__PURE__ */ s(Li, { className: "flex justify-center", color: "text.primary", children: /* @__PURE__ */ s(F, { color: "text.primary", children: r }) }),
        /* @__PURE__ */ w("span", { className: "flex flex-col truncate", children: [
          /* @__PURE__ */ s(F, { variant: "caption", noWrap: !0, children: t }),
          e ? /* @__PURE__ */ s(
            F,
            {
              variant: "caption",
              className: "text-[12px] leading-[20px] text-[#707075]",
              noWrap: !0,
              children: e
            }
          ) : null
        ] })
      ]
    }
  );
}
function Ad({
  avatar: t,
  firstName: e,
  lastName: r,
  company: n,
  membership: i
}) {
  const a = Yt(e, r), o = `${e} ${r}`;
  return /* @__PURE__ */ w("div", { className: "flex flex-row gap-4 p-4", children: [
    /* @__PURE__ */ s(Xt, { displayName: a, avatar: t, size: "medium" }),
    /* @__PURE__ */ w("div", { className: "flex flex-col gap-1 text-left truncate", children: [
      /* @__PURE__ */ s(
        F,
        {
          variant: "body1",
          color: "primary.main",
          fontWeight: "600",
          noWrap: !0,
          title: o,
          children: o
        }
      ),
      /* @__PURE__ */ w("div", { className: "flex flex-col text-left truncate", children: [
        /* @__PURE__ */ s(F, { variant: "caption", color: "#707075", title: n, noWrap: !0, children: n }),
        /* @__PURE__ */ s(
          F,
          {
            variant: "caption",
            color: "#707075",
            title: i,
            noWrap: !0,
            children: i
          }
        )
      ] })
    ] })
  ] });
}
function Tn() {
  const { t } = W(), { customer: e, isLoading: r } = Ae(), n = ie(() => {
    function i(l) {
      if (!l)
        return "";
      switch (l) {
        case Q.TIER_1_GROUP_ID:
        case Q.TIER_2_GROUP_ID:
        case Q.TIER_10_GROUP_ID:
          return t("Professional Member");
        case Q.TIER_3_GROUP_ID:
        case Q.TIER_7_GROUP_ID:
          return t("Digital Member");
        case Q.TIER_9_GROUP_ID:
          return t("Education member");
        case Q.TIER_99_GROUP_ID:
          return t("Student");
        case Q.TIER_13_GROUP_ID:
          return t("Rep");
        default:
          return "";
      }
    }
    const a = e?.hasAssociatedBrands || !1, o = !!(e?.groupId && e?.groupId !== Q.TIER_7_GROUP_ID), c = !!(e?.groupId && (e?.groupId === Q.TIER_1_GROUP_ID || e?.groupId === Q.TIER_2_GROUP_ID));
    return {
      firstName: e?.firstname ?? "",
      lastName: e?.lastname ?? "",
      email: e?.email ?? "",
      address: e?.defaultAddress?.address ?? "",
      company: e?.company_name ?? "",
      membership: i(e?.groupId) ?? "",
      avatar: e?.profileImage ?? "",
      selectedAddressId: e?.defaultAddress?.id ?? "",
      showBrandRepSection: a,
      showOrders: o,
      showSampledItems: c,
      mSelectPoints: e?.loyalty_points ?? 0
    };
  }, [
    e?.company_name,
    e?.defaultAddress?.address,
    e?.defaultAddress?.id,
    e?.email,
    e?.firstname,
    e?.groupId,
    e?.hasAssociatedBrands,
    e?.lastname,
    e?.profileImage,
    e?.loyalty_points,
    t
  ]);
  return {
    isLoading: r,
    user: n
  };
}
function Ud(t) {
  return new Intl.NumberFormat("en-US").format(Number(t));
}
const Ld = er === "EU";
function Mn({
  user: {
    firstName: t,
    lastName: e,
    email: r,
    address: n,
    mSelectPoints: i,
    avatar: a,
    company: o,
    membership: c,
    selectedAddressId: l
  },
  onClose: d
}) {
  const { t: u } = W(), { user: f } = Tn(), { loyaltyProgramEnabled: b } = Bd();
  function C() {
    d?.();
    const q = `${ct()}/customer/account`;
    window.location.href = q;
  }
  const j = Ri(() => {
    d?.();
    const q = `${ct()}/m-select`;
    window.location.href = q;
  }, [d]);
  function M() {
    d?.(), ds();
  }
  function A() {
    d?.(), window.dispatchEvent(
      new CustomEvent(Ho, {
        detail: {
          selectedAddressId: l,
          multiAddress: !1,
          fromCustomerMenu: !0
        }
      })
    );
  }
  const B = ct();
  return /* @__PURE__ */ w(Gt, { children: [
    /* @__PURE__ */ s(
      Ad,
      {
        avatar: a,
        firstName: t,
        lastName: e,
        company: o,
        membership: c
      }
    ),
    f.showBrandRepSection && /* @__PURE__ */ s(
      ye,
      {
        title: u("Brand settings"),
        icon: /* @__PURE__ */ s(Fa, {}),
        onClick: M
      }
    ),
    f.showOrders ? /* @__PURE__ */ s(
      ye,
      {
        title: u("Orders"),
        icon: /* @__PURE__ */ s(za, {}),
        href: `${B}${Fo}`
      }
    ) : null,
    f.showSampledItems ? /* @__PURE__ */ s(
      ye,
      {
        title: u("Sampled Items"),
        icon: /* @__PURE__ */ s(Ba, { size: 32 }),
        href: `${B}${Vo}`
      }
    ) : null,
    /* @__PURE__ */ s(
      ye,
      {
        title: u("Profile"),
        label: r,
        icon: /* @__PURE__ */ s(qa, {}),
        onClick: C
      }
    ),
    /* @__PURE__ */ s(
      ye,
      {
        title: u("Address Book"),
        label: n,
        icon: /* @__PURE__ */ s(Ha, {}),
        onClick: A
      }
    ),
    !!b && /* @__PURE__ */ s(
      ye,
      {
        title: u("Material Select"),
        label: `${Ud(i)} ${u("Points").toLowerCase()}`,
        icon: /* @__PURE__ */ s(Za, {}),
        onClick: j
      }
    ),
    /* @__PURE__ */ s(
      ye,
      {
        title: u("Refer a friend"),
        label: u("Earn rewards with each referral"),
        icon: /* @__PURE__ */ s(Wa, {}),
        href: Lo,
        target: "_blank"
      }
    ),
    !Ld && /* @__PURE__ */ s(
      ye,
      {
        title: u("Sample returns"),
        label: u("Return your unneeded samples for reuse"),
        icon: /* @__PURE__ */ s(Ta, {}),
        href: `${B}${Zo}`
      }
    ),
    /* @__PURE__ */ s(Ar, {}),
    /* @__PURE__ */ s("div", { className: "flex flex-col px-4 mt-4 pb-2", children: /* @__PURE__ */ s(it, { component: "a", href: `${B}${zo}`, children: u("Sign out") }) })
  ] });
}
function Fd({
  user: t,
  isLoading: e = !1
}) {
  const { t: r } = W(), { handleOpen: n, handleClose: i } = qr(), { firstName: a, lastName: o, avatar: c } = t, l = Yt(a, o);
  function d() {
    n({
      title: r("User profile"),
      content: /* @__PURE__ */ s(Mn, { user: t, onClose: i })
    });
  }
  return /* @__PURE__ */ s(
    be,
    {
      size: "small",
      "aria-haspopup": "true",
      disabled: e,
      onClick: d,
      children: /* @__PURE__ */ s(Xt, { displayName: l, avatar: c, size: "small" })
    }
  );
}
function Vd({
  isOpen: t,
  anchorEl: e,
  onClose: r,
  ...n
}) {
  return /* @__PURE__ */ s(
    Fr,
    {
      id: "user-profile-menu",
      anchorEl: e,
      open: t,
      transformOrigin: zd,
      anchorOrigin: Zd,
      PaperProps: Hd,
      onClose: r,
      onClick: r,
      keepMounted: !0,
      children: /* @__PURE__ */ s(Mn, { ...n })
    }
  );
}
const Zd = {
  horizontal: "right",
  vertical: "bottom"
}, zd = {
  horizontal: "right",
  vertical: "top"
}, Hd = {
  sx: {
    width: "336px",
    borderRadius: "12px"
  }
};
function qd({
  user: { firstName: t, lastName: e, avatar: r, company: n },
  isOpen: i,
  isLoading: a = !1,
  onOpen: o
}) {
  const c = Yt(t, e), l = `${t} ${e}`, d = l.length > ot ? `${l.slice(0, ot)}...` : l, u = n.length > ot ? `${n.slice(0, ot)}...` : n;
  return /* @__PURE__ */ s(
    be,
    {
      size: "small",
      "aria-haspopup": "true",
      "aria-controls": i ? "user-menu" : void 0,
      "aria-expanded": i ? "true" : void 0,
      disabled: a,
      onClick: o,
      className: "px-0",
      children: /* @__PURE__ */ w("div", { className: "flex flex-row gap-3 items-center h-12 px-2 pr-4 border border-[#F2F2F2] rounded-full hover:bg-[#F5F5F7] hover:border-[#F5F5F7]", children: [
        /* @__PURE__ */ s(Xt, { displayName: c, avatar: r, size: "small" }),
        /* @__PURE__ */ w("div", { className: "flex flex-col text-left truncate", children: [
          /* @__PURE__ */ s(
            F,
            {
              variant: "caption",
              color: "primary.main",
              noWrap: !0,
              title: d,
              children: d
            }
          ),
          /* @__PURE__ */ s(
            F,
            {
              variant: "caption3",
              color: "#707075",
              fontWeight: "600",
              title: n,
              noWrap: !0,
              children: u.toUpperCase()
            }
          )
        ] }),
        /* @__PURE__ */ s("div", { className: i ? "rotate-180" : "", children: /* @__PURE__ */ s(Zr, {}) })
      ] })
    }
  );
}
function Wd({
  user: t,
  isLoading: e = !1
}) {
  const { anchorEl: r, open: n, onOpen: i, onClose: a } = zr();
  return /* @__PURE__ */ w(Gt, { children: [
    /* @__PURE__ */ s(
      qd,
      {
        isOpen: n,
        isLoading: e,
        user: t,
        onOpen: i
      }
    ),
    /* @__PURE__ */ s(
      Vd,
      {
        isOpen: n,
        anchorEl: r,
        user: t,
        onClose: a
      }
    )
  ] });
}
function Gd() {
  const { isTablet: t, isMobile: e, isSmallDesktop: r } = Qt(), { isLoading: n, user: i } = Tn();
  return e || t || r ? /* @__PURE__ */ s(Fd, { isLoading: n, user: i }) : /* @__PURE__ */ s(Wd, { isLoading: n, user: i });
}
function Kd() {
  return /* @__PURE__ */ w("div", { className: "flex flex-row gap-1", children: [
    /* @__PURE__ */ s(Od, {}),
    /* @__PURE__ */ s(Gd, {})
  ] });
}
function Qd(t) {
  if (typeof t != "object" || t === null)
    return !1;
  const e = Object.getPrototypeOf(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in t) && !(Symbol.iterator in t);
}
function Jd(t, e, r = "") {
  if (!arguments.length) throw new TypeError("Argument 1 `value` is required.");
  if (typeof e != "function")
    throw new TypeError("Argument 2 `isExtractable` must be a function.");
  if (typeof r != "string")
    throw new TypeError("Argument 3 `path` must be a string.");
  const n = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
  function a(o, c, l) {
    if (e(o)) {
      const f = i.get(o);
      return f ? f.push(c) : i.set(o, [c]), null;
    }
    const d = Array.isArray(o) || typeof FileList < "u" && o instanceof FileList, u = Qd(o);
    if (d || u) {
      let f = n.get(o);
      const b = !f;
      if (b && (f = d ? [] : (
        // Replicate if the plain object is an `Object` instance.
        o instanceof /** @type {any} */
        Object ? {} : /* @__PURE__ */ Object.create(null)
      ), n.set(
        o,
        /** @type {Clone} */
        f
      )), !l.has(o)) {
        const C = c ? `${c}.` : "", j = new Set(l).add(o);
        if (d) {
          let M = 0;
          for (const A of o) {
            const B = a(
              A,
              C + M++,
              j
            );
            b && f.push(B);
          }
        } else
          for (const M in o) {
            const A = a(
              o[M],
              C + M,
              j
            );
            b && (f[M] = A);
          }
      }
      return f;
    }
    return o;
  }
  return {
    clone: a(t, r, /* @__PURE__ */ new Set()),
    files: i
  };
}
function Yd(t, e, r) {
  "name" in r ? t.append(e, r, r.name) : t.append(e, r);
}
function Xd(t) {
  return typeof File < "u" && t instanceof File || typeof Blob < "u" && t instanceof Blob;
}
function el({
  uri: t = "/graphql",
  useGETForQueries: e,
  isExtractableFile: r = Xd,
  FormData: n,
  formDataAppendFile: i = Yd,
  print: a = ca,
  fetch: o,
  fetchOptions: c,
  credentials: l,
  headers: d,
  includeExtensions: u
} = {}) {
  const f = {
    http: { includeExtensions: u },
    options: c,
    credentials: l,
    headers: d
  };
  return new na((b) => {
    const C = (
      /**
       * @type {import("@apollo/client/core/types.js").DefaultContext & {
       *   clientAwareness?: {
       *     name?: string,
       *     version?: string,
       *   },
       * }}
       */
      b.getContext()
    ), {
      // Apollo Studio client awareness `name` and `version` can be configured
      // via `ApolloClient` constructor options:
      // https://www.apollographql.com/docs/graphos/metrics/client-awareness/#setup
      clientAwareness: { name: j, version: M } = {},
      headers: A
    } = C, B = {
      http: C.http,
      options: C.fetchOptions,
      credentials: C.credentials,
      headers: {
        // Client awareness headers can be overridden by context `headers`.
        ...j && { "apollographql-client-name": j },
        ...M && { "apollographql-client-version": M },
        ...A
      }
    }, { options: O, body: q } = sa(
      b,
      a,
      da,
      f,
      B
    ), { clone: ee, files: S } = Jd(q, r, "");
    let U = la(b, t);
    if (S.size) {
      O.headers && delete O.headers["content-type"];
      const R = n || FormData, L = new R();
      L.append("operations", ur(ee, "Payload"));
      const N = {};
      let z = 0;
      S.forEach((K) => {
        N[++z] = K;
      }), L.append("map", JSON.stringify(N)), z = 0, S.forEach((K, le) => {
        i(L, String(++z), le);
      }), O.body = L;
    } else if (e && // If the operation contains some mutations GET shouldn’t be used.
    !b.query.definitions.some(
      (R) => R.kind === "OperationDefinition" && R.operation === "mutation"
    ) && (O.method = "GET"), O.method === "GET") {
      const { newURI: R, parseError: L } = oa(U, q);
      if (L)
        return new mr((N) => {
          N.error(L);
        });
      U = R;
    } else O.body = ur(ee, "Payload");
    const { controller: h } = ia();
    typeof h != "boolean" && (O.signal && (O.signal.aborted ? (
      // Signal already aborted, so immediately abort.
      h.abort()
    ) : (
      // Signal not already aborted, so setup a listener to abort when it
      // does.
      O.signal.addEventListener(
        "abort",
        () => {
          h.abort();
        },
        {
          // Prevent a memory leak if the user configured abort controller
          // is long lasting, or controls multiple things.
          once: !0
        }
      )
    )), O.signal = h.signal);
    const P = o || fetch;
    return new mr((R) => {
      let L;
      return P(U, O).then((N) => (b.setContext({ response: N }), N)).then(aa(b)).then((N) => {
        R.next(N), R.complete();
      }).catch((N) => {
        L || (N.result && N.result.errors && N.result.data && R.next(N.result), R.error(N));
      }), () => {
        L = !0, typeof h != "boolean" && h.abort();
      };
    });
  });
}
const On = `${Qs()}/api/v1/query`, st = "apollo-client-cache", tl = es, rl = rd;
var Nn = /* @__PURE__ */ ((t) => (t.PROJECT = "projectOperations", t.BOARD = "boardOperations", t))(Nn || {});
const nl = {
  projectOperations: tl,
  boardOperations: rl
}, qt = {
  projectOperations: On,
  boardOperations: yd
};
function il(t) {
  const r = t?.query?.definitions.find(
    (i) => i.kind === "OperationDefinition"
  );
  return (
    // @ts-ignore ignoring due to tsc not being able to infer the type of operationDefinition in each application
    r?.selectionSet?.selections?.[0]?.kind === "Field" ? (
      // @ts-ignore ignoring due to tsc not being able to infer the type of operationDefinition in each application
      r.selectionSet.selections[0].name.value
    ) : void 0
  );
}
function Wt(t) {
  const e = il(t);
  return e ? Object.values(Nn).find(
    (r) => nl[r].includes(e)
  ) ?? null : null;
}
function al(t, e) {
  if (!e)
    return t;
  const r = Wt(e);
  return r ? qt[r] : t;
}
const ol = {
  projectOperations: {
    getAccessTokenFromStorage: Ws,
    createToken: Gs,
    refreshToken: Ks,
    shouldRefresh: Ls,
    isExpired: Us
  },
  boardOperations: {
    getAccessTokenFromStorage: pd,
    createToken: fd,
    refreshToken: hd,
    shouldRefresh: ud,
    isExpired: ld
  }
}, sl = () => (window[st] || (window[st] = new Zi()), window[st]);
function cl(t) {
  return new ua({
    link: t,
    cache: sl()
  });
}
function dl({ buildUri: t, defaultUri: e }) {
  const [r, n] = te(null), i = async (b, C) => {
    let j = null;
    if (C ? j = C : b && (j = Wt(b)), !j)
      return "";
    const M = ol[j];
    let A = M.getAccessTokenFromStorage();
    const B = await Zs();
    let O = A[B];
    return (!O || M.isExpired(O)) && (O = await M.createToken(
      t(e, b),
      B
    )), M.shouldRefresh(O) && M.refreshToken(t(e, b), B), `Bearer ${O}`;
  }, a = el({
    uri: (b) => t(e, b)
  }), o = lr(async (b, { headers: C }) => ({ headers: { ...C, "Accept-Language": qs() || "en" } })), c = Object.keys(qt).reduce(
    (b, C) => (b[C] = new ea(
      ta({
        url: qt[C],
        connectionParams: async () => ({
          Authorization: await i(
            void 0,
            C
          )
        }),
        retryAttempts: 5
      })
    ), b),
    {}
  ), l = (b) => c[Wt(b) || ""], d = lr(async (b, { headers: C }) => {
    if (!an())
      return C;
    const j = await i(b);
    return {
      headers: {
        ...C,
        authorization: j ?? ""
      }
    };
  }), u = new zi((b) => l(b).request(b)), f = Hi(
    ({ query: b }) => {
      const C = ra(b);
      return C.kind === "OperationDefinition" && C.operation === "subscription";
    },
    u,
    // Send subscription operations through the WebSocket
    d
    // Send queries/mutations through the HTTP link
  );
  return nt(() => {
    n(cl(qi([o, f, a])));
  }, []), {
    client: r,
    generateBearerToken: i
  };
}
function ll({ children: t }) {
  const { client: e } = dl({ buildUri: al, defaultUri: On });
  return e ? /* @__PURE__ */ s(Wi, { client: e, children: t }) : null;
}
const Mr = "navigation-top-bar";
function ul() {
  return Xa({
    resourcesToBackendCallback: yl,
    ns: [Mr],
    defaultNS: Mr
  });
}
const Dn = ul();
Dn.init();
const ml = {
  en: Bn,
  fr: fl,
  it: pl,
  es: gl,
  de: hl
};
function pl() {
  return Promise.resolve().then(() => _l);
}
function fl() {
  return Promise.resolve().then(() => xl);
}
function hl() {
  return Promise.resolve().then(() => Il);
}
function Bn() {
  return Promise.resolve().then(() => Sl);
}
function gl() {
  return Promise.resolve().then(() => Pl);
}
function yl(t) {
  return ml[t]() ?? Bn();
}
const vl = "Something went wrong. Please try again later.";
function tu() {
  return /* @__PURE__ */ s(ji, { children: /* @__PURE__ */ s(Ea, { children: /* @__PURE__ */ s(ll, { children: /* @__PURE__ */ s(Gc, { children: /* @__PURE__ */ s(jo, { fallbackMessage: vl, children: /* @__PURE__ */ s(Fi, { i18n: Dn, children: /* @__PURE__ */ s(Do, { children: /* @__PURE__ */ s(eo, { children: /* @__PURE__ */ w(cn, { children: [
    /* @__PURE__ */ s(Kd, {}),
    /* @__PURE__ */ s(To, {})
  ] }) }) }) }) }) }) }) }) });
}
const An = "Ordini", Un = "P", Ln = "Punti", Fn = "Profilo", Vn = "Rappresentante", Zn = "Cerca", zn = "Studente", bl = {
  "Active Project": "Progetto attivo",
  "Address Book": "Rubrica",
  "All projects": "Tutti i progetti",
  "Brand settings": "Impostazioni del marchio",
  "Choose project": "Scegliere il progetto",
  "Digital Member": "Membro digitale",
  "Earn rewards with each referral": "Ottieni un regalo per ogni referral",
  "Education member": "Membro educazione",
  "Material Select": "Selezione del materiale",
  "New project": "Nuovo progetto",
  Orders: An,
  P: Un,
  Points: Ln,
  "Professional Member": "Membro professionale",
  Profile: Fn,
  "Refer a friend": "Invita un amico",
  Rep: Vn,
  "Return your unneeded samples for reuse": "Restituisci i campioni inutilizzati per il riutilizzo",
  "Sample returns": "Restituzione campioni",
  "Sampled Items": "Campioni ordinati",
  Search: Zn,
  "See details": "Vedi dettagli",
  "Sign out": "Esci",
  "Spec’d Items": "Articoli specificati",
  Student: zn,
  "User profile": "Profilo utente"
}, _l = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Orders: An,
  P: Un,
  Points: Ln,
  Profile: Fn,
  Rep: Vn,
  Search: Zn,
  Student: zn,
  default: bl
}, Symbol.toStringTag, { value: "Module" })), Hn = "Commandes", qn = "P", Wn = "Points", Gn = "Profil", Kn = "Représentant", Qn = "Recherche", Jn = "Étudiant", Cl = {
  "Active Project": "Projet actif",
  "Address Book": "Carnet d'adresses",
  "All projects": "Tous les projets",
  "Brand settings": "Paramètres de la marque",
  "Choose project": "Choisir un projet",
  "Digital Member": "Membre numérique",
  "Earn rewards with each referral": "Gagnez des récompenses pour chaque parrainage",
  "Education member": "Membre éducation",
  "Material Select": "Sélection du matériau",
  "New project": "Nouveau projet",
  Orders: Hn,
  P: qn,
  Points: Wn,
  "Professional Member": "Membre professionnel",
  Profile: Gn,
  "Refer a friend": "Parrainez un ami",
  Rep: Kn,
  "Return your unneeded samples for reuse": "Retournez vos échantillons inutiles pour réutilisation",
  "Sample returns": "Retours d'échantillons",
  "Sampled Items": "Échantillons sélectionnés",
  Search: Qn,
  "See details": "Voir les détails",
  "Sign out": "Se déconnecter",
  "Spec’d Items": "Articles spécifiés",
  Student: Jn,
  "User profile": "Profil utilisateur"
}, xl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Orders: Hn,
  P: qn,
  Points: Wn,
  Profile: Gn,
  Rep: Kn,
  Search: Qn,
  Student: Jn,
  default: Cl
}, Symbol.toStringTag, { value: "Module" })), Yn = "Bestellungen", Xn = "P", ei = "Punkte", ti = "Profil", ri = "Vertreter", ni = "Suchen", ii = "Student", wl = {
  "Active Project": "Aktives Projekt",
  "Address Book": "Adressbuch",
  "All projects": "Alle Projekte",
  "Brand settings": "Markeneinstellungen",
  "Choose project": "Projekt auswählen",
  "Digital Member": "Digitales Member",
  "Earn rewards with each referral": "Erhalte Prämien mit jeder Empfehlung",
  "Education member": "Bildungs Member",
  "Material Select": "Material auswählen",
  "New project": "Neues Projekt",
  Orders: Yn,
  P: Xn,
  Points: ei,
  "Professional Member": "Professionelles Member",
  Profile: ti,
  "Refer a friend": "Freunden empfehlen",
  Rep: ri,
  "Return your unneeded samples for reuse": "Schicke deine übrigen Muster zur Weiterverwendung zurück",
  "Sample returns": "Muster-Rücksendung",
  "Sampled Items": "Bemusterte Artikel",
  Search: ni,
  "See details": "Details ansehen",
  "Sign out": "Abmelden",
  "Spec’d Items": "Spezifizierte Artikel",
  Student: ii,
  "User profile": "Benutzerprofil"
}, Il = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Orders: Yn,
  P: Xn,
  Points: ei,
  Profile: ti,
  Rep: ri,
  Search: ni,
  Student: ii,
  default: wl
}, Symbol.toStringTag, { value: "Module" })), ai = "", oi = "", si = "", ci = "", di = "", li = "", kl = {
  "Active Project": "",
  "Address Book": "",
  "Brand settings": "",
  "Choose project": "",
  "Digital Member": "",
  "Earn rewards with each referral": "",
  "Education member": "",
  "Material Select": "",
  Orders: ai,
  P: oi,
  Points: si,
  "Professional Member": "",
  Profile: ci,
  "Refer a friend": "",
  Rep: di,
  "Return your unneeded samples for reuse": "",
  "Sample returns": "",
  "Sampled Items": "",
  "Sign out": "",
  Student: li,
  "User profile": ""
}, Sl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Orders: ai,
  P: oi,
  Points: si,
  Profile: ci,
  Rep: di,
  Student: li,
  default: kl
}, Symbol.toStringTag, { value: "Module" })), ui = "Pedidos", mi = "P", pi = "Puntos", fi = "Perfil", hi = "Representante", gi = "Buscar", yi = "Estudiante", $l = {
  "Active Project": "Proyecto activo",
  "Address Book": "Libro de direcciones",
  "All projects": "Todos los proyectos",
  "Brand settings": "Configuración de la marca",
  "Choose project": "Elegir proyecto",
  "Digital Member": "Miembro digital",
  "Earn rewards with each referral": "Gana recompensas con cada recomendación",
  "Education member": "Miembro educación",
  "Material Select": "Selección de material",
  "New project": "Nuevo proyecto",
  Orders: ui,
  P: mi,
  Points: pi,
  "Professional Member": "Miembro profesional",
  Profile: fi,
  "Refer a friend": "Invita a un amigo",
  Rep: hi,
  "Return your unneeded samples for reuse": "Devuelve tus muestras no necesarias para su reutilización",
  "Sample returns": "Devolución de muestras",
  "Sampled Items": "Artículos pedidos",
  Search: gi,
  "See details": "Ver detalles",
  "Sign out": "Cerrar sesión",
  "Spec’d Items": "Artículos especificados",
  Student: yi,
  "User profile": "Perfil de usuario"
}, Pl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Orders: ui,
  P: mi,
  Points: pi,
  Profile: fi,
  Rep: hi,
  Search: gi,
  Student: yi,
  default: $l
}, Symbol.toStringTag, { value: "Module" }));
export {
  tu as NavigationTopBarApp
};
